import { jsx, jsxs, Fragment as Fragment$1 } from 'react/jsx-runtime';
import { useCallback, useEffect, Fragment, useState, useRef, useContext, Children, isValidElement, cloneElement, createContext, useMemo, forwardRef, useImperativeHandle } from 'react';
import styled, { css, keyframes, ThemeContext, useTheme, createGlobalStyle, ThemeProvider } from 'styled-components';
import { SearchResultSectionItemType, HeaderConsumer, HeaderStore } from '@devsbb/header-schema';
import { SonntagIcon, SectionHead, SonntagButtonV2, DropDown, ButtonV2, AccountMenu as AccountMenu$1, BottomSheet as BottomSheet$1, lightBaseTheme, darkBaseTheme } from '@getgrover/ui';
import { sendAnalyticsEvent } from '@devsbb/analytics-client';
import { CSSTransition } from 'react-transition-group';
import useOnClickOutside from 'use-onclickoutside';
import { useTranslation, initReactI18next } from 'react-i18next';
import { __rest, __awaiter, __assign } from 'tslib';
import i18n from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import Cookies from 'js-cookie';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$h =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$n = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$m = fails$n;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$m(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$l = fails$n;

var functionBindNative = !fails$l(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$f = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$f.bind(call$f) : function () {
  return call$f.apply(call$f, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$4 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var bind$2 = FunctionPrototype$2.bind;
var call$e = FunctionPrototype$2.call;
var uncurryThis$m = NATIVE_BIND$2 && bind$2.bind(call$e, call$e);

var functionUncurryThis = NATIVE_BIND$2 ? function (fn) {
  return fn && uncurryThis$m(fn);
} : function (fn) {
  return fn && function () {
    return call$e.apply(fn, arguments);
  };
};

var uncurryThis$l = functionUncurryThis;

var toString$b = uncurryThis$l({}.toString);
var stringSlice$5 = uncurryThis$l(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$5(toString$b(it), 8, -1);
};

var uncurryThis$k = functionUncurryThis;
var fails$k = fails$n;
var classof$7 = classofRaw$1;

var $Object$4 = Object;
var split = uncurryThis$k(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$k(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$7(it) == 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

var $TypeError$d = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$7 = function (it) {
  if (it == undefined) throw $TypeError$d("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$6 = requireObjectCoercible$7;

var toIndexedObject$5 = function (it) {
  return IndexedObject$2(requireObjectCoercible$6(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$j = function (argument) {
  return typeof argument == 'function';
};

var isCallable$i = isCallable$j;

var isObject$7 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$i(it);
};

var global$g = global$h;
var isCallable$h = isCallable$j;

var aFunction = function (argument) {
  return isCallable$h(argument) ? argument : undefined;
};

var getBuiltIn$6 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$g[namespace]) : global$g[namespace] && global$g[namespace][method];
};

var uncurryThis$j = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$j({}.isPrototypeOf);

var getBuiltIn$5 = getBuiltIn$6;

var engineUserAgent = getBuiltIn$5('navigator', 'userAgent') || '';

var global$f = global$h;
var userAgent$2 = engineUserAgent;

var process$1 = global$f.process;
var Deno = global$f.Deno;
var versions = process$1 && process$1.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$2) {
  match = userAgent$2.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$2.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es-x/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$j = fails$n;

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$j(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es-x/no-symbol -- required for testing */

var NATIVE_SYMBOL$2 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$4 = getBuiltIn$6;
var isCallable$g = isCallable$j;
var isPrototypeOf$4 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$4('Symbol');
  return isCallable$g($Symbol) && isPrototypeOf$4($Symbol.prototype, $Object$3(it));
};

var $String$3 = String;

var tryToString$5 = function (argument) {
  try {
    return $String$3(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$f = isCallable$j;
var tryToString$4 = tryToString$5;

var $TypeError$c = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$5 = function (argument) {
  if (isCallable$f(argument)) return argument;
  throw $TypeError$c(tryToString$4(argument) + ' is not a function');
};

var aCallable$4 = aCallable$5;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$5 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable$4(func);
};

var call$d = functionCall;
var isCallable$e = isCallable$j;
var isObject$6 = isObject$7;

var $TypeError$b = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$e(fn = input.toString) && !isObject$6(val = call$d(fn, input))) return val;
  if (isCallable$e(fn = input.valueOf) && !isObject$6(val = call$d(fn, input))) return val;
  if (pref !== 'string' && isCallable$e(fn = input.toString) && !isObject$6(val = call$d(fn, input))) return val;
  throw $TypeError$b("Can't convert object to primitive value");
};

var shared$4 = {exports: {}};

var global$e = global$h;

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$7 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$7(global$e, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$e[key] = value;
  } return value;
};

var global$d = global$h;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$d[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.23.5',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.23.5/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$5 = requireObjectCoercible$7;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$5 = function (argument) {
  return $Object$2(requireObjectCoercible$5(argument));
};

var uncurryThis$i = functionUncurryThis;
var toObject$4 = toObject$5;

var hasOwnProperty = uncurryThis$i({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$4(it), key);
};

var uncurryThis$h = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$a = uncurryThis$h(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$a(++id + postfix, 36);
};

var global$c = global$h;
var shared$3 = shared$4.exports;
var hasOwn$b = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$3('wks');
var Symbol$1 = global$c.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$g = function (name) {
  if (!hasOwn$b(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL$1 || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL$1 && hasOwn$b(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var call$c = functionCall;
var isObject$5 = isObject$7;
var isSymbol$1 = isSymbol$2;
var getMethod$4 = getMethod$5;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$f = wellKnownSymbol$g;

var $TypeError$a = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$f('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$5(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$4(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$c(exoticToPrim, input, pref);
    if (!isObject$5(result) || isSymbol$1(result)) return result;
    throw $TypeError$a("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$3 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$b = global$h;
var isObject$4 = isObject$7;

var document$1 = global$b.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$4(document$1) && isObject$4(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$c = descriptors;
var fails$i = fails$n;
var createElement = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$c && !fails$i(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$b = descriptors;
var call$b = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$3 = createPropertyDescriptor$4;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$2 = toPropertyKey$3;
var hasOwn$a = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$b ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$2(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$a(O, P)) return createPropertyDescriptor$3(!call$b(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$a = descriptors;
var fails$h = fails$n;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$a && fails$h(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$3 = isObject$7;

var $String$2 = String;
var $TypeError$9 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$e = function (argument) {
  if (isObject$3(argument)) return argument;
  throw $TypeError$9($String$2(argument) + ' is not an object');
};

var DESCRIPTORS$9 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$d = anObject$e;
var toPropertyKey$1 = toPropertyKey$3;

var $TypeError$8 = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$9 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$d(O);
  P = toPropertyKey$1(P);
  anObject$d(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$d(O);
  P = toPropertyKey$1(P);
  anObject$d(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$8('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$8 = descriptors;
var definePropertyModule$5 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$4;

var createNonEnumerableProperty$6 = DESCRIPTORS$8 ? function (object, key, value) {
  return definePropertyModule$5.f(object, key, createPropertyDescriptor$2(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$7 = descriptors;
var hasOwn$9 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$7 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$9(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$7 || (DESCRIPTORS$7 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$g = functionUncurryThis;
var isCallable$d = isCallable$j;
var store$1 = sharedStore;

var functionToString = uncurryThis$g(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$d(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var global$a = global$h;
var isCallable$c = isCallable$j;
var inspectSource$2 = inspectSource$3;

var WeakMap$1 = global$a.WeakMap;

var nativeWeakMap = isCallable$c(WeakMap$1) && /native code/.test(inspectSource$2(WeakMap$1));

var shared$2 = shared$4.exports;
var uid = uid$2;

var keys$1 = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys$1[key] || (keys$1[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$9 = global$h;
var uncurryThis$f = functionUncurryThis;
var isObject$2 = isObject$7;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$6;
var hasOwn$8 = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global$9.TypeError;
var WeakMap = global$9.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$2(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  var wmget = uncurryThis$f(store.get);
  var wmhas = uncurryThis$f(store.has);
  var wmset = uncurryThis$f(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$8(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$5(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$8(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$8(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var fails$g = fails$n;
var isCallable$b = isCallable$j;
var hasOwn$7 = hasOwnProperty_1;
var DESCRIPTORS$6 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$1 = inspectSource$3;
var InternalStateModule$1 = internalState;

var enforceInternalState$1 = InternalStateModule$1.enforce;
var getInternalState$2 = InternalStateModule$1.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS$6 && !fails$g(function () {
  return defineProperty$6(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$7(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$6) defineProperty$6(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$7(options, 'arity') && value.length !== options.arity) {
    defineProperty$6(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$7(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$6) defineProperty$6(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState$1(value);
  if (!hasOwn$7(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$b(this) && getInternalState$2(this).source || inspectSource$1(this);
}, 'toString');

var isCallable$a = isCallable$j;
var definePropertyModule$4 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$6 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$a(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$4.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$1 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$3 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$2 = toIntegerOrInfinity$3;

var max$1 = Math.max;
var min$2 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$2 = function (index, length) {
  var integer = toIntegerOrInfinity$2(index);
  return integer < 0 ? max$1(integer + length, 0) : min$2(integer, length);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$3;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$2 = function (argument) {
  return argument > 0 ? min$1(toIntegerOrInfinity$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$1 = toLength$2;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$5 = function (obj) {
  return toLength$1(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex$1 = toAbsoluteIndex$2;
var lengthOfArrayLike$4 = lengthOfArrayLike$5;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$3 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$4(O);
    var index = toAbsoluteIndex$1(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$3(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$3(false)
};

var uncurryThis$e = functionUncurryThis;
var hasOwn$6 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$2 = uncurryThis$e([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$6(hiddenKeys$2, key) && hasOwn$6(O, key) && push$2(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$6(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$2(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$3 = getBuiltIn$6;
var uncurryThis$d = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$c = anObject$e;

var concat$1 = uncurryThis$d([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$3('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$c(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$5 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$3 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$3.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$5(target, key) && !(exceptions && hasOwn$5(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$f = fails$n;
var isCallable$9 = isCallable$j;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize$1(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$9(detection) ? fails$f(detection)
    : !!detection;
};

var normalize$1 = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$8 = global$h;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$6;
var defineBuiltIn$5 = defineBuiltIn$6;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$1 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$8;
  } else if (STATIC) {
    target = global$8[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$8[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$4(sourceProperty, 'sham', true);
    }
    defineBuiltIn$5(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$5 = descriptors;
var uncurryThis$c = functionUncurryThis;
var call$a = functionCall;
var fails$e = fails$n;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$3 = toObject$5;
var IndexedObject$1 = indexedObject;

// eslint-disable-next-line es-x/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var defineProperty$5 = Object.defineProperty;
var concat = uncurryThis$c([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$e(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$5 && $assign({ b: 1 }, $assign(defineProperty$5({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$5(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es-x/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys$1($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$3(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$5 || call$a(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$9 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$$9({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

var wellKnownSymbol$e = wellKnownSymbol$g;

var TO_STRING_TAG$3 = wellKnownSymbol$e('toStringTag');
var test$1 = {};

test$1[TO_STRING_TAG$3] = 'z';

var toStringTagSupport = String(test$1) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$8 = isCallable$j;
var classofRaw = classofRaw$1;
var wellKnownSymbol$d = wellKnownSymbol$g;

var TO_STRING_TAG$2 = wellKnownSymbol$d('toStringTag');
var $Object$1 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$6 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$2)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$8(O.callee) ? 'Arguments' : result;
};

var classof$5 = classof$6;

var $String$1 = String;

var toString$9 = function (argument) {
  if (classof$5(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String$1(argument);
};

var anObject$b = anObject$e;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$b(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var fails$d = fails$n;
var global$7 = global$h;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$7.RegExp;

var UNSUPPORTED_Y$3 = fails$d(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY$1 = UNSUPPORTED_Y$3 || fails$d(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$3 || fails$d(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY$1,
  UNSUPPORTED_Y: UNSUPPORTED_Y$3
};

var objectDefineProperties = {};

var DESCRIPTORS$4 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$2 = objectDefineProperty;
var anObject$a = anObject$e;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$4 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$a(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$2.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$2 = getBuiltIn$6;

var html$1 = getBuiltIn$2('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var anObject$9 = anObject$e;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$9(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var fails$c = fails$n;
var global$6 = global$h;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$6.RegExp;

var regexpUnsupportedDotAll = fails$c(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

var fails$b = fails$n;
var global$5 = global$h;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$5.RegExp;

var regexpUnsupportedNcg = fails$b(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$9 = functionCall;
var uncurryThis$b = functionUncurryThis;
var toString$8 = toString$9;
var regexpFlags = regexpFlags$1;
var stickyHelpers$2 = regexpStickyHelpers;
var shared = shared$4.exports;
var create$2 = objectCreate;
var getInternalState$1 = internalState.get;
var UNSUPPORTED_DOT_ALL$1 = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG$1 = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$3 = uncurryThis$b(''.charAt);
var indexOf = uncurryThis$b(''.indexOf);
var replace$3 = uncurryThis$b(''.replace);
var stringSlice$4 = uncurryThis$b(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$9(nativeExec, re1, 'a');
  call$9(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$2 = stickyHelpers$2.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$2 || UNSUPPORTED_DOT_ALL$1 || UNSUPPORTED_NCG$1;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$1(re);
    var str = toString$8(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$9(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$2 && re.sticky;
    var flags = call$9(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$3(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$4(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$3(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$9(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$4(match.input, charsAdded);
        match[0] = stringSlice$4(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$9(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create$2(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$3 = patchedExec;

var $$8 = _export;
var exec$3 = regexpExec$3;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$8({ target: 'RegExp', proto: true, forced: /./.exec !== exec$3 }, {
  exec: exec$3
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var uncurryThis$a = functionUncurryThis;
var defineBuiltIn$4 = defineBuiltIn$6;
var regexpExec$2 = regexpExec$3;
var fails$a = fails$n;
var wellKnownSymbol$c = wellKnownSymbol$g;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$6;

var SPECIES$2 = wellKnownSymbol$c('species');
var RegExpPrototype$3 = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$c(KEY);

  var DELEGATES_TO_SYMBOL = !fails$a(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$a(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$2] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis$a(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis$a(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec$2 || $exec === RegExpPrototype$3.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn$4(String.prototype, KEY, methods[0]);
    defineBuiltIn$4(RegExpPrototype$3, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty$3(RegExpPrototype$3[SYMBOL], 'sham', true);
};

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es-x/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

var call$8 = functionCall;
var anObject$8 = anObject$e;
var isCallable$7 = isCallable$j;
var classof$4 = classofRaw$1;
var regexpExec$1 = regexpExec$3;

var $TypeError$7 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$7(exec)) {
    var result = call$8(exec, R, S);
    if (result !== null) anObject$8(result);
    return result;
  }
  if (classof$4(R) === 'RegExp') return call$8(regexpExec$1, R, S);
  throw $TypeError$7('RegExp#exec called on incompatible receiver');
};

var call$7 = functionCall;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var anObject$7 = anObject$e;
var requireObjectCoercible$4 = requireObjectCoercible$7;
var sameValue = sameValue$1;
var toString$7 = toString$9;
var getMethod$3 = getMethod$5;
var regExpExec = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic$1('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$4(this);
      var searcher = regexp == undefined ? undefined : getMethod$3(regexp, SEARCH);
      return searcher ? call$7(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$7(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject$7(this);
      var S = toString$7(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

var wellKnownSymbol$b = wellKnownSymbol$g;
var create$1 = objectCreate;
var defineProperty$4 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$b('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  defineProperty$4(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$9 = fails$n;

var correctPrototypeGetter = !fails$9(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$4 = hasOwnProperty_1;
var isCallable$6 = isCallable$j;
var toObject$2 = toObject$5;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject$2(O);
  if (hasOwn$4(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$6(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};

var fails$8 = fails$n;
var isCallable$5 = isCallable$j;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$3 = defineBuiltIn$6;
var wellKnownSymbol$a = wellKnownSymbol$g;

var ITERATOR$4 = wellKnownSymbol$a('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es-x/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails$8(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$4].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$5(IteratorPrototype$2[ITERATOR$4])) {
  defineBuiltIn$3(IteratorPrototype$2, ITERATOR$4, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$3 = objectDefineProperty.f;
var hasOwn$3 = hasOwnProperty_1;
var wellKnownSymbol$9 = wellKnownSymbol$g;

var TO_STRING_TAG$1 = wellKnownSymbol$9('toStringTag');

var setToStringTag$2 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$3(target, TO_STRING_TAG$1)) {
    defineProperty$3(target, TO_STRING_TAG$1, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor$1 = createPropertyDescriptor$4;
var setToStringTag$1 = setToStringTag$2;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$1 = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor$1(+!ENUMERABLE_NEXT, next) });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var isCallable$4 = isCallable$j;

var $String = String;
var $TypeError$6 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$4(argument)) return argument;
  throw $TypeError$6("Can't set " + $String(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$9 = functionUncurryThis;
var anObject$6 = anObject$e;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$9(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$6(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$7 = _export;
var call$6 = functionCall;
var FunctionName = functionName;
var isCallable$3 = isCallable$j;
var createIteratorConstructor = createIteratorConstructor$1;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag = setToStringTag$2;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$6;
var defineBuiltIn$2 = defineBuiltIn$6;
var wellKnownSymbol$8 = wellKnownSymbol$g;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$2 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$3 = wellKnownSymbol$8('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$1 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$3]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$1) {
          setPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$3(CurrentIteratorPrototype[ITERATOR$3])) {
          defineBuiltIn$2(CurrentIteratorPrototype, ITERATOR$3, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$2 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$2(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$6(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$2(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$7({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$3] !== defaultIterator) {
    defineBuiltIn$2(IterablePrototype, ITERATOR$3, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators$2 = iterators;
var InternalStateModule = internalState;
var defineProperty$2 = objectDefineProperty.f;
var defineIterator = defineIterator$1;
var DESCRIPTORS$3 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$3 && values.name !== 'values') try {
  defineProperty$2(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$4 = global$h;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$6;
var wellKnownSymbol$7 = wellKnownSymbol$g;

var ITERATOR$2 = wellKnownSymbol$7('iterator');
var TO_STRING_TAG = wellKnownSymbol$7('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$2] !== ArrayValues) try {
      createNonEnumerableProperty$1(CollectionPrototype, ITERATOR$2, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$2] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty$1(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$4[COLLECTION_NAME] && global$4[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

var aCallable$3 = aCallable$5;
var toObject$1 = toObject$5;
var IndexedObject = indexedObject;
var lengthOfArrayLike$3 = lengthOfArrayLike$5;

var $TypeError$5 = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$2 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable$3(callbackfn);
    var O = toObject$1(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike$3(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError$5('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$2(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$2(true)
};

var fails$7 = fails$n;

var arrayMethodIsStrict$2 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$7(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var classof$3 = classofRaw$1;
var global$3 = global$h;

var engineIsNode = classof$3(global$3.process) == 'process';

var $$6 = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict$1 = arrayMethodIsStrict$2;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;

var STRICT_METHOD$1 = arrayMethodIsStrict$1('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$6({ target: 'Array', proto: true, forced: !STRICT_METHOD$1 || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

function transitionTime(timeSlug) {
  if (timeSlug === 'short') {
    return '0.1s';
  }

  if (timeSlug === 'medium-mobile') {
    return '0.25s';
  }

  if (timeSlug === 'medium-desktop' || timeSlug === 'long-mobile') {
    return '0.3s';
  }

  if (timeSlug === 'long-desktop') {
    return '0.35s';
  }

  return '0.2s';
}

function transitionTimingFunction(type) {
  switch (type) {
    case 'in':
      return 'cubic-bezier(0.0, 0.0, 0.2, 1)';

    case 'out':
      return 'cubic-bezier(0.4, 0.0, 1, 1)';

    case 'standard':
      return 'cubic-bezier(0.4, 0.0, 0.2, 1)';

    default:
      return '';
  }
}
function transition(property, timeSlug, type) {
  switch (type) {
    case 'in':
      return css(["transition:", " ", " ", ";"], property, transitionTime(timeSlug), transitionTimingFunction(type));

    case 'out':
      return css(["transition:", " ", " ", ";"], property, transitionTime(timeSlug), transitionTimingFunction(type));

    case 'standard':
      return css(["transition:", " ", " ", ";"], property, transitionTime(timeSlug), transitionTimingFunction(type));

    default:
      return css([""]);
  }
}

const elevationTransitionDuration = '0.2s';
const elevationTransitionCurve = 'cubic-bezier(0.4, 0.0, 0.2, 1)';
const shadowColorTransparent1 = 'rgba(0, 0, 0, 0.05)';
const shadowColorTransparent2 = 'rgba(0, 0, 0, 0.13)';
const elevationBaseShadow = `0px 0px 3px ${shadowColorTransparent1}`;
const transparentBorder = /*#__PURE__*/css(["border:2px solid rgba(0,0,0,0);"]);
const greyBorder = /*#__PURE__*/css(["border:2px solid #f1f1f1;"]);
function elevation(level, border = true, shadowColor1 = shadowColorTransparent1, shadowColor2 = shadowColorTransparent2) {
  switch (level) {
    case 0:
      return css(["box-shadow:0px 0px 0px ", ",0px 0px 0px ", ";", ""], shadowColor1, shadowColor2, border ? greyBorder : '');

    case 1:
      return css(["box-shadow:0px 2px 5px ", ",", ";", ""], shadowColor2, elevationBaseShadow, border ? transparentBorder : '');

    case 2:
      return css(["box-shadow:0px 4px 10px ", ",", ";", ""], shadowColor2, elevationBaseShadow, border ? transparentBorder : '');

    case 3:
      return css(["box-shadow:0px 7px 15px ", ",", ";", ""], shadowColor2, elevationBaseShadow, border ? transparentBorder : '');

    default:
      return css([""]);
  }
}
function elevationTransition(border = true) {
  if (border) {
    return css(["transition:border ", " ", ",box-shadow ", " ", ";"], elevationTransitionDuration, elevationTransitionCurve, elevationTransitionDuration, elevationTransitionCurve);
  }

  return css(["transition:box-shadow ", " ", ";"], elevationTransitionDuration, elevationTransitionCurve);
}

const OuterWrap$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "searchstyles__OuterWrap",
  componentId: "xaw6dm-0"
})(["width:100%;position:relative;-webkit-tap-highlight-color:transparent;*{-webkit-tap-highlight-color:transparent;}"]);
const InnerWrap$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "searchstyles__InnerWrap",
  componentId: "xaw6dm-1"
})(["width:100%;position:absolute;z-index:", ";display:flex;flex-direction:column;justify-content:flex-start;align-items:center;background-color:", ";border-radius:24px;cursor:text;", ";", " @media (", "){", " ", " &:focus-within,&:focus{color:black;border-color:white;", "}&:hover{color:black;border-color:white;", "}}"], ({
  showSearchContent
}) => showSearchContent ? 10 : 1, ({
  theme
}) => theme.colors.ElementBackground, elevation(1, false), ({
  showSearchContent
}) => showSearchContent && css(["position:fixed;border-radius:0;top:0;left:0;right:0;", ""], elevation(0, false)), ({
  theme
}) => theme.screens.tablet, elevationTransition(false), ({
  showSearchContent
}) => showSearchContent && css(["position:absolute;border-radius:24px;", ";"], elevation(3, false)), elevation(2, false), elevation(3, false));
const Form$1 = /*#__PURE__*/styled.form.withConfig({
  displayName: "searchstyles__Form",
  componentId: "xaw6dm-2"
})(["height:48px;padding:0 12px;width:100%;overflow:hidden;display:flex;align-items:center;position:relative;flex:0 0 auto;", ""], ({
  showSearchContent
}) => showSearchContent && css(["border-bottom:2px solid ", ";"], ({
  theme
}) => theme.colors['Level 1']));
const Input = /*#__PURE__*/styled.input.withConfig({
  displayName: "searchstyles__Input",
  componentId: "xaw6dm-3"
})(["margin-left:8px;height:100%;flex-grow:1;max-width:calc(100% - 26px);", ";color:", ";line-height:24px;padding:0;background-color:transparent;border:none;outline:transparent;caret-color:#59c3ff;&::-webkit-search-cancel-button{-webkit-appearance:none;outline:none;}&:-webkit-autofill,&:-webkit-autofill:hover,&:-webkit-autofill:focus,&:-webkit-autofill:active{-webkit-box-shadow:0 0 0 30px white inset !important;}"], ({
  theme
}) => theme.typography.SmallHeadline, ({
  theme
}) => theme.colors.Foreground);
const ClearButton$1 = /*#__PURE__*/styled.button.withConfig({
  displayName: "searchstyles__ClearButton",
  componentId: "xaw6dm-4"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;width:48px;height:48px;cursor:pointer;position:absolute;right:0px;top:0px;visibility:hidden;opacity:0;background:transparent;border:none;@media (", "){", ";}", ""], ({
  theme
}) => theme.screens.tablet, transition('all', 'medium-desktop', 'standard'), ({
  visible
}) => visible && css(["visibility:visible;opacity:1;"]));

const Container$5 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__Container",
  componentId: "sc-1d7ltma-0"
})(["position:fixed;display:flex;justify-content:flex-start;align-items:center;bottom:0;left:0;right:0;top:0;overflow-y:auto;height:", ";max-height:100vh;-webkit-tap-highlight-color:transparent;cursor:pointer;background:none;visibility:hidden;z-index:10;@media (", "){height:100vh;}", ";", ""], ({
  vh
}) => vh ? `${vh}px` : '100vh', ({
  theme
}) => theme.screens.tablet, transition('all', 'long-mobile', 'out'), ({
  visible
}) => visible && `
            background: rgba(0, 0, 0, 0.5);
            visibility: visible;
            ${transition('all', 'long-mobile', 'in')};
        `);

//checks both body and html elements
const hasVerticalScrollbar = () => {
  const {
    body,
    documentElement: html
  } = document;
  const hasBodyScrollbar = body.scrollHeight > body.clientHeight;
  const hasHtmlScrollbar = html.scrollHeight > html.clientHeight;
  return hasBodyScrollbar || hasHtmlScrollbar;
}; // creating a hidden element, measuring its scrollbar width, and then removing it.

const getScrollbarWidth = () => {
  const scrollDiv = document.createElement('div');
  scrollDiv.style.width = '100px';
  scrollDiv.style.height = '100px';
  scrollDiv.style.overflow = 'scroll';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  document.body.appendChild(scrollDiv); // Measure the scrollbar width

  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
};

const useScrollLock = () => {
  const lockScroll = useCallback(() => {
    document.body.style.overflow = 'hidden';

    if (hasVerticalScrollbar()) {
      document.body.style.paddingRight = `${getScrollbarWidth()}px`;
    }
  }, []);
  const unlockScroll = useCallback(() => {
    document.body.style.overflow = '';

    if (hasVerticalScrollbar()) {
      document.body.style.paddingRight = '';
    }
  }, []);
  return {
    lockScroll,
    unlockScroll
  };
};

const Overlay$3 = ({
  className,
  children,
  visible,
  id,
  onClickOverlay
}) => {
  const {
    lockScroll,
    unlockScroll
  } = useScrollLock();
  useEffect(() => {
    if (visible) {
      lockScroll();
    } else {
      unlockScroll();
    }
  }, [visible, lockScroll, unlockScroll]);
  return jsx(Container$5, Object.assign({
    className: className,
    visible: visible,
    id: id || undefined,
    onClick: onClickOverlay,
    vh: typeof window !== 'undefined' ? window.innerHeight : undefined
  }, {
    children: children
  }));
};

var $$5 = _export;
var DESCRIPTORS$2 = descriptors;
var global$2 = global$h;
var uncurryThis$8 = functionUncurryThis;
var hasOwn$2 = hasOwnProperty_1;
var isCallable$2 = isCallable$j;
var isPrototypeOf$3 = objectIsPrototypeOf;
var toString$6 = toString$9;
var defineProperty$1 = objectDefineProperty.f;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$2.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS$2 && isCallable$2(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString$6(arguments[0]);
    var result = isPrototypeOf$3(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var symbolToString = uncurryThis$8(SymbolPrototype.toString);
  var symbolValueOf = uncurryThis$8(SymbolPrototype.valueOf);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace$2 = uncurryThis$8(''.replace);
  var stringSlice$3 = uncurryThis$8(''.slice);

  defineProperty$1(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = symbolValueOf(this);
      var string = symbolToString(symbol);
      if (hasOwn$2(EmptyStringDescriptionStore, symbol)) return '';
      var desc = NATIVE_SYMBOL ? stringSlice$3(string, 7, -1) : replace$2(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$5({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

const searchIconUrl$1 = 'https://res.cloudinary.com/grover/image/upload/v1646153280/static/search.svg';
const clockRecentSearchIconUrl$1 = 'https://res.cloudinary.com/grover/image/upload/v1646153280/static/clock-recent-search.svg';

var isCallable$1 = isCallable$j;
var isObject$1 = isObject$7;
var setPrototypeOf = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$1 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable$1(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject$1(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};

var isObject = isObject$7;
var classof$2 = classofRaw$1;
var wellKnownSymbol$6 = wellKnownSymbol$g;

var MATCH$2 = wellKnownSymbol$6('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$2]) !== undefined ? !!isRegExp : classof$2(it) == 'RegExp');
};

var call$5 = functionCall;
var hasOwn$1 = hasOwnProperty_1;
var isPrototypeOf$2 = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;

var RegExpPrototype$2 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$2) && !hasOwn$1(R, 'flags') && isPrototypeOf$2(RegExpPrototype$2, R)
    ? call$5(regExpFlags, R) : flags;
};

var defineProperty = objectDefineProperty.f;

var proxyAccessor$1 = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};

var getBuiltIn$1 = getBuiltIn$6;
var definePropertyModule$1 = objectDefineProperty;
var wellKnownSymbol$5 = wellKnownSymbol$g;
var DESCRIPTORS$1 = descriptors;

var SPECIES$1 = wellKnownSymbol$5('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$1(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule$1.f;

  if (DESCRIPTORS$1 && Constructor && !Constructor[SPECIES$1]) {
    defineProperty(Constructor, SPECIES$1, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var DESCRIPTORS = descriptors;
var global$1 = global$h;
var uncurryThis$7 = functionUncurryThis;
var isForced = isForced_1;
var inheritIfRequired = inheritIfRequired$1;
var createNonEnumerableProperty = createNonEnumerableProperty$6;
var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var isPrototypeOf$1 = objectIsPrototypeOf;
var isRegExp$2 = isRegexp;
var toString$5 = toString$9;
var getRegExpFlags$1 = regexpGetFlags;
var stickyHelpers$1 = regexpStickyHelpers;
var proxyAccessor = proxyAccessor$1;
var defineBuiltIn$1 = defineBuiltIn$6;
var fails$6 = fails$n;
var hasOwn = hasOwnProperty_1;
var enforceInternalState = internalState.enforce;
var setSpecies = setSpecies$1;
var wellKnownSymbol$4 = wellKnownSymbol$g;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var MATCH$1 = wellKnownSymbol$4('match');
var NativeRegExp = global$1.RegExp;
var RegExpPrototype$1 = NativeRegExp.prototype;
var SyntaxError = global$1.SyntaxError;
var exec$2 = uncurryThis$7(RegExpPrototype$1.exec);
var charAt$2 = uncurryThis$7(''.charAt);
var replace$1 = uncurryThis$7(''.replace);
var stringIndexOf$1 = uncurryThis$7(''.indexOf);
var stringSlice$2 = uncurryThis$7(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers$1.MISSED_STICKY;
var UNSUPPORTED_Y$1 = stickyHelpers$1.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails$6(function () {
    re2[MATCH$1] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt$2(string, index);
    if (chr === '\\') {
      result += chr + charAt$2(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt$2(string, index);
    if (chr === '\\') {
      chr = chr + charAt$2(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec$2(IS_NCG, stringSlice$2(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf$1(RegExpPrototype$1, this);
    var patternIsRegExp = isRegExp$2(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf$1(RegExpPrototype$1, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = getRegExpFlags$1(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString$5(pattern);
    flags = flags === undefined ? '' : toString$5(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf$1(flags, 's') > -1;
      if (dotAll) flags = replace$1(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf$1(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y$1) flags = replace$1(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype$1, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys[index++]);
  }

  RegExpPrototype$1.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype$1;
  defineBuiltIn$1(global$1, 'RegExp', RegExpWrapper, { constructor: true });
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var defineBuiltIn = defineBuiltIn$6;
var anObject$5 = anObject$e;
var $toString = toString$9;
var fails$5 = fails$n;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var n$ToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails$5(function () { return n$ToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && n$ToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject$5(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$6 = functionUncurryThis;
var requireObjectCoercible$3 = requireObjectCoercible$7;
var toString$4 = toString$9;
var whitespaces$1 = whitespaces$2;

var replace = uncurryThis$6(''.replace);
var whitespace = '[' + whitespaces$1 + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$1 = function (TYPE) {
  return function ($this) {
    var string = toString$4(requireObjectCoercible$3($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$1(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$1(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$1(3)
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var fails$4 = fails$n;
var whitespaces = whitespaces$2;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$4(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $$4 = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$4({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$1 = FunctionPrototype.apply;
var call$4 = FunctionPrototype.call;

// eslint-disable-next-line es-x/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$4.bind(apply$1) : function () {
  return call$4.apply(apply$1, arguments);
});

var uncurryThis$5 = functionUncurryThis;
var fails$3 = fails$n;
var isCallable = isCallable$j;
var classof$1 = classof$6;
var getBuiltIn = getBuiltIn$6;
var inspectSource = inspectSource$3;

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$1 = uncurryThis$5(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof$1(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$1(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$3(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isConstructor = isConstructor$1;
var tryToString$3 = tryToString$5;

var $TypeError$4 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError$4(tryToString$3(argument) + ' is not a constructor');
};

var anObject$4 = anObject$e;
var aConstructor = aConstructor$1;
var wellKnownSymbol$3 = wellKnownSymbol$g;

var SPECIES = wellKnownSymbol$3('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$4(O).constructor;
  var S;
  return C === undefined || (S = anObject$4(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
};

var uncurryThis$4 = functionUncurryThis;
var toIntegerOrInfinity = toIntegerOrInfinity$3;
var toString$3 = toString$9;
var requireObjectCoercible$2 = requireObjectCoercible$7;

var charAt$1 = uncurryThis$4(''.charAt);
var charCodeAt = uncurryThis$4(''.charCodeAt);
var stringSlice$1 = uncurryThis$4(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$3(requireObjectCoercible$2($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$1(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$1(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

var charAt = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};

var toPropertyKey = toPropertyKey$3;
var definePropertyModule = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$4;

var createProperty$2 = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var toAbsoluteIndex = toAbsoluteIndex$2;
var lengthOfArrayLike$2 = lengthOfArrayLike$5;
var createProperty$1 = createProperty$2;

var $Array = Array;
var max = Math.max;

var arraySliceSimple = function (O, start, end) {
  var length = lengthOfArrayLike$2(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty$1(result, n, O[k]);
  result.length = n;
  return result;
};

var apply = functionApply;
var call$3 = functionCall;
var uncurryThis$3 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var isRegExp$1 = isRegexp;
var anObject$3 = anObject$e;
var requireObjectCoercible$1 = requireObjectCoercible$7;
var speciesConstructor = speciesConstructor$1;
var advanceStringIndex = advanceStringIndex$1;
var toLength = toLength$2;
var toString$2 = toString$9;
var getMethod$2 = getMethod$5;
var arraySlice$1 = arraySliceSimple;
var callRegExpExec = regexpExecAbstract;
var regexpExec = regexpExec$3;
var stickyHelpers = regexpStickyHelpers;
var fails$2 = fails$n;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis$3(/./.exec);
var push$1 = uncurryThis$3($push);
var stringSlice = uncurryThis$3(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$2(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString$2(requireObjectCoercible$1(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp$1(separator)) {
        return call$3(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call$3(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push$1(output, stringSlice(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice$1(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push$1(output, '');
      } else push$1(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySlice$1(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call$3(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible$1(this);
      var splitter = separator == undefined ? undefined : getMethod$2(separator, SPLIT);
      return splitter
        ? call$3(splitter, separator, O, limit)
        : call$3(internalSplit, toString$2(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject$3(this);
      var S = toString$2(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push$1(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push$1(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push$1(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);

const Highlighter$1 = ({
  text,
  highlight,
  className
}) => {
  const regex = new RegExp(`(${highlight.trim()})`, 'gi');
  const parts = text.split(regex).filter(Boolean);
  return jsx("span", Object.assign({
    className: className
  }, {
    children: parts.map((part, i) => regex.test(part) ? jsx("mark", {
      children: part
    }, i) : jsx(Fragment, {
      children: part
    }, i))
  }));
};

const Arrow$1 = ({
  color,
  className
}) => jsx("svg", Object.assign({
  width: "18",
  height: "14",
  viewBox: "0 0 18 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: className
}, {
  children: jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29264 13.707C8.90211 13.3165 8.90211 12.6833 9.29264 12.2928L13.5855 7.99988L0.999743 7.99988C0.447457 7.99988 -0.000256928 7.55216 -0.00025688 6.99988C-0.000256832 6.44759 0.447457 5.99988 0.999743 5.99988L13.5855 5.99988L9.29264 1.70698C8.90211 1.31646 8.90211 0.683295 9.29264 0.292771C9.68316 -0.0977542 10.3163 -0.0977541 10.7068 0.292771L17.414 6.99988L10.7068 13.707C10.3163 14.0975 9.68316 14.0975 9.29264 13.707Z",
    fill: color
  })
}));
Arrow$1.defaultProps = {
  className: undefined,
  color: 'rgba(255, 255, 255, 0.28)'
};

const Link$2 = ({
  link,
  onNavigate,
  children,
  className,
  onClick,
  testId
}) => {
  const {
    text,
    url,
    external,
    targetBlank,
    preventDefault
  } = link;
  const linkContent = children || text;

  const handleClick = e => {
    onClick === null || onClick === void 0 ? void 0 : onClick(e, link);
  };

  const handleNavigateClick = e => {
    onClick === null || onClick === void 0 ? void 0 : onClick(e, link);
    e.preventDefault();
    onNavigate({
      url
    });
  };

  const handleNoNavigateClick = e => {
    onClick === null || onClick === void 0 ? void 0 : onClick(e, link);
    e.preventDefault();
  };

  if (preventDefault) {
    return jsx("a", Object.assign({
      href: url,
      "data-testid": testId,
      className: className,
      onClick: handleNoNavigateClick
    }, {
      children: linkContent
    }));
  }

  if (targetBlank) {
    return jsx("a", Object.assign({
      "data-testid": testId,
      href: url,
      target: "_blank",
      rel: "noreferrer",
      className: className,
      onClick: handleClick
    }, {
      children: linkContent
    }));
  }

  if (external) {
    return jsx("a", Object.assign({
      "data-testid": testId,
      href: url,
      className: className,
      onClick: handleClick
    }, {
      children: linkContent
    }));
  }

  return jsx("a", Object.assign({
    "data-testid": testId,
    href: url,
    onClick: handleNavigateClick,
    className: className
  }, {
    children: linkContent
  }));
};

const List$1 = /*#__PURE__*/styled.ul.withConfig({
  displayName: "search-result-sectionstyles__List",
  componentId: "sc-3gk29g-0"
})(["list-style:none;margin:0;padding:0;"]);
const Image$1 = /*#__PURE__*/styled.img.withConfig({
  displayName: "search-result-sectionstyles__Image",
  componentId: "sc-3gk29g-1"
})(["height:32px;width:32px;margin-right:12px;flex:0 0 auto;object-fit:contain;"]);
const NavigationLink$5 = /*#__PURE__*/styled(Link$2).withConfig({
  displayName: "search-result-sectionstyles__NavigationLink",
  componentId: "sc-3gk29g-2"
})(["", ";color:", ";padding:", ";text-decoration:none;display:flex;align-items:center;border-radius:8px;cursor:pointer;&:hover,&:focus{background-color:", ";outline:none;}"], ({
  theme
}) => theme.typography.Paragraph, ({
  theme
}) => theme.colors.Foreground, ({
  theme
}) => `${theme.spacers.M} 0`, ({
  theme
}) => theme.colors['Level 1']);
const baseListItemIconStyle$1 = /*#__PURE__*/css(["margin-right:", ";position:relative;width:24px;height:24px;"], ({
  theme
}) => theme.spacers.M);
const CategoryIcon$2 = /*#__PURE__*/styled(SonntagIcon).withConfig({
  displayName: "search-result-sectionstyles__CategoryIcon",
  componentId: "sc-3gk29g-3"
})(["", ""], baseListItemIconStyle$1);
const RecentSearchTermIcon$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "search-result-sectionstyles__RecentSearchTermIcon",
  componentId: "sc-3gk29g-4"
})(["background:url(", ");", ""], clockRecentSearchIconUrl$1, baseListItemIconStyle$1);
const SearchTermIcon$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "search-result-sectionstyles__SearchTermIcon",
  componentId: "sc-3gk29g-5"
})(["background:url(", ");", ""], searchIconUrl$1, baseListItemIconStyle$1);
const HighlightedText$1 = /*#__PURE__*/styled(Highlighter$1).withConfig({
  displayName: "search-result-sectionstyles__HighlightedText",
  componentId: "sc-3gk29g-6"
})(["text-overflow:ellipsis;overflow:hidden;white-space:nowrap;mark{background-color:transparent;color:inherit;font-weight:600;}"]);
const ArrowIcon$1 = /*#__PURE__*/styled(Arrow$1).attrs(({
  theme
}) => ({
  color: theme.colors['Level 3']
})).withConfig({
  displayName: "search-result-sectionstyles__ArrowIcon",
  componentId: "sc-3gk29g-7"
})(["margin-left:auto;flex-shrink:0;&.arrow-up{transform:rotate(225deg);}"]);
const TextWrap$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "search-result-sectionstyles__TextWrap",
  componentId: "sc-3gk29g-8"
})(["display:flex;flex-direction:column;justify-content:center;overflow:hidden;margin-right:", ";"], ({
  theme
}) => theme.spacers.S);
const Features$1 = /*#__PURE__*/styled(Highlighter$1).withConfig({
  displayName: "search-result-sectionstyles__Features",
  componentId: "sc-3gk29g-9"
})(["", ";white-space:nowrap;text-overflow:ellipsis;overflow:hidden;line-height:16px;color:", ";mark{background-color:transparent;color:inherit;font-weight:600;}"], ({
  theme
}) => theme.typography.TinyParagraph, ({
  theme
}) => theme.colors['Level 4']);
const NoResultsText$1 = /*#__PURE__*/styled.p.withConfig({
  displayName: "search-result-sectionstyles__NoResultsText",
  componentId: "sc-3gk29g-10"
})(["", ";color:", ";margin-bottom:", ";"], ({
  theme
}) => theme.typography.Paragraph, ({
  theme
}) => theme.colors.Foreground, ({
  theme
}) => theme.spacers.L);

const Container$4 = /*#__PURE__*/styled.div.withConfig({
  displayName: "search-result-section-container__Container",
  componentId: "kcjwmg-0"
})(["display:flex;flex-direction:column;margin-bottom:", ";"], ({
  theme
}) => theme.spacers.L);
const TitleContainer$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "search-result-section-container__TitleContainer",
  componentId: "kcjwmg-1"
})(["margin-bottom:", ";"], ({
  theme
}) => theme.spacers.M);
const SearchResultSectionContainer$1 = ({
  title,
  children
}) => {
  return jsxs(Container$4, Object.assign({
    "data-testid": "search-result-section"
  }, {
    children: [jsx(TitleContainer$1, {
      children: jsx(SectionHead, {
        title: title
      })
    }), children]
  }));
};

const SEGMENT_EVENTS = {
  yourTechLinkClick: 'My Tech Clicked',
  categoryMenuLinkClick: 'Category Clicked',
  searchInputFocus: 'Search Entered',
  searchInputBlur: 'Search Exited',
  searchSubmit: 'Search Term Used',
  searchResultCategoryClick: 'Search Category Clicked',
  searchResultProductClick: 'Search Product Clicked',
  searchResultShowAllClick: 'Search CTA Clicked',
  popularSearchTermClicked: 'Search Popular Search Term Clicked',
  popularCategoryClicked: 'Search Popular Category Clicked',
  noSearchResultsDelivered: 'Search Overlay 0 Results Delivered',
  searchCategoryPreviewClick: 'Search Category Teaser Clicked',
  loginButtonClick: 'Login Started',
  dashboardClicked: 'Dashboard Clicked',
  navigationClicked: 'Navigation Clicked',
  languageChanged: 'Language Changed',
  storeChanged: 'Store Changed'
};
var NAVIGATION_GROUP_TYPE;

(function (NAVIGATION_GROUP_TYPE) {
  NAVIGATION_GROUP_TYPE["TRENDING"] = "trending";
  NAVIGATION_GROUP_TYPE["DEALS"] = "deals";
  NAVIGATION_GROUP_TYPE["MY_TECH"] = "my-tech";
  NAVIGATION_GROUP_TYPE["HOW_IT_WORKS"] = "how-it-works";
  NAVIGATION_GROUP_TYPE["CART"] = "cart";
  NAVIGATION_GROUP_TYPE["WISHLIST"] = "wishlist";
  NAVIGATION_GROUP_TYPE["ACCOUNT"] = "account";
  NAVIGATION_GROUP_TYPE["BRANDS"] = "brands";
  NAVIGATION_GROUP_TYPE["CATEGORY"] = "category";
  NAVIGATION_GROUP_TYPE["HAMBURGER_MENU"] = "hamburger-menu";
  NAVIGATION_GROUP_TYPE["ALL_CATEGORIES"] = "all-categories";
})(NAVIGATION_GROUP_TYPE || (NAVIGATION_GROUP_TYPE = {}));

var ACCOUNT_ACTION_TYPE;

(function (ACCOUNT_ACTION_TYPE) {
  ACCOUNT_ACTION_TYPE["REGISTER"] = "register";
  ACCOUNT_ACTION_TYPE["LOGIN"] = "login";
})(ACCOUNT_ACTION_TYPE || (ACCOUNT_ACTION_TYPE = {}));

const TRACKING_PROPS = {
  POSITION: 'header',
  PLATFORM: 'Web'
};

const EMPTY_QUERY = '[]';
const handleLoginButtonClick = ({
  storeId,
  sendAnalyticsFunctionFromConsumer
}) => {
  const sendAnalytics = sendAnalyticsFunctionFromConsumer || sendAnalyticsEvent;
  sendAnalytics(SEGMENT_EVENTS.loginButtonClick, {
    store_id: storeId
  });
};
const handleYourTechLinkClick = ({
  storeId,
  isB2BStore,
  sendAnalyticsFunctionFromConsumer
}) => {
  const sendAnalytics = sendAnalyticsFunctionFromConsumer || sendAnalyticsEvent;
  if (isB2BStore) sendAnalytics(SEGMENT_EVENTS.dashboardClicked, {
    store_id: storeId
  });
  sendAnalytics(SEGMENT_EVENTS.yourTechLinkClick, {
    store_id: storeId
  });
};
const handleCategoryMenuLinkClick = ({
  storeId,
  url,
  sendAnalyticsFunctionFromConsumer
}) => {
  const sendAnalytics = sendAnalyticsFunctionFromConsumer || sendAnalyticsEvent;
  sendAnalytics(SEGMENT_EVENTS.categoryMenuLinkClick, {
    store_id: storeId,
    value: url
  });
};
const handleSearchInputFocus = ({
  storeId,
  sendAnalyticsFunctionFromConsumer
}) => {
  const sendAnalytics = sendAnalyticsFunctionFromConsumer || sendAnalyticsEvent;
  sendAnalytics(SEGMENT_EVENTS.searchInputFocus, {
    store_id: storeId
  });
};
const handleSearchInputBlur = ({
  storeId,
  query,
  sendAnalyticsFunctionFromConsumer
}) => {
  const sendAnalytics = sendAnalyticsFunctionFromConsumer || sendAnalyticsEvent;
  const cleanQuery = !query.trim().length ? EMPTY_QUERY : query;
  sendAnalytics(SEGMENT_EVENTS.searchInputBlur, {
    store_id: storeId,
    search_term: cleanQuery
  });
};
const handleSearchSubmit = ({
  storeId,
  query,
  sendAnalyticsFunctionFromConsumer
}) => {
  const sendAnalytics = sendAnalyticsFunctionFromConsumer || sendAnalyticsEvent;
  const cleanQuery = !query.trim().length ? EMPTY_QUERY : query;
  sendAnalytics(SEGMENT_EVENTS.searchSubmit, {
    store_id: storeId,
    search_term: cleanQuery
  });
};
const handleSearchResultCategoryClick = ({
  storeId,
  query,
  permalink,
  sendAnalyticsFunctionFromConsumer
}) => {
  const sendAnalytics = sendAnalyticsFunctionFromConsumer || sendAnalyticsEvent;
  const cleanQuery = !query.trim().length ? EMPTY_QUERY : query;
  sendAnalytics(SEGMENT_EVENTS.searchResultCategoryClick, {
    store_id: storeId,
    search_term: cleanQuery,
    category: permalink
  });
};
const handleSearchResultProductClick = ({
  storeId,
  query,
  sku,
  productName,
  sendAnalyticsFunctionFromConsumer
}) => {
  const sendAnalytics = sendAnalyticsFunctionFromConsumer || sendAnalyticsEvent;
  const cleanQuery = !query.trim().length ? EMPTY_QUERY : query;
  sendAnalytics(SEGMENT_EVENTS.searchResultProductClick, {
    store_id: storeId,
    search_term: cleanQuery,
    product_name: productName,
    product_sku: sku
  });
};
const handleSearchResultShowAllClick = ({
  storeId,
  query,
  sendAnalyticsFunctionFromConsumer
}) => {
  const sendAnalytics = sendAnalyticsFunctionFromConsumer || sendAnalyticsEvent;
  const cleanQuery = !query.trim().length ? EMPTY_QUERY : query;
  sendAnalytics(SEGMENT_EVENTS.searchResultShowAllClick, {
    store_id: storeId,
    search_term: cleanQuery
  });
};
const handleSearchCategoryPreviewClick = ({
  storeId,
  permalink,
  sendAnalyticsFunctionFromConsumer
}) => {
  const sendAnalytics = sendAnalyticsFunctionFromConsumer || sendAnalyticsEvent;
  sendAnalytics(SEGMENT_EVENTS.searchCategoryPreviewClick, {
    store_id: storeId,
    category: permalink
  });
};
const handleNoSearchResultsDelivered = ({
  storeId,
  query,
  sendAnalyticsFunctionFromConsumer
}) => {
  const sendAnalytics = sendAnalyticsFunctionFromConsumer || sendAnalyticsEvent;
  sendAnalytics(SEGMENT_EVENTS.noSearchResultsDelivered, {
    store_id: storeId,
    search_term: query
  });
};
const handlePopularSearchTermClicked = ({
  storeId,
  query,
  sendAnalyticsFunctionFromConsumer
}) => {
  const sendAnalytics = sendAnalyticsFunctionFromConsumer || sendAnalyticsEvent;
  sendAnalytics(SEGMENT_EVENTS.popularSearchTermClicked, {
    store_id: storeId,
    popular_search_term: query
  });
};
const handlePopularCategoryClicked = ({
  storeId,
  query,
  sendAnalyticsFunctionFromConsumer
}) => {
  const sendAnalytics = sendAnalyticsFunctionFromConsumer || sendAnalyticsEvent;
  sendAnalytics(SEGMENT_EVENTS.popularCategoryClicked, {
    store_id: storeId,
    popular_category: query
  });
};

const productAnalyticsKey = 'sku';
const categoryAnalyticsKey = 'permalink';
const SearchResultSection$1 = ({
  section,
  isMobile,
  onNavigate,
  storeId,
  query,
  sendAnalyticsFunctionFromConsumer,
  setQuery
}) => {
  const {
    title,
    emptyText,
    items,
    highlight
  } = section;
  const isRecentSearchTerm = false;

  const handleNoSearchResults = () => {
    handleNoSearchResultsDelivered({
      storeId,
      query,
      sendAnalyticsFunctionFromConsumer
    });
  };

  const handleClick = item => {
    var _a, _b;

    if (item.type === SearchResultSectionItemType.popularCategory) {
      setQuery === null || setQuery === void 0 ? void 0 : setQuery('');
      handlePopularCategoryClicked({
        storeId,
        query: item.link.text,
        sendAnalyticsFunctionFromConsumer
      });
    }

    if (item.type === SearchResultSectionItemType.popularSearch) {
      setQuery === null || setQuery === void 0 ? void 0 : setQuery(item.link.text);
      handlePopularSearchTermClicked({
        storeId,
        query: item.link.text,
        sendAnalyticsFunctionFromConsumer
      });
    }

    if (item.type === SearchResultSectionItemType.product) {
      const sku = (_a = item.analyticsTerms.find(term => term.name === productAnalyticsKey)) === null || _a === void 0 ? void 0 : _a.value;
      handleSearchResultProductClick({
        sendAnalyticsFunctionFromConsumer,
        storeId,
        query,
        productName: item.link.text,
        sku
      });
    }

    if (item.type === SearchResultSectionItemType.category) {
      const permalink = (_b = item.analyticsTerms.find(term => term.name === categoryAnalyticsKey)) === null || _b === void 0 ? void 0 : _b.value;
      setQuery === null || setQuery === void 0 ? void 0 : setQuery('');
      handleSearchResultCategoryClick({
        sendAnalyticsFunctionFromConsumer,
        storeId,
        query,
        permalink
      });
    }
  };

  const content = !items.length ? jsxs(Fragment$1, {
    children: [handleNoSearchResults(), jsx(NoResultsText$1, {
      children: emptyText
    })]
  }) : jsx(List$1, {
    children: items.map(item => {
      const {
        link,
        imageUrl,
        description
      } = item;
      const {
        url,
        svgPath,
        text
      } = link;
      return jsx("li", {
        children: jsxs(NavigationLink$5, Object.assign({
          link: link,
          onNavigate: onNavigate,
          onClick: () => handleClick(item),
          testId: `search-result-section-link-${item.type}`
        }, {
          children: [imageUrl ? jsx(Image$1, {
            alt: text,
            src: imageUrl
          }) : svgPath ? jsx(CategoryIcon$2, {
            iconPath: svgPath
          }) : !highlight && isRecentSearchTerm ? jsx(RecentSearchTermIcon$1, {}) : jsx(SearchTermIcon$1, {}), jsxs(TextWrap$1, {
            children: [highlight ? jsx(HighlightedText$1, {
              text: text,
              highlight: highlight
            }) : jsx("span", {
              children: text
            }), !isMobile ? jsx(Features$1, {
              text: description || '',
              highlight: highlight || ''
            }) : null]
          }), jsx(ArrowIcon$1, {
            className: item.type === SearchResultSectionItemType.popularSearch ? 'arrow-up' : ''
          })]
        }))
      }, url);
    })
  });
  return jsx(SearchResultSectionContainer$1, Object.assign({
    title: title
  }, {
    children: content
  }));
};

const Wrap$5 = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styled__Wrap",
  componentId: "sc-1wxcbt6-0"
})(["padding:0;list-style:none;display:grid;margin-bottom:", ";grid-gap:", ";grid-template-columns:repeat(2,1fr);@media (", "){grid-template-columns:repeat(3,1fr);}@media (", "){grid-template-columns:repeat(3,1fr);}@media (", "){grid-template-columns:repeat(4,1fr);}@media (", "){grid-template-columns:repeat(4,1fr);}@media (", "){grid-template-columns:repeat(6,1fr);}@media (", "){grid-template-columns:repeat(7,1fr);}@media (", "){grid-template-columns:repeat(8,1fr);}"], ({
  theme
}) => theme.spacers.L, ({
  theme
}) => theme.spacers.L, ({
  theme
}) => theme.screens.largePhone, ({
  theme
}) => theme.screens.desktop, ({
  theme
}) => theme.screens.largeDesktop, ({
  theme
}) => theme.screens.wideDesktop, ({
  theme
}) => theme.screens.wideScreen, ({
  theme
}) => theme.screens.extraWideScreen, ({
  theme
}) => theme.screens.extraWideDesktop);
const itemStyles$1 = /*#__PURE__*/css(["", ";color:", ";background-color:#f7f7f7;border-radius:8px;height:117px;word-break:break-word;text-align:center;padding-bottom:", ";&:hover{box-shadow:0px 0px 3px rgba(0,0,0,0.05),0px 4px 10px rgba(0,0,0,0.13);}@media (", "){height:176px;padding-bottom:", ";}"], ({
  theme
}) => theme.typography.Paragraph, ({
  theme
}) => theme.colors.secondary, ({
  theme
}) => theme.spacers.M, ({
  theme
}) => theme.screens.tablet, ({
  theme
}) => theme.spacers.L);
const ShowAllButton$1 = /*#__PURE__*/styled.button.withConfig({
  displayName: "styled__ShowAllButton",
  componentId: "sc-1wxcbt6-1"
})(["", " border:none;cursor:pointer;width:100%;text-align:center;padding:0;display:flex;align-items:center;justify-content:center;"], itemStyles$1);
const ButtonText$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__ButtonText",
  componentId: "sc-1wxcbt6-2"
})(["background:", ";", ";line-height:120%;font-weight:800;padding:14px 22px;border-radius:88px;"], ({
  theme
}) => theme.colors['Level 1'], ({
  theme
}) => theme.typography.Paragraph);
const NavigationLink$4 = /*#__PURE__*/styled(Link$2).withConfig({
  displayName: "styled__NavigationLink",
  componentId: "sc-1wxcbt6-3"
})(["", " display:flex;flex-direction:column;justify-content:center;align-items:center;text-decoration:none;"], itemStyles$1);
const ImageWrap$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__ImageWrap",
  componentId: "sc-1wxcbt6-4"
})(["position:relative;height:100%;width:100%;display:flex;"]);
const CategoryImage$1 = /*#__PURE__*/styled.img.withConfig({
  displayName: "styled__CategoryImage",
  componentId: "sc-1wxcbt6-5"
})(["position:absolute;object-fit:contain;object-position:center center;width:100%;height:100%;"]);
const TextContainer$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__TextContainer",
  componentId: "sc-1wxcbt6-6"
})(["hyphens:auto;font-size:14px;line-height:150%;color:#333333;@media (", "){font-size:16px;}"], ({
  theme
}) => theme.screens.tablet);

const shimmerImageUrl$1 = 'https://res.cloudinary.com/grover/image/upload/v1689781339/categories-widget/shimmerImage.gif';
const NUM_COLLAPSED_CATEGORY_ITEMS$1 = 5;

const Item$2 = ({
  link,
  text,
  imageUrl,
  onNavigate,
  handleCategoryClick
}) => {
  const [src, setSrc] = useState(imageUrl !== null && imageUrl !== void 0 ? imageUrl : shimmerImageUrl$1);
  return jsxs(NavigationLink$4, Object.assign({
    link: link,
    onNavigate: onNavigate,
    onClick: handleCategoryClick,
    "data-testid": "link",
    testId: "category-preview"
  }, {
    children: [jsx(ImageWrap$1, {
      children: jsx(CategoryImage$1, {
        src: src,
        alt: text,
        onError: () => setSrc(`${shimmerImageUrl$1}`)
      })
    }), jsx(TextContainer$1, {
      children: text
    })]
  }));
};

const CategoryPills$1 = ({
  categories,
  isMobile,
  onNavigate,
  storeId,
  searchCategoriesShowAllLabel,
  sendAnalyticsFunctionFromConsumer
}) => {
  const [collapsed, setCollapsed] = useState(isMobile);
  const visibleItems = collapsed ? categories.slice(0, NUM_COLLAPSED_CATEGORY_ITEMS$1) : categories;

  const handleCategoryClick = permalink => {
    handleSearchCategoryPreviewClick({
      sendAnalyticsFunctionFromConsumer,
      storeId,
      permalink
    });
  };

  return jsxs(Wrap$5, {
    children: [visibleItems.map(category => {
      const {
        id,
        link,
        permalink,
        coverImageUrl
      } = category;
      const {
        text
      } = link;
      return jsx("li", {
        children: jsx(Item$2, {
          link: link,
          text: text,
          imageUrl: coverImageUrl,
          onNavigate: onNavigate,
          handleCategoryClick: () => handleCategoryClick(permalink)
        })
      }, id);
    }), collapsed && jsx("li", {
      children: jsx(ShowAllButton$1, Object.assign({
        onClick: () => setCollapsed(false)
      }, {
        children: jsx(ButtonText$1, {
          children: searchCategoriesShowAllLabel
        })
      }), "show-all")
    })]
  });
};

const inOutTransitionFunction$1 = 'cubic-bezier(0.4, 0.0, 0.2, 1)';
const animationDurationInMs$1 = 1400;
const rotationKeyframe$1 = /*#__PURE__*/keyframes(["from{transform:rotate(0deg);}to{transform:rotate(270deg);}"]);
const rotationKeyframeRule$1 = /*#__PURE__*/css(
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
// @ts-ignore: No overload matches this call.
['', ` ${animationDurationInMs$1}ms linear infinite;`], rotationKeyframe$1);
const dashKeyframe$1 = /*#__PURE__*/keyframes(["50%{transform:rotate(135deg);}100%{transform:rotate(450deg);}"]);
const dashKeyframeRule$1 = /*#__PURE__*/css(
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
// @ts-ignore: No overload matches this call.
['', ` ${animationDurationInMs$1}ms ${inOutTransitionFunction$1} infinite`], dashKeyframe$1);
const SpinnerContainer$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__SpinnerContainer",
  componentId: "rbpua5-0"
})(["width:45px;height:45px;animation:", ";"], rotationKeyframeRule$1);
const SpinnerCircle$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__SpinnerCircle",
  componentId: "rbpua5-1"
})(["border-left-color:", ";border-top-color:", ";box-sizing:border-box;border-width:4px;border-style:solid;width:100%;height:100%;border-radius:50%;border-right-color:transparent;border-bottom-color:transparent;animation:", ";"], ({
  theme
}) => theme.colors.Color1_75, ({
  theme
}) => theme.colors.Color1_75, dashKeyframeRule$1);
const Container$3 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__Container",
  componentId: "rbpua5-2"
})(["flex-shrink:0;flex-grow:1;display:flex;justify-content:center;align-items:center;width:100%;height:100%;"]);

const Spinner$1 = () => jsx(SpinnerContainer$1, {
  children: jsx(SpinnerCircle$1, {})
});

const CircleLoader$1 = ({
  className: _className = ''
}) => jsx(Container$3, Object.assign({
  className: _className
}, {
  children: jsx(Spinner$1, {})
}));

const Wrap$4 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__Wrap",
  componentId: "sc-13cpgcg-0"
})(["width:100%;display:block;overflow-y:auto;height:100vh;padding:", ";@media (", "){height:auto;max-height:70vh;padding-bottom:0;}"], ({
  theme
}) => `${theme.spacers.XL} ${theme.spacers.XL} 192px`, ({
  theme
}) => theme.screens.tablet);
const Loader$1 = /*#__PURE__*/styled(CircleLoader$1).withConfig({
  displayName: "styles__Loader",
  componentId: "sc-13cpgcg-1"
})(["height:64px;margin-top:", ";@media (", "){margin-top:16px;}"], ({
  theme
}) => theme.spacers.XXL, ({
  theme
}) => theme.screens.tablet);
const Button$4 = /*#__PURE__*/styled(SonntagButtonV2).withConfig({
  displayName: "styles__Button",
  componentId: "sc-13cpgcg-3"
})(["text-decoration:none;margin:", ";flex:0 0 auto;width:100%;@media (", "){width:auto;}"], ({
  theme
}) => `${theme.spacers.XL} auto`, ({
  theme
}) => theme.screens.tablet);

const SearchContent$1 = ({
  isMobile,
  isLoading,
  query,
  categories,
  searchResult,
  onTouchStart,
  setQuery,
  topLevelCategoriesTitle,
  onNavigate,
  storeId,
  searchCategoriesShowAllLabel,
  sendAnalyticsFunctionFromConsumer
}) => {
  const ref = useRef(null);
  const wrapProps = {
    ref,
    onTouchStart
  };

  if (isLoading) {
    return jsx(Wrap$4, Object.assign({}, wrapProps, {
      children: jsx(Loader$1, {})
    }));
  }

  if (!query) {
    return jsx(Wrap$4, Object.assign({}, wrapProps, {
      children: jsx(SearchResultSectionContainer$1, Object.assign({
        title: topLevelCategoriesTitle
      }, {
        children: jsx(CategoryPills$1, {
          isMobile: isMobile,
          categories: categories,
          onNavigate: onNavigate,
          storeId: storeId,
          searchCategoriesShowAllLabel: searchCategoriesShowAllLabel,
          sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
        })
      }))
    }));
  }

  if (!searchResult || !query) {
    return null;
  }

  const handleShowAllLinkClick = () => {
    handleSearchResultShowAllClick({
      sendAnalyticsFunctionFromConsumer,
      storeId,
      query
    });
  };

  const noResultsSection = searchResult.sections.find(s => s.items.length === 0 && s.emptyText);
  return jsxs(Wrap$4, Object.assign({}, wrapProps, {
    children: [searchResult.sections.map(section => {
      return jsx(SearchResultSection$1, {
        isMobile: isMobile,
        section: section,
        onNavigate: onNavigate,
        setQuery: setQuery,
        storeId: storeId,
        query: query,
        sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
      }, section.title);
    }), !noResultsSection && jsx(Link$2, Object.assign({
      link: searchResult.showAllLink,
      onNavigate: onNavigate,
      onClick: handleShowAllLinkClick
    }, {
      children: jsx(Button$4, {
        children: searchResult.showAllLink.text
      })
    }))]
  }));
};

const CloseIcon = ({
  className,
  color,
  size
}) => jsx("svg", Object.assign({
  height: size,
  width: size,
  className: className,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, {
  children: jsx("path", {
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29289 6.29289C6.68342 5.90237 7.31658 5.90237 7.70711 6.29289L12 10.5858L16.2929 6.29289C16.6834 5.90237 17.3166 5.90237 17.7071 6.29289C18.0976 6.68342 18.0976 7.31658 17.7071 7.70711L13.4142 12L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L12 13.4142L7.70711 17.7071C7.31658 18.0976 6.68342 18.0976 6.29289 17.7071C5.90237 17.3166 5.90237 16.6834 6.29289 16.2929L10.5858 12L6.29289 7.70711C5.90237 7.31658 5.90237 6.68342 6.29289 6.29289Z"
  })
}));
CloseIcon.defaultProps = {
  className: undefined,
  color: '#333333',
  size: '24px'
};

const ANIMATION_DURATION_IN_MS$2 = 200;
const Wrap$3 = /*#__PURE__*/styled.div.withConfig({
  displayName: "search-suggestionsstyles__Wrap",
  componentId: "sc-18awqdw-0"
})(["display:flex;flex-wrap:nowrap;width:100%;pointer-events:none;position:absolute;max-width:calc(100% - 26px);top:14px;bottom:0;left:20px;height:100%;white-space:nowrap;overflow:hidden;"]);
const SuggestionList$1 = /*#__PURE__*/styled.ul.withConfig({
  displayName: "search-suggestionsstyles__SuggestionList",
  componentId: "sc-18awqdw-1"
})(["padding:0;margin:0;position:relative;width:inherit;"]);
const Suggestion$1 = /*#__PURE__*/styled.li.withConfig({
  displayName: "search-suggestionsstyles__Suggestion",
  componentId: "sc-18awqdw-2"
})(["display:flex;align-items:center;gap:8px;list-style:none;position:absolute;", ";line-height:normal;color:#666666;opacity:0;transition-property:opacity;transition-duration:", "ms;transition-timing-function:ease;&.categoryText-enter-active,&.categoryText-exit-active{opacity:0.5;}&.categoryText-enter-done{opacity:1;}&.categoryText-exit-done{opacity:0;}"], ({
  theme
}) => theme.typography.SmallHeadline, ANIMATION_DURATION_IN_MS$2);

// todo suggestions for mobile "Monitors and Stuff"

const SearchSuggestions$1 = ({
  suggestions
}) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const updateRandomPlaceholder = useCallback(() => setActiveIndex(Math.floor(Math.random() * suggestions.length)), [suggestions]);
  useEffect(() => {
    updateRandomPlaceholder();
    const categoryNameInterval = setInterval(() => updateRandomPlaceholder(), 5000);
    return () => clearInterval(categoryNameInterval);
  }, [updateRandomPlaceholder]);
  return jsx(Wrap$3, {
    children: jsx(SuggestionList$1, {
      children: suggestions.map((item, index) => jsx(CSSTransition, Object.assign({
        timeout: ANIMATION_DURATION_IN_MS$2,
        classNames: "categoryText",
        in: index === activeIndex,
        out: index !== activeIndex
      }, {
        children: jsx(Suggestion$1, {
          children: item
        })
      }), item))
    })
  });
};

function useDebounce(value, delay) {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    // Update debounced value after delay
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay); // Cancel the timeout if value changes (also on delay change or unmount)
    // This is how we prevent debounced value from updating if value is changed ...
    // .. within the delay period. Timeout gets cleared and restarted.

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}

const Search$1 = ({
  userDevice,
  query,
  onQueryChange,
  categories,
  searchLoading,
  searchResult,
  topLevelCategoriesTitle,
  searchCategoriesShowAllLabel,
  onNavigate,
  storeId,
  store,
  locale,
  sendAnalyticsFunctionFromConsumer,
  consumer
}) => {
  const theme = useContext(ThemeContext);
  const [showSearchContent, setShowSearchContent] = useState(false);
  const inputRef = useRef(null);
  const debouncedQuery = useDebounce(query, 800);

  const handleOpen = () => {
    if (showSearchContent) {
      return;
    }

    handleSearchInputFocus({
      sendAnalyticsFunctionFromConsumer,
      storeId
    });
    setShowSearchContent(true);
  };

  const handleClose = () => {
    handleSearchInputBlur({
      sendAnalyticsFunctionFromConsumer,
      storeId,
      query
    });
    setShowSearchContent(false);
  };

  const handleClear = () => {
    onQueryChange('');
    handleClose();
  };

  const handleNavigation = ({
    url
  }) => {
    onNavigate({
      url
    });
    handleClose();
  };

  const handleSubmit = e => {
    e.preventDefault();
    handleSearchSubmit({
      sendAnalyticsFunctionFromConsumer,
      storeId,
      query
    });
    const url = `/${store}-${locale}/search?filter=search%3D${query}`;

    if (consumer === HeaderConsumer.catalog) {
      return handleNavigation({
        url
      });
    }

    window.location.href = url;
  };

  const handleQueryChange = e => {
    onQueryChange(e.target.value);
  };

  const handleNotImplementedTrackerFunction = () => {
    console.log('Tracking events are not implemented');
  };

  const searchSuggestions = categories.reduce((acc, item) => {
    var _a;

    const subCategories = (_a = item.children) !== null && _a !== void 0 ? _a : [];
    const childrenTitles = subCategories.map(one => `Search for ${one.link.text}...`);
    return [...acc, ...childrenTitles];
  }, []);
  return jsxs(OuterWrap$1, Object.assign({
    "data-testid": "header-search-bar"
  }, {
    children: [jsx(Overlay$3, {
      visible: showSearchContent,
      onClickOverlay: handleClose
    }), jsxs(InnerWrap$1, Object.assign({
      showSearchContent: showSearchContent
    }, {
      children: [jsxs(Form$1, Object.assign({
        onSubmit: handleSubmit,
        showSearchContent: showSearchContent
      }, {
        children: [!query && jsx(SearchSuggestions$1, {
          suggestions: searchSuggestions
        }), jsx(Input, {
          type: "text",
          autoComplete: "false",
          onChange: handleQueryChange,
          value: query,
          onFocus: handleOpen,
          ref: inputRef,
          "aria-label": "SEARCHBAR_SEARCH_INPUT_LABEL",
          "data-testid": "search-input"
        }), jsx(ClearButton$1, Object.assign({
          onClick: handleClear,
          visible: showSearchContent,
          "aria-label": "SEARCHBAR_CLEAR_BUTTON_LABEL",
          type: "button",
          "data-testid": "search-clear-button"
        }, {
          children: jsx(CloseIcon, {
            color: theme.colors.Foreground
          })
        }))]
      })), showSearchContent ? jsx(SearchContent$1, {
        searchCategoriesShowAllLabel: searchCategoriesShowAllLabel,
        isMobile: userDevice === "mobile"
        /* Mobile */
        ,
        isLoading: searchLoading,
        query: debouncedQuery,
        categories: categories,
        searchResult: searchResult,
        onTouchStart: handleNotImplementedTrackerFunction,
        setQuery: title => onQueryChange(title),
        topLevelCategoriesTitle: topLevelCategoriesTitle,
        onNavigate: handleNavigation,
        storeId: storeId,
        sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
      }) : null]
    }))]
  }));
};

const ButtonWrapper$2 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__ButtonWrapper",
  componentId: "sc-4g4wzi-0"
})(["padding-bottom:10px;"]);
const Button$3 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__Button",
  componentId: "sc-4g4wzi-1"
})(["height:48px;padding:0 12px;display:flex;justify-content:center;align-items:center;position:relative;background:", ";border-radius:24px;color:", ";box-shadow:0px 2px 5px rgb(0 0 0 / 13%),0px 0px 3px rgb(0 0 0 / 5%);transition:box-shadow 0.2s cubic-bezier(0.4,0,0.2,1);margin-right:8px;cursor:pointer;&:hover{box-shadow:0px 7px 15px rgb(0 0 0 / 13%),0px 0px 3px rgb(0 0 0 / 5%);}&:focus{box-shadow:0px 4px 10px rgb(0 0 0 / 13%),0px 0px 3px rgb(0 0 0 / 5%);}"], ({
  theme
}) => theme.colors.ElementBackground, ({
  theme
}) => theme.colors.Foreground);
const CategoryButtonText = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__CategoryButtonText",
  componentId: "sc-4g4wzi-2"
})(["", ";color:", ";margin:0 4px 0 8px;"], ({
  theme
}) => theme.typography.SmallHeadline, ({
  theme
}) => theme.colors.Foreground);

const CirclePaths = ['M7.58594 7.21875C7.2207 7.69336 6.64648 8 6 8C5.54883 8 5.13281 7.85156 4.79688 7.59961C4.3125 7.23438 4 6.6543 4 6C4 4.89453 4.89453 4 6 4C7.10547 4 8 4.89453 8 6C8 6.45898 7.8457 6.88281 7.58594 7.21875Z', 'M13.5859 7.21875C13.2207 7.69336 12.6465 8 12 8C11.5488 8 11.1328 7.85156 10.7969 7.59961C10.3125 7.23438 10 6.6543 10 6C10 4.89453 10.8945 4 12 4C13.1055 4 14 4.89453 14 6C14 6.45898 13.8457 6.88281 13.5859 7.21875Z', 'M19.5859 7.21875C19.2207 7.69336 18.6465 8 18 8C17.5488 8 17.1328 7.85156 16.7969 7.59961C16.3125 7.23438 16 6.6543 16 6C16 4.89453 16.8945 4 18 4C19.1055 4 20 4.89453 20 6C20 6.45898 19.8457 6.88281 19.5859 7.21875Z', 'M8 12C8 13.1055 7.10547 14 6 14C4.89453 14 4 13.1055 4 12C4 10.8945 4.89453 10 6 10C6.64062 10 7.21094 10.3008 7.57617 10.7695C7.8418 11.1094 8 11.5352 8 12Z', 'M14 12C14 13.1055 13.1055 14 12 14C10.8945 14 10 13.1055 10 12C10 10.8945 10.8945 10 12 10C12.6406 10 13.2109 10.3008 13.5762 10.7695C13.8418 11.1094 14 11.5352 14 12Z', 'M20 12C20 13.1055 19.1055 14 18 14C16.8945 14 16 13.1055 16 12C16 10.8945 16.8945 10 18 10C18.6406 10 19.2109 10.3008 19.5762 10.7695C19.8418 11.1094 20 11.5352 20 12Z', 'M7.70117 19.0527C7.89062 18.748 8 18.3867 8 18C8 16.8945 7.10547 16 6 16C4.89453 16 4 16.8945 4 18C4 19.1055 4.89453 20 6 20C6.71875 20 7.34961 19.6211 7.70117 19.0527Z', 'M13.7012 19.0527C13.8906 18.748 14 18.3867 14 18C14 16.8945 13.1055 16 12 16C10.8945 16 10 16.8945 10 18C10 19.1055 10.8945 20 12 20C12.7188 20 13.3496 19.6211 13.7012 19.0527Z', 'M19.7012 19.0527C19.8906 18.748 20 18.3867 20 18C20 16.8945 19.1055 16 18 16C16.8945 16 16 16.8945 16 18C16 19.1055 16.8945 20 18 20C18.7188 20 19.3496 19.6211 19.7012 19.0527Z'];
const ANIMATION_DURATION_IN_MS$1 = 500;
const ANIMATION_DELAY_IN_MS = 20;
const ANIMATION_CLASSNAME = 'category-item-circle';
const ANIMATION_SCALE = 1.25;
const CategoryMenuItemAnimated = /*#__PURE__*/styled.path.withConfig({
  displayName: "category-menu-icon__CategoryMenuItemAnimated",
  componentId: "sc-1lqkqf1-0"
})(["transform-origin:center;fill:", ";&.", "-enter{transform:scale(1);}&.", "-enter-active{transition:", "ms;transform:scale(", ");transition-delay:", "ms;transition-timing-function:cubic-bezier(0,1,0.32,1);}&.", "-enter-done{transform:scale(", ");}&.", "-exit{transform:scale(", ");}&.", "-exit-active{transition:", "ms;transform:scale(1);transition-delay:", "ms;transition-timing-function:cubic-bezier(0,1,0.32,1);}&.", "-exit-done{transform:scale(1);}"], ({
  theme
}) => theme.colors.Foreground, ANIMATION_CLASSNAME, ANIMATION_CLASSNAME, ANIMATION_DURATION_IN_MS$1, ANIMATION_SCALE, ({
  delay
}) => delay, ANIMATION_CLASSNAME, ANIMATION_SCALE, ANIMATION_CLASSNAME, ANIMATION_SCALE, ANIMATION_CLASSNAME, ANIMATION_DURATION_IN_MS$1, ({
  delay
}) => delay, ANIMATION_CLASSNAME);
const CategoryMenuIcon = ({
  active
}) => {
  return jsx("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: CirclePaths.map((pathData, index) => jsx(CSSTransition, Object.assign({
      in: active,
      timeout: ANIMATION_DURATION_IN_MS$1,
      classNames: ANIMATION_CLASSNAME
    }, {
      children: jsx(CategoryMenuItemAnimated //Create staggered effect by using the index as a delay multiplier
      , {
        //Create staggered effect by using the index as a delay multiplier
        delay: index * ANIMATION_DELAY_IN_MS,
        d: pathData
      })
    }), index))
  }));
};

function Svg({
  svgPath,
  isTransparent = false
}) {
  const theme = useTheme();
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: svgPath,
      fill: isTransparent ? theme.colors.Background : theme.colors.Foreground
    })
  }));
}

const useIsMounted = () => {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(() => true);
  }, []);
  return isMounted;
};

const useWindowLocation = () => {
  const isMounted = useIsMounted();
  const [location, setLocation] = useState(isMounted ? window.location : undefined);
  useEffect(() => {
    if (!isMounted) return;

    const setWindowLocation = () => {
      setLocation(window.location);
    };

    if (!location) {
      setWindowLocation();
    }

    window.addEventListener('popstate', setWindowLocation);
    return () => {
      window.removeEventListener('popstate', setWindowLocation);
    };
  }, [isMounted, location]);
  return location;
};

var tryToString$2 = tryToString$5;

var $TypeError$3 = TypeError;

var deletePropertyOrThrow$1 = function (O, P) {
  if (!delete O[P]) throw $TypeError$3('Cannot delete property ' + tryToString$2(P) + ' of ' + tryToString$2(O));
};

var arraySlice = arraySliceSimple;

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice(array, 0, middle), comparefn),
    mergeSort(arraySlice(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

var arraySort = mergeSort;

var userAgent$1 = engineUserAgent;

var firefox = userAgent$1.match(/firefox\/(\d+)/i);

var engineFfVersion = !!firefox && +firefox[1];

var UA = engineUserAgent;

var engineIsIeOrEdge = /MSIE|Trident/.test(UA);

var userAgent = engineUserAgent;

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

var engineWebkitVersion = !!webkit && +webkit[1];

var $$3 = _export;
var uncurryThis$2 = functionUncurryThis;
var aCallable$2 = aCallable$5;
var toObject = toObject$5;
var lengthOfArrayLike$1 = lengthOfArrayLike$5;
var deletePropertyOrThrow = deletePropertyOrThrow$1;
var toString$1 = toString$9;
var fails$1 = fails$n;
var internalSort = arraySort;
var arrayMethodIsStrict = arrayMethodIsStrict$2;
var FF = engineFfVersion;
var IE_OR_EDGE = engineIsIeOrEdge;
var V8 = engineV8Version;
var WEBKIT = engineWebkitVersion;

var test = [];
var un$Sort = uncurryThis$2(test.sort);
var push = uncurryThis$2(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails$1(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails$1(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails$1(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString$1(x) > toString$1(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$$3({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable$2(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? un$Sort(array) : un$Sort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike$1(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = items.length;
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});

var $$2 = _export;
var $includes = arrayIncludes.includes;
var fails = fails$n;
var addToUnscopables = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$2({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var isRegExp = isRegexp;

var $TypeError$2 = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw $TypeError$2("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$2 = wellKnownSymbol$g;

var MATCH = wellKnownSymbol$2('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$1 = _export;
var uncurryThis$1 = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$7;
var toString = toString$9;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf = uncurryThis$1(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$1({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

const ItemText = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__ItemText",
  componentId: "x1eiiz-0"
})(["", ";flex-grow:1;&:only-child{margin-left:32px;}"], ({
  theme
}) => theme.typography.SmallHeadline);

const StoreIcon = ({
  testId
}) => {
  const theme = useContext(ThemeContext);
  return jsx("svg", Object.assign({
    "data-testid": testId,
    width: "24",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10ZM12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8Z M20 10C20 15.1262 16.2107 19.6811 12 22.1578C7.79326 19.7009 4 15.1084 4 10C4 5.54688 7.63281 2 12 2C16.3672 2 20 5.53906 20 10ZM6 10C6 13.9802 8.85959 17.6634 12 19.81C15.1404 17.6634 18 13.9802 18 10C18 6.52757 15.1484 4 12 4C8.85156 4 6 6.57031 6 10Z",
      fill: theme.colors.Foreground
    })
  }));
};

const StoreDropdown = ({
  className,
  storeOptions,
  activeStore,
  handleChangeStore
}) => {
  const onChangeStore = ({
    value
  }) => {
    handleChangeStore === null || handleChangeStore === void 0 ? void 0 : handleChangeStore(value);
  };

  const storeOptionsWithIcon = storeOptions.map(store => Object.assign(Object.assign({}, store), {
    icon: store.value === activeStore ? jsx(StoreIcon, {}) : undefined
  })).sort((a, b) => a.value === activeStore ? -1 : b.value === activeStore ? 1 : 0).filter(({
    value
  }) => {
    if (!activeStore) return false;
    const activeAndOptionAreB2B = activeStore.includes('business') && String(value).includes('business');
    const activeAndOptionAreB2C = !activeStore.includes('business') && !String(value).includes('business');
    return activeAndOptionAreB2B || activeAndOptionAreB2C;
  });
  const defaultStoreOption = storeOptions.find(({
    value
  }) => value === activeStore) || storeOptions[0];
  return jsx(DropDown, {
    className: className,
    options: storeOptionsWithIcon,
    defaultValue: defaultStoreOption,
    onChange: onChangeStore,
    overrides: {
      ItemText: {
        component: ItemText
      }
    }
  });
};

const LocaleIcon = ({
  testId
}) => {
  const theme = useContext(ThemeContext);
  return jsx("svg", Object.assign({
    "data-testid": testId,
    width: "24",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10Zm-8.253 6.177C12.948 19.774 12.215 20 12 20c-.215 0-.948-.226-1.747-1.823-.639-1.278-1.11-3.083-1.226-5.177h5.946c-.116 2.094-.587 3.899-1.226 5.177ZM14.973 11H9.027c.116-2.094.587-3.899 1.226-5.177C11.052 4.226 11.785 4 12 4c.215 0 .948.226 1.747 1.823.639 1.278 1.11 3.083 1.226 5.177Zm2.002 2c-.12 2.434-.678 4.61-1.512 6.214A8.007 8.007 0 0 0 19.938 13h-2.963Zm2.963-2h-2.963c-.12-2.434-.678-4.61-1.512-6.214A8.007 8.007 0 0 1 19.938 11ZM7.025 11c.12-2.434.678-4.61 1.512-6.214A8.007 8.007 0 0 0 4.062 11h2.963Zm-2.963 2a8.007 8.007 0 0 0 4.475 6.214C7.703 17.61 7.145 15.434 7.025 13H4.062Z",
      fill: theme.colors.Foreground
    })
  }));
};

const LocaleDropdown = ({
  className,
  handleChangeLocale,
  localeOptions,
  activeLocale
}) => {
  const onChangeLocale = ({
    value
  }) => {
    handleChangeLocale === null || handleChangeLocale === void 0 ? void 0 : handleChangeLocale(value);
  };

  const localeOptionsWithIcon = localeOptions.map(locale => Object.assign(Object.assign({}, locale), {
    icon: locale.value === activeLocale ? jsx(LocaleIcon, {}) : undefined
  })).sort((a, b) => a.value === activeLocale ? -1 : b.value === activeLocale ? 1 : 0);
  const defaultLocaleOption = localeOptions.find(({
    value
  }) => value === activeLocale) || localeOptions[0];
  return jsx(DropDown, {
    className: className,
    options: localeOptionsWithIcon,
    defaultValue: defaultLocaleOption,
    onChange: onChangeLocale,
    overrides: {
      ItemText: {
        component: ItemText
      }
    }
  });
};

const Content$2 = /*#__PURE__*/styled.nav.withConfig({
  displayName: "styles__Content",
  componentId: "sc-1fh67hl-0"
})(["margin-top:auto;min-height:100%;background:", ";transition:all 0.2s cubic-bezier(0.4,0,1,1);transform:translateX(-100%);", ";"], ({
  theme
}) => theme.colors.Background, ({
  active
}) => active && `
            transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);
            transform: translateX(0%);
        `);
const PageLinksWrapper = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styles__PageLinksWrapper",
  componentId: "sc-1fh67hl-1"
})(["display:flex;flex-direction:column;padding:16px 0;margin:0;border-bottom:", ";"], ({
  theme
}) => `2px solid ${theme.colors['Level 1']}`);
const IconWrapper$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__IconWrapper",
  componentId: "sc-1fh67hl-2"
})(["margin-right:16px;"]);
const Item$1 = /*#__PURE__*/styled.li.withConfig({
  displayName: "styles__Item",
  componentId: "sc-1fh67hl-3"
})(["display:flex;align-items:center;min-height:48px;padding:0 16px;a{", ";color:", ";text-decoration:none;display:flex;align-items:center;}"], ({
  theme
}) => theme.typography.SmallHeadline, ({
  theme
}) => theme.colors.Foreground);
const MobileCategoriesWrapper = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styles__MobileCategoriesWrapper",
  componentId: "sc-1fh67hl-4"
})(["display:flex;flex-direction:column;padding:16px 0;margin:0;"]);
const MobileOptionsLinks = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styles__MobileOptionsLinks",
  componentId: "sc-1fh67hl-5"
})(["display:flex;flex-direction:column;margin-top:16px;padding-left:0;margin-bottom:0;"]);
const OptionsLinkWrapper = /*#__PURE__*/styled.li.withConfig({
  displayName: "styles__OptionsLinkWrapper",
  componentId: "sc-1fh67hl-6"
})(["display:flex;align-items:center;min-height:48px;padding:0 16px;a,button{", ";color:", ";text-decoration:none;border:none;background:none;padding:0;}"], ({
  theme
}) => theme.typography.SmallCapsHeadline, ({
  theme
}) => theme.colors.Foreground);
const CategoryIcon$1 = /*#__PURE__*/styled(SonntagIcon).withConfig({
  displayName: "styles__CategoryIcon",
  componentId: "sc-1fh67hl-7"
})(["margin-right:", ";position:relative;"], ({
  theme
}) => theme.spacers.L);
const LocaleDropDown = /*#__PURE__*/styled(LocaleDropdown).withConfig({
  displayName: "styles__LocaleDropDown",
  componentId: "sc-1fh67hl-8"
})(["margin-bottom:0;> div{border-radius:0;}"]);
const StoreDropDown = /*#__PURE__*/styled(StoreDropdown).withConfig({
  displayName: "styles__StoreDropDown",
  componentId: "sc-1fh67hl-9"
})(["height:250px;margin-bottom:0;> div{border-radius:0;}"]);

const Container$2 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__Container",
  componentId: "co1dkx-0"
})(["-webkit-tap-highlight-color:transparent;cursor:pointer;position:fixed;bottom:0;left:0;right:0;top:0;overflow-y:auto;background:none;visibility:hidden;z-index:10;display:flex;justify-content:flex-start;align-items:center;height:100vh;", ";", ""], transition('all', 'long-mobile', 'out'), ({
  visible
}) => visible && `
            background: rgba(0, 0, 0, 0.5);
            visibility: visible;
            ${transition('all', 'long-mobile', 'in')};
        `);

const Overlay$2 = ({
  className,
  children,
  visible,
  id,
  onClickOverlay
}) => {
  const {
    lockScroll,
    unlockScroll
  } = useScrollLock();
  useEffect(() => {
    if (visible) {
      lockScroll();
    } else {
      unlockScroll();
    }
  }, [visible, lockScroll, unlockScroll]);
  return jsx(Container$2, Object.assign({
    className: className,
    visible: visible,
    id: id || undefined,
    onClick: onClickOverlay
  }, {
    children: children
  }));
};

function CategoryMenuMobile({
  active,
  onNavigate,
  loggedIn,
  handleLogin,
  handleLogout,
  handleChangeLocale,
  handleChangeStore,
  hideMobileMenu,
  activeStore,
  activeLocale,
  categoryMenuData: {
    categories,
    logoutButtonText,
    localeOptions,
    storeOptions,
    mobileLinks: pageLinks,
    mobileOptionLinks,
    signinButtonText
  },
  storeId,
  onLinkClick,
  sendAnalyticsFunctionFromConsumer,
  trackLoginEvent,
  onSupportClick
}) {
  var _a;

  const menuRef = useRef(null);
  const location = useWindowLocation();
  useOnClickOutside(menuRef, hideMobileMenu);
  useEffect(() => {
    hideMobileMenu();
  }, [location, hideMobileMenu]);
  const onLogin = useCallback(() => {
    handleLogin === null || handleLogin === void 0 ? void 0 : handleLogin();
    hideMobileMenu();
    if (trackLoginEvent) handleLoginButtonClick({
      storeId,
      sendAnalyticsFunctionFromConsumer
    });
  }, [handleLogin, hideMobileMenu, sendAnalyticsFunctionFromConsumer, storeId, trackLoginEvent]);
  const onLogout = useCallback(() => {
    handleLogout === null || handleLogout === void 0 ? void 0 : handleLogout();
    hideMobileMenu();
  }, [handleLogout, hideMobileMenu]);

  const handleCategoryOnClick = e => {
    var _a;

    const url = (_a = e === null || e === void 0 ? void 0 : e.currentTarget) === null || _a === void 0 ? void 0 : _a.href;
    handleCategoryMenuLinkClick({
      storeId,
      url,
      sendAnalyticsFunctionFromConsumer
    });
  };

  const handleOnClickWithSupport = (e, link) => {
    //map no navigate link to support(dixa)
    if (link.preventDefault) {
      onSupportClick === null || onSupportClick === void 0 ? void 0 : onSupportClick();
    }

    onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick(e, link);
  };

  return jsx(Overlay$2, Object.assign({
    visible: active
  }, {
    children: jsxs(Content$2, Object.assign({
      ref: menuRef,
      active: active
    }, {
      children: [jsx(PageLinksWrapper, {
        children: pageLinks && pageLinks.map(link => jsxs(Item$1, {
          children: [jsx(IconWrapper$1, {
            children: link.svgPath && jsx(Svg, {
              svgPath: link.svgPath
            })
          }), jsx(Link$2, {
            link: link,
            onNavigate: onNavigate,
            onClick: event => onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick(event, link)
          })]
        }, link.text))
      }), jsx(MobileCategoriesWrapper, {
        children: (_a = categories === null || categories === void 0 ? void 0 : categories.map(({
          id,
          link
        }) => jsx(Item$1, {
          children: jsxs(Link$2, Object.assign({
            link: link,
            onNavigate: onNavigate,
            onClick: handleCategoryOnClick
          }, {
            children: [link.svgPath ? jsx(CategoryIcon$1, {
              iconPath: link.svgPath
            }) : null, jsx("span", {
              children: link.text
            })]
          }))
        }, id))) !== null && _a !== void 0 ? _a : null
      }), jsxs(MobileOptionsLinks, {
        children: [jsx(OptionsLinkWrapper, {
          children: loggedIn ? jsx("button", Object.assign({
            onClick: onLogout
          }, {
            children: logoutButtonText
          })) : jsx("button", Object.assign({
            onClick: onLogin
          }, {
            children: signinButtonText
          }))
        }), mobileOptionLinks.map(link => jsx(OptionsLinkWrapper, {
          children: jsx(Link$2, {
            link: link,
            onNavigate: onNavigate,
            onClick: handleOnClickWithSupport
          })
        }, link.text))]
      }), jsx(LocaleDropDown, {
        localeOptions: localeOptions,
        activeLocale: activeLocale,
        handleChangeLocale: handleChangeLocale
      }), jsx(StoreDropDown, {
        storeOptions: storeOptions,
        activeStore: activeStore,
        handleChangeStore: handleChangeStore
      })]
    }))
  }));
}

function pointInPolygon(point, vs) {
  const x = point.x;
  const y = point.y;
  let inside = false;

  for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
    const xi = vs[i].x;
    const yi = vs[i].y;
    const xj = vs[j].x;
    const yj = vs[j].y;
    const intersect = yi > y != yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }

  return inside;
}
function getTriangleZone(target, point) {
  const {
    left,
    top,
    bottom
  } = target;
  return [point, {
    x: left,
    y: top
  }, {
    x: left,
    y: bottom
  }];
}
const useMouseHistory = () => {
  const mouseHistory = useRef([]);

  const addToMouseHistory = p => {
    mouseHistory.current.push(p);

    if (mouseHistory.current.length > 3) {
      mouseHistory.current.shift();
    }
  };

  return {
    mouseHistory,
    addToMouseHistory
  };
};
const useElements = () => {
  const sources = useRef([]);
  const targets = useRef([]);

  const callSourceCallback = el => {
    var _a;

    if (!el) return;
    (_a = sources.current.find(src => src.el === el)) === null || _a === void 0 ? void 0 : _a.cb();
  };

  return {
    sources,
    targets,
    callSourceCallback
  };
};
function childWithProps(children, events) {
  let child = Children.only(children);

  if ( /*#__PURE__*/isValidElement(child)) {
    child = /*#__PURE__*/cloneElement(child, events);
  }

  return child;
}
const isUserAimingToTargets = (targets, previousMousePos, currentMousePos) => {
  return targets.some(t => {
    const target = t.getBoundingClientRect();
    if (!target) return false;
    const triangle = getTriangleZone(target, previousMousePos);
    const inTriangle = pointInPolygon(currentMousePos, triangle);
    return inTriangle;
  });
};
const isPointInsideElement = (p, el) => {
  const rect = el.getBoundingClientRect();
  return pointInPolygon(p, [{
    x: rect.left,
    y: rect.top
  }, {
    x: rect.right,
    y: rect.top
  }, {
    x: rect.right,
    y: rect.bottom
  }, {
    x: rect.left,
    y: rect.bottom
  }]);
};

function isAcceptedElement(el) {
  return el instanceof HTMLElement || el instanceof SVGElement;
}

const AimIntentContext = /*#__PURE__*/createContext({
  registerSource: () => {// empty default
  },
  registerTarget: () => {// empty default
  },
  unregisterSource: () => {// empty default
  },
  unregisterTarget: () => {// empty default
  }
});

function AimIntentSource({
  children,
  onMouseEnter
}) {
  const {
    registerSource,
    unregisterSource
  } = useContext(AimIntentContext);
  const ref = useRef(null);
  useEffect(() => {
    const r = ref.current;

    if (r) {
      registerSource(r, onMouseEnter);
    }

    return () => {
      if (r) unregisterSource(r);
    };
  }, [ref, unregisterSource, onMouseEnter, registerSource]);
  const child = useMemo(() => {
    return childWithProps(children, {
      ref
    });
  }, [ref, children]);
  return jsx(Fragment$1, {
    children: child
  });
}

function AimIntentTarget({
  children
}) {
  const {
    registerTarget,
    unregisterTarget
  } = useContext(AimIntentContext);
  const ref = useRef(null);
  useEffect(() => {
    const r = ref.current;

    if (r) {
      registerTarget(r);
    }

    return () => {
      if (r) unregisterTarget(r);
    };
  }, [ref, unregisterTarget, registerTarget]);
  const child = useMemo(() => {
    return childWithProps(children, {
      ref
    });
  }, [ref, children]);
  return jsx(Fragment$1, {
    children: child
  });
}

function debounce(fn, timeout) {
  let timerId;
  return function (...args) {
    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => {
      fn(...args);
      timerId = null;
    }, timeout);
  };
}

/**
 * Detects user aim intent for triggering mouse events.
 *
 * Only works on sources that are to the left of targets for now.
 * For the future the getTriangleZone in ./utils needs to be update if we
 * want to support targets being anywhere relative to the sources.
 *
 * @example
 * // myCallback will only be called when the user enters the source div but is not
 * // aiming towards the target div
 * <AimIntent>
 *   <AimIntent.Source onMouseEnter={myCallback}>
 *     <div>My source div</div>
 *   </AimIntent.Source>
 *   <AimIntent.Target>
 *     <div>My target div</div>
 *   </AimIntent.Target>
 * </AimIntent>
 *
 * @example
 * // timeout will ensure that the callback will be called
 * // if the user started aiming towards the target but hasn't
 * // reached the target in 150 milliseconds
 * <AimIntent timeout={150}>
 */

const AimIntent = ({
  children,
  onMouseEnter,
  onMouseLeave,
  timeout: _timeout = 150
}) => {
  const isAiming = useRef(false);
  const isTrackingMouse = useRef(false);
  const lastSourceEntered = useRef(null);
  const {
    mouseHistory,
    addToMouseHistory
  } = useMouseHistory();
  const {
    sources,
    targets,
    callSourceCallback
  } = useElements();
  const stopAiming = useCallback(() => {
    isAiming.current = false;
    mouseHistory.current = [];
  }, []);
  const stopCheckingAfterTimeout = useCallback(debounce(() => {
    if (!isTrackingMouse.current) return;
    callSourceCallback(lastSourceEntered.current);
  }, _timeout), []);
  const trackMovement = useCallback(e => {
    const point = {
      x: e.clientX,
      y: e.clientY
    };
    const previous = mouseHistory.current[0];
    addToMouseHistory(point);
    if (!previous) return;
    stopCheckingAfterTimeout();

    if (isUserAimingToTargets(targets.current, previous, point)) {
      isAiming.current = true;
      return;
    }

    stopAiming();
    if (!(lastSourceEntered.current && isPointInsideElement(point, lastSourceEntered.current))) return;
    callSourceCallback(lastSourceEntered.current);
  }, []);
  const stopTracking = useCallback(() => {
    stopAiming();
    isTrackingMouse.current = false;
    lastSourceEntered.current = null;
    document.removeEventListener('mousemove', trackMovement);
  }, []);
  const startTracking = useCallback(() => {
    isTrackingMouse.current = true;
    document.addEventListener('mousemove', trackMovement);
  }, []);
  const onSourceHover = useCallback(e => {
    if (!isAcceptedElement(e.target)) return;
    lastSourceEntered.current = e.target;
    if (!isTrackingMouse.current) startTracking();
    if (isAiming.current) return;
    callSourceCallback(e.target);
  }, []);
  const onTargetHover = useCallback(e => {
    if (!isAcceptedElement(e.target)) return;
    stopTracking();
  }, []);
  const store = useRef({
    registerSource(el, onMouseEnter) {
      if (sources.current.find(s => s.el === el)) return;
      sources.current.push({
        el,
        cb: onMouseEnter
      });
      el.addEventListener('mouseenter', onSourceHover);
    },

    unregisterSource(el) {
      sources.current = sources.current.filter(s => s.el !== el);
      el.removeEventListener('mouseenter', onSourceHover);
    },

    registerTarget(el) {
      if (targets.current.find(t => t === el)) return;
      targets.current.push(el);
      el.addEventListener('mouseenter', onTargetHover);
    },

    unregisterTarget(el) {
      targets.current = targets.current.filter(t => t !== el);
      el.removeEventListener('mouseenter', onTargetHover);
    }

  });
  const child = childWithProps(children, {
    onMouseEnter: () => {
      onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter();
    },
    onMouseLeave: () => {
      stopTracking();
      onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave();
    }
  });
  useEffect(() => {
    const s = sources;
    const t = targets;
    const st = store.current;
    return () => {
      stopAiming();
      s.current.forEach(s => st.unregisterSource(s.el));
      t.current.forEach(t => st.unregisterTarget(t));
    };
  }, []);
  return jsx(AimIntentContext.Provider, Object.assign({
    value: store.current
  }, {
    children: child
  }));
};
AimIntent.Source = AimIntentSource;
AimIntent.Target = AimIntentTarget;

const CategoryMenuPosition = /*#__PURE__*/styled.div.withConfig({
  displayName: "category-menustyles__CategoryMenuPosition",
  componentId: "s8cdj5-0"
})(["position:absolute;top:60px;visibility:hidden;opacity:0;transform:scale(0.9);z-index:-1;display:flex;background-color:", ";box-shadow:0px 7px 15px rgba(0,0,0,0.13),0px 0px 3px rgba(0,0,0,0.05);border-radius:8px;transition:all 0.2s cubic-bezier(0.4,0,1,1);", ""], ({
  theme
}) => theme.colors.ElementBackground, ({
  active
}) => active && `
        visibility: visible;
        transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);
        opacity: 1;
        z-index: 3;
        transform: scale(1);
    `);
const CategoryMenuWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "category-menustyles__CategoryMenuWrapper",
  componentId: "s8cdj5-1"
})(["display:flex;flex-direction:column;border-radius:8px;min-width:236px;border-radius:8px 0 0 8px;", ""], ({
  active
}) => active && `
        z-index: 3;
    `);
const NavigationLink$3 = /*#__PURE__*/styled(Link$2).withConfig({
  displayName: "category-menustyles__NavigationLink",
  componentId: "s8cdj5-2"
})(["display:flex;align-items:center;height:48px;padding:0 16px;cursor:pointer;text-decoration:none;overflow:hidden;&:first-child{border-radius:8px 0 0 0;}", ""], ({
  active,
  theme
}) => active && `background-color: ${theme.colors['Level 1']};`);
const Icon$1 = /*#__PURE__*/styled(SonntagIcon).withConfig({
  displayName: "category-menustyles__Icon",
  componentId: "s8cdj5-3"
})(["margin-right:", ";position:relative;fill:", ";"], ({
  theme
}) => theme.spacers.L, ({
  isActiveCategory,
  theme
}) => isActiveCategory ? theme.colors.Foreground : theme.colors['Level 5']);
const CategoryText = /*#__PURE__*/styled.div.withConfig({
  displayName: "category-menustyles__CategoryText",
  componentId: "s8cdj5-4"
})(["", ";color:", ";"], ({
  theme
}) => theme.typography.SmallHeadline, ({
  theme
}) => `${theme.colors.Foreground}`);
const SubcategoryMenu = /*#__PURE__*/styled.div.withConfig({
  displayName: "category-menustyles__SubcategoryMenu",
  componentId: "s8cdj5-5"
})(["background-color:", ";border-radius:0 8px 8px 0;"], ({
  theme
}) => theme.colors['Level 1']);
const ViewAllLink = /*#__PURE__*/styled(Link$2).withConfig({
  displayName: "category-menustyles__ViewAllLink",
  componentId: "s8cdj5-6"
})(["text-decoration:none;display:flex;margin:8px 16px 24px;"]);

const CategoryMenu = ({
  active,
  hideCategoryMenu,
  onMouseEnter,
  categories,
  viewAllButtonText,
  onNavigate,
  storeId,
  sendAnalyticsFunctionFromConsumer
}) => {
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeSubCategoryId, setActiveSubCategoryId] = useState(null);

  const handleHoverCategory = id => {
    const category = categories === null || categories === void 0 ? void 0 : categories.find(category => category.id === id);
    if (category) setActiveCategory(category);
  };

  const handleCloseMenus = () => {
    setActiveCategory(null);
    hideCategoryMenu();
  };

  const handleClick = e => {
    var _a;

    const url = (_a = e === null || e === void 0 ? void 0 : e.currentTarget) === null || _a === void 0 ? void 0 : _a.href;
    handleCategoryMenuLinkClick({
      storeId,
      url,
      sendAnalyticsFunctionFromConsumer
    });

    if (e.metaKey || e.ctrlKey) {
      return;
    }

    handleCloseMenus();
  };

  return jsx(AimIntent, Object.assign({
    onMouseEnter: onMouseEnter,
    onMouseLeave: handleCloseMenus
  }, {
    children: jsxs(CategoryMenuPosition, Object.assign({
      active: active,
      "data-testid": "desktop-category-menu"
    }, {
      children: [jsx(CategoryMenuWrapper, Object.assign({
        active: active
      }, {
        children: categories.map(({
          id,
          link
        }) => jsx(AimIntent.Source, Object.assign({
          onMouseEnter: () => handleHoverCategory(id)
        }, {
          children: jsx("div", {
            children: jsxs(NavigationLink$3, Object.assign({
              link: link,
              onNavigate: onNavigate,
              onClick: handleClick,
              active: (activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.id) === id,
              testId: "desktop-category-menu-link"
            }, {
              children: [link.svgPath ? jsx(Icon$1, {
                iconPath: link.svgPath,
                isActiveCategory: (activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.id) === id
              }) : null, jsx(CategoryText, {
                children: link.text
              })]
            }))
          })
        }), id))
      })), (activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.children) ? jsx(AimIntent.Target, {
        children: jsxs(SubcategoryMenu, Object.assign({
          "data-testid": "desktop-subcategory-menu"
        }, {
          children: [activeCategory.children.map(({
            id,
            link
          }) => jsxs(NavigationLink$3, Object.assign({
            link: link,
            onClick: handleClick,
            onNavigate: onNavigate,
            onMouseEnter: () => setActiveSubCategoryId(id),
            "data-testid": "desktop-subcategory-menu-link"
          }, {
            children: [link.svgPath ? jsx(Icon$1, {
              iconPath: link.svgPath,
              isActiveCategory: activeSubCategoryId === id
            }) : null, jsx(CategoryText, {
              children: link.text
            })]
          }))), jsx(ViewAllLink, Object.assign({
            link: activeCategory.link,
            onNavigate: onNavigate
          }, {
            children: jsx(ButtonV2, Object.assign({
              small: true,
              color: "black"
            }, {
              children: viewAllButtonText
            }))
          }))]
        }))
      }) : null]
    }))
  }));
};

function CategoryButton({
  onNavigate,
  handleChangeLocale,
  handleChangeStore,
  handleLogin,
  handleLogout,
  categoryMenuData,
  loggedIn,
  activeStore,
  activeLocale,
  userDevice,
  storeId,
  sendAnalyticsFunctionFromConsumer,
  onLinkClick,
  trackLoginEvent,
  onSupportClick
}) {
  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const [categoryMenuActive, setCategoryMenuActive] = useState(false);
  const desktop = userDevice === "desktop"
  /* Desktop */
  ;
  const handleCategoryButtonClick = useCallback(() => {
    if (desktop) {
      setCategoryMenuActive(true);
    } else {
      setMobileMenuActive(true);
    }
  }, [desktop]);
  const showCategoryMenu = useCallback(() => {
    setCategoryMenuActive(true);
  }, []);
  const hideCategoryMenu = useCallback(() => {
    setCategoryMenuActive(false);
  }, []);
  const hideMobileMenu = useCallback(() => {
    setMobileMenuActive(false);
  }, []);

  const renderCategoryButtonText = () => {
    if (!desktop) {
      return null;
    }

    return jsx(CategoryButtonText, {
      children: categoryMenuData.categoriesButtonText
    });
  };

  return jsxs(Fragment$1, {
    children: [jsx(ButtonWrapper$2, Object.assign({
      onMouseLeave: hideCategoryMenu
    }, {
      children: jsxs(Button$3, Object.assign({
        onClick: handleCategoryButtonClick,
        onMouseEnter: showCategoryMenu,
        "data-testid": "category-button"
      }, {
        children: [jsx(CategoryMenuIcon, {
          active: categoryMenuActive
        }), renderCategoryButtonText()]
      }))
    })), desktop && jsx(CategoryMenu, {
      onNavigate: onNavigate,
      active: categoryMenuActive,
      onMouseEnter: showCategoryMenu,
      hideCategoryMenu: hideCategoryMenu,
      viewAllButtonText: categoryMenuData.viewAllButtonText,
      sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer,
      categories: categoryMenuData.categories,
      storeId: storeId
    }), !desktop && jsx(CategoryMenuMobile, {
      active: mobileMenuActive,
      hideMobileMenu: hideMobileMenu,
      handleChangeLocale: handleChangeLocale,
      handleChangeStore: handleChangeStore,
      handleLogin: handleLogin,
      handleLogout: handleLogout,
      onNavigate: onNavigate,
      loggedIn: loggedIn,
      activeStore: activeStore,
      activeLocale: activeLocale,
      categoryMenuData: categoryMenuData,
      onLinkClick: onLinkClick,
      storeId: storeId,
      sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer,
      trackLoginEvent: trackLoginEvent,
      onSupportClick: onSupportClick
    })]
  });
}

function Categories({
  onNavigate,
  handleChangeLocale,
  handleChangeStore,
  handleLogout,
  handleLogin,
  categoryMenuData,
  loggedIn,
  activeStore,
  activeLocale,
  userDevice,
  storeId,
  sendAnalyticsFunctionFromConsumer,
  onLinkClick,
  trackLoginEvent,
  onSupportClick
}) {
  return jsx(CategoryButton, {
    onNavigate: onNavigate,
    handleChangeLocale: handleChangeLocale,
    handleChangeStore: handleChangeStore,
    handleLogout: handleLogout,
    handleLogin: handleLogin,
    categoryMenuData: categoryMenuData,
    loggedIn: loggedIn,
    activeStore: activeStore,
    activeLocale: activeLocale,
    userDevice: userDevice,
    storeId: storeId,
    sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer,
    onLinkClick: onLinkClick,
    trackLoginEvent: trackLoginEvent,
    onSupportClick: onSupportClick
  });
}

const RootWrapper$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "wrappersstyles__RootWrapper",
  componentId: "sc-5pikcv-0"
})(["padding-bottom:4px;"]);
const TopWrapper$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "wrappersstyles__TopWrapper",
  componentId: "sc-5pikcv-1"
})(["position:relative;height:", ";display:flex;justify-content:space-between;align-items:center;"], props => props.mobile ? '32px' : '48px');
const BottomWrapper$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "wrappersstyles__BottomWrapper",
  componentId: "sc-5pikcv-2"
})(["align-items:flex-start;justify-content:space-between;height:58px;position:relative;display:flex;width:100%;margin-top:16px;"]);

function GroverBusinessSvg() {
  const theme = useTheme();
  const fill = theme.type === 'dark' ? '#FFF' : '#1A1A1A';
  return jsxs("svg", Object.assign({
    viewBox: "0 0 307 92",
    fill: "none",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      d: "M163.627 31.7569V24.7949C163.627 24.3854 163.261 24.0669 162.848 24.0669C157.26 24.2944 153.87 26.7061 151.947 28.7537C147.183 33.8956 147.503 40.9486 147.503 42.6777V58.1488C147.503 58.5583 147.824 58.8769 148.236 58.8769H155.29C155.703 58.8769 156.023 58.5583 156.023 58.1488V42.3137C156.023 42.3137 155.703 37.1718 158.222 34.4416C159.321 33.2585 160.879 32.6215 162.94 32.485C163.307 32.485 163.627 32.1665 163.627 31.7569Z",
      fill: "#FE1251"
    }), jsx("path", {
      d: "M293.809 31.7569V24.7949C293.809 24.3854 293.443 24.0669 293.03 24.0669C287.442 24.2944 284.006 26.7061 282.128 28.7537C277.365 33.8956 277.685 40.9486 277.685 42.6777V58.1488C277.685 58.5583 278.006 58.8769 278.418 58.8769H285.426C285.839 58.8769 286.159 58.5583 286.159 58.1488V42.3137C286.159 42.3137 285.839 37.1718 288.358 34.4416C289.457 33.2585 291.015 32.6215 293.076 32.485C293.534 32.485 293.809 32.1665 293.809 31.7569Z",
      fill: "#FE1251"
    }), jsx("path", {
      d: "M51.9968 63.7002C39.3542 63.7002 29.0936 53.5075 29.0936 40.9486C29.0936 28.3897 39.3542 18.197 51.9968 18.197C64.6394 18.197 74.9 28.3897 74.9 40.9486C74.9 53.5075 64.6394 63.7002 51.9968 63.7002ZM85.9852 20.6087C85.0691 17.2414 83.6491 14.1472 81.3588 11.781C78.9768 9.50588 75.8162 8.09528 72.4723 7.18521C63.6317 4.77354 53.4626 4.86455 44.5762 6.91219C35.5523 8.91434 29.0478 14.7387 23.7342 22.0193C18.7871 28.7537 14.1149 37.1263 13.4278 45.5899C12.7407 54.4631 17.1839 62.9722 23.5968 69.1151C29.7807 75.4855 38.3465 79.8994 47.2788 79.2168C55.7988 78.5343 64.2271 73.8929 71.0065 69.0241C78.3355 63.7457 84.1988 57.2843 86.2142 48.3656C88.3213 39.4925 88.4129 29.3908 85.9852 20.6087Z",
      fill: "#FE1251"
    }), jsx("path", {
      d: "M230.688 24.7039L219.19 49.6852L207.693 24.7039C207.51 24.3399 207.143 24.0669 206.685 24.0669H199.906C199.356 24.0669 199.036 24.6129 199.265 25.068L214.61 58.4218C214.747 58.6948 214.976 58.8313 215.297 58.8313H223.084C223.359 58.8313 223.634 58.6493 223.771 58.4218L239.116 25.1135C239.345 24.6584 238.979 24.1124 238.475 24.1124H231.696C231.283 24.0669 230.871 24.3399 230.688 24.7039Z",
      fill: "#FE1251"
    }), jsx("path", {
      d: "M246.079 37.2628L246.17 37.0808C247.911 33.3951 251.667 31.0289 255.79 31.0289C259.912 31.0289 263.668 33.3951 265.409 37.0808L265.501 37.2628H246.079ZM254.782 23.2478C245.437 23.7484 237.834 31.2564 237.376 40.5391C236.826 51.0958 245.3 59.8779 255.79 59.8779C261.653 59.8779 267.15 57.1022 270.585 52.4609C270.814 52.1424 270.768 51.6418 270.402 51.4143L265.043 47.9561C264.722 47.7741 264.31 47.8196 264.081 48.0926C262.065 50.5953 259.042 52.0514 255.79 52.0514C251.117 52.0514 247.041 49.0937 245.621 44.6343L245.575 44.4523H265.959H273.379C273.746 44.4523 274.067 44.1793 274.112 43.8153C274.204 43.0417 274.25 42.2682 274.25 41.4491C274.25 31.1199 265.409 22.7018 254.782 23.2478Z",
      fill: "#FE1251"
    }), jsx("path", {
      d: "M182.591 52.0969C176.728 52.0969 171.964 47.3645 171.964 41.5401C171.964 35.7157 176.728 30.9834 182.591 30.9834C188.454 30.9834 193.218 35.7157 193.218 41.5401C193.218 47.3645 188.454 52.0969 182.591 52.0969ZM182.591 23.2023C172.422 23.2023 164.131 31.4384 164.131 41.5401C164.131 51.6418 172.422 59.8779 182.591 59.8779C192.76 59.8779 201.051 51.6418 201.051 41.5401C201.051 31.4384 192.76 23.2023 182.591 23.2023Z",
      fill: "#FE1251"
    }), jsx("path", {
      d: "M121.21 18.197C108.568 18.197 98.3071 28.3897 98.3071 40.9486C98.3071 53.5075 108.568 63.7002 121.21 63.7002C133.853 63.7002 144.114 53.5075 144.114 40.9486C144.114 39.7655 144.022 38.5369 143.839 37.3538C143.793 36.9898 143.472 36.7168 143.106 36.7168H122.859C122.447 36.7168 122.126 37.0353 122.126 37.4448V44.4068C122.126 44.8164 122.447 45.1349 122.859 45.1349H135.09L135.044 45.3169C133.074 51.4143 127.394 55.4641 120.89 55.3731C112.919 55.1911 106.506 48.5476 106.69 40.6756C106.873 32.849 113.286 26.5696 121.21 26.5696C125.837 26.5696 130.188 28.7537 132.891 32.4395C133.12 32.758 133.532 32.8035 133.853 32.6215L139.67 28.8902C140.037 28.6627 140.128 28.2077 139.854 27.8437C135.594 21.7462 128.677 18.197 121.21 18.197Z",
      fill: "#FE1251"
    }), jsx("path", {
      d: "M168.299 87.3164V68.9786H174.529C175.72 68.9786 176.728 69.2061 177.552 69.6156C178.377 70.0251 178.972 70.6167 179.339 71.3447C179.705 72.0728 179.934 72.8918 179.934 73.8019C179.934 74.5755 179.797 75.2125 179.522 75.7586C179.247 76.3046 178.927 76.7596 178.468 77.0782C178.01 77.3967 177.552 77.6697 177.003 77.8062V77.9427C177.598 77.9882 178.194 78.2157 178.743 78.5798C179.293 78.9438 179.751 79.4898 180.117 80.1269C180.484 80.8094 180.667 81.583 180.667 82.5385C180.667 83.4486 180.438 84.2677 180.026 84.9957C179.614 85.7238 178.972 86.3153 178.102 86.7248C177.232 87.1344 176.178 87.3619 174.85 87.3619L168.299 87.3164ZM169.994 77.2602H174.667C175.399 77.2602 176.041 77.1237 176.59 76.8051C177.14 76.4866 177.552 76.0771 177.873 75.5765C178.194 75.076 178.331 74.439 178.331 73.8019C178.331 72.8463 178.01 72.0273 177.369 71.4357C176.728 70.8442 175.766 70.5257 174.529 70.5257H169.994V77.2602ZM169.994 85.8148H174.896C176.316 85.8148 177.369 85.4962 178.056 84.8592C178.743 84.2222 179.064 83.4486 179.064 82.493C179.064 81.8105 178.881 81.1734 178.56 80.5819C178.239 79.9904 177.736 79.5808 177.14 79.2168C176.545 78.8983 175.812 78.7163 174.987 78.7163H170.04L169.994 85.8148Z",
      fill: fill
    }), jsx("path", {
      d: "M196.928 68.9786H198.623V81.1279C198.623 82.3565 198.348 83.4941 197.753 84.4952C197.157 85.4962 196.333 86.2698 195.279 86.8158C194.226 87.3619 192.989 87.6804 191.615 87.6804C190.241 87.6804 189.004 87.4074 187.95 86.8158C186.897 86.2698 186.072 85.4962 185.477 84.4952C184.881 83.5396 184.607 82.402 184.607 81.1734V69.0241H186.301V81.0369C186.301 81.9925 186.53 82.8571 186.943 83.6306C187.401 84.4042 187.996 84.9957 188.775 85.4052C189.554 85.8603 190.516 86.0423 191.569 86.0423C192.623 86.0423 193.585 85.8148 194.363 85.4052C195.142 84.9502 195.783 84.3587 196.196 83.6306C196.608 82.9026 196.837 81.9925 196.837 81.0369L196.928 68.9786Z",
      fill: fill
    }), jsx("path", {
      d: "M213.327 73.5289C213.236 72.5278 212.778 71.7088 211.953 71.0717C211.128 70.4802 210.121 70.1617 208.93 70.1617C208.059 70.1617 207.327 70.2982 206.639 70.6167C205.998 70.8897 205.494 71.2993 205.128 71.8453C204.761 72.3913 204.578 72.9374 204.578 73.6199C204.578 74.1204 204.67 74.53 204.899 74.894C205.128 75.258 205.403 75.5765 205.769 75.8496C206.136 76.1226 206.502 76.3501 206.96 76.5321C207.418 76.7141 207.83 76.8961 208.288 76.9871L210.212 77.5332C210.808 77.7152 211.403 77.8972 211.999 78.1702C212.594 78.4433 213.144 78.7163 213.602 79.1258C214.06 79.5353 214.472 79.9904 214.793 80.5364C215.114 81.0824 215.251 81.7195 215.251 82.493C215.251 83.4486 214.976 84.3587 214.472 85.1322C213.968 85.9058 213.236 86.5428 212.274 86.9979C211.312 87.4529 210.167 87.6804 208.838 87.6804C207.601 87.6804 206.502 87.4529 205.586 87.0434C204.67 86.6338 203.937 86.0423 203.387 85.3142C202.883 84.5862 202.563 83.7216 202.471 82.7661H204.212C204.258 83.4941 204.532 84.0857 204.945 84.5862C205.357 85.0867 205.907 85.4508 206.594 85.7238C207.281 85.9968 208.014 86.1333 208.838 86.1333C209.754 86.1333 210.579 85.9968 211.312 85.6783C212.045 85.3597 212.594 84.9502 213.007 84.4042C213.419 83.8581 213.648 83.2211 213.648 82.493C213.648 81.856 213.465 81.3555 213.144 80.9459C212.823 80.5364 212.365 80.1724 211.77 79.8994C211.174 79.6263 210.533 79.3533 209.754 79.1258L207.556 78.4888C206.09 78.0792 204.99 77.4877 204.166 76.7141C203.387 75.9406 202.975 74.985 202.975 73.8019C202.975 72.8009 203.25 71.9363 203.754 71.2082C204.303 70.4802 204.99 69.8887 205.907 69.4336C206.823 69.0241 207.83 68.7966 208.976 68.7966C210.121 68.7966 211.128 69.0241 211.999 69.4336C212.869 69.8431 213.602 70.4347 214.106 71.1627C214.61 71.8908 214.885 72.7099 214.93 73.6654L213.327 73.5289Z",
      fill: fill
    }), jsx("path", {
      d: "M221.023 68.9786V87.3164H219.328V68.9786H221.023Z",
      fill: fill
    }), jsx("path", {
      d: "M240.399 68.9786V87.3164H238.75L227.848 71.9818H227.71V87.3164H226.016V68.9786H227.665L238.612 84.3587H238.75V68.9786H240.399Z",
      fill: fill
    }), jsx("path", {
      d: "M245.392 87.3164V68.9786H256.11V70.4802H247.087V77.3967H255.561V78.8983H247.087V85.8148H256.294V87.3164H245.392Z",
      fill: fill
    }), jsx("path", {
      d: "M269.898 73.5289C269.807 72.5278 269.348 71.7088 268.524 71.0717C267.699 70.4802 266.692 70.1617 265.501 70.1617C264.63 70.1617 263.897 70.2982 263.21 70.6167C262.569 70.8897 262.065 71.2993 261.699 71.8453C261.332 72.3458 261.149 72.9374 261.149 73.6199C261.149 74.1204 261.241 74.53 261.47 74.894C261.699 75.258 261.974 75.5765 262.34 75.8496C262.707 76.1226 263.119 76.3501 263.531 76.5321C263.989 76.7141 264.401 76.8961 264.859 76.9871L266.783 77.5332C267.379 77.7152 267.974 77.8972 268.524 78.1702C269.119 78.4433 269.669 78.7163 270.127 79.1258C270.585 79.5353 270.997 79.9904 271.318 80.5364C271.639 81.0824 271.776 81.7195 271.776 82.493C271.776 83.4486 271.501 84.3587 270.997 85.1322C270.494 85.9058 269.761 86.5428 268.799 86.9979C267.837 87.4529 266.692 87.6804 265.363 87.6804C264.127 87.6804 263.027 87.4529 262.111 87.0434C261.195 86.6338 260.462 86.0423 259.912 85.3142C259.363 84.5862 259.088 83.7216 258.996 82.7661H260.737C260.783 83.4941 261.057 84.0857 261.47 84.5862C261.882 85.0867 262.432 85.4508 263.119 85.7238C263.806 85.9968 264.539 86.1333 265.363 86.1333C266.279 86.1333 267.104 85.9968 267.837 85.6783C268.57 85.3597 269.119 84.9502 269.532 84.4042C269.944 83.8581 270.127 83.2211 270.127 82.493C270.127 81.856 269.99 81.3555 269.623 80.9459C269.257 80.5364 268.845 80.1724 268.249 79.8994C267.654 79.6263 267.012 79.3533 266.234 79.1258L264.035 78.4888C262.569 78.0792 261.47 77.4877 260.691 76.7141C259.912 75.9406 259.5 74.985 259.5 73.8019C259.5 72.8009 259.775 71.9363 260.279 71.2082C260.828 70.4802 261.516 69.8887 262.432 69.4336C263.348 69.0241 264.356 68.7966 265.501 68.7966C266.646 68.7966 267.654 69.0241 268.57 69.4336C269.44 69.8431 270.173 70.4347 270.677 71.1627C271.181 71.8908 271.456 72.7099 271.501 73.6654L269.898 73.5289Z",
      fill: fill
    }), jsx("path", {
      d: "M285.93 73.5289C285.839 72.5278 285.381 71.7088 284.556 71.0717C283.732 70.4802 282.724 70.1617 281.533 70.1617C280.663 70.1617 279.93 70.2982 279.243 70.6167C278.601 70.8897 278.098 71.2993 277.731 71.8453C277.365 72.3458 277.181 72.9374 277.181 73.6199C277.181 74.1204 277.273 74.53 277.502 74.894C277.731 75.258 278.006 75.5765 278.372 75.8496C278.739 76.1226 279.151 76.3501 279.563 76.5321C280.021 76.7141 280.434 76.8961 280.892 76.9871L282.816 77.5332C283.411 77.7152 284.007 77.8972 284.556 78.1702C285.152 78.4433 285.701 78.7163 286.159 79.1258C286.618 79.5353 287.03 79.9904 287.35 80.5364C287.671 81.0824 287.808 81.7195 287.808 82.493C287.808 83.4486 287.534 84.3587 287.03 85.1322C286.526 85.9058 285.793 86.5428 284.831 86.9979C283.869 87.4529 282.724 87.6804 281.396 87.6804C280.159 87.6804 279.059 87.4529 278.143 87.0434C277.227 86.6338 276.494 86.0423 275.945 85.3142C275.395 84.5862 275.12 83.7216 275.029 82.7661H276.769C276.815 83.4941 277.09 84.0857 277.502 84.5862C277.914 85.0867 278.464 85.4508 279.151 85.7238C279.838 85.9968 280.571 86.1333 281.396 86.1333C282.312 86.1333 283.136 85.9968 283.869 85.6783C284.602 85.3597 285.152 84.9502 285.564 84.4042C285.976 83.8581 286.159 83.2211 286.159 82.493C286.159 81.856 286.022 81.3555 285.656 80.9459C285.289 80.5364 284.877 80.1724 284.281 79.8994C283.686 79.6263 283.045 79.3533 282.266 79.1258L280.067 78.4888C278.601 78.0792 277.502 77.4877 276.723 76.7141C275.945 75.9406 275.532 74.985 275.532 73.8019C275.532 72.8009 275.807 71.9363 276.311 71.2082C276.861 70.4802 277.548 69.8887 278.464 69.4336C279.38 69.0241 280.388 68.7966 281.533 68.7966C282.678 68.7966 283.686 69.0241 284.602 69.4336C285.472 69.8431 286.205 70.4347 286.709 71.1627C287.213 71.8908 287.488 72.7099 287.534 73.6654L285.93 73.5289Z",
      fill: fill
    })]
  }));
}

function GroverLogoSvg({
  isTransparent = false,
  color,
  className
}) {
  const theme = useTheme();
  const fill = isTransparent ? theme.colors.Background : color;
  return jsx("svg", Object.assign({
    viewBox: "0 0 297.6 85",
    fill: "none",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, {
    children: jsxs("g", {
      children: [jsx("path", {
        fill: fill,
        d: "M159.6,32.1V25c0-0.4-0.4-0.8-0.8-0.7c-5.7,0.2-9.1,2.7-11,4.8c-4.8,5.2-4.5,12.4-4.5,14.2V59\n\t\tc0,0.4,0.3,0.7,0.7,0.7h7.1c0.4,0,0.7-0.3,0.7-0.7V42.9c0,0-0.3-5.2,2.2-8c1.1-1.2,2.7-1.9,4.8-2C159.2,32.9,159.6,32.5,159.6,32.1\n\t\t"
      }), jsx("path", {
        fill: fill,
        d: "M291.2,32.1V25c0-0.4-0.4-0.8-0.8-0.7c-5.7,0.2-9.1,2.7-11,4.8c-4.8,5.2-4.5,12.4-4.5,14.2V59\n\t\tc0,0.4,0.3,0.7,0.7,0.7h7.1c0.4,0,0.7-0.3,0.7-0.7V42.9c0,0-0.3-5.2,2.2-8c1.1-1.2,2.7-1.9,4.8-2C290.9,32.9,291.2,32.5,291.2,32.1\n\t\t"
      }), jsx("path", {
        fill: fill,
        d: "M46.7,64.6c-12.8,0-23.1-10.4-23.1-23.1S34,18.3,46.7,18.3c12.8,0,23.1,10.4,23.1,23.1S59.5,64.6,46.7,64.6\n\t\t M81.1,20.8c-0.9-3.4-2.4-6.6-4.7-9c-2.4-2.3-5.6-3.7-9-4.7c-8.9-2.5-19.2-2.3-28.2-0.3c-9.1,2.1-15.7,8-21.1,15.4\n\t\tc-5,6.9-9.7,15.4-10.4,24c-0.7,9,3.8,17.7,10.3,24c6.3,6.5,14.9,11,24,10.3c8.6-0.7,17.1-5.4,24-10.4c7.4-5.4,13.3-11.9,15.4-21\n\t\tC83.4,40,83.6,29.7,81.1,20.8"
      }), jsx("path", {
        fill: fill,
        d: "M227.4,25l-11.6,25.4L204.1,25c-0.2-0.4-0.6-0.6-1-0.6h-6.8c-0.5,0-0.9,0.6-0.7,1l15.5,33.9\n\t\tc0.1,0.3,0.4,0.4,0.7,0.4h7.9c0.3,0,0.6-0.2,0.7-0.4l15.5-33.9c0.2-0.5-0.1-1-0.7-1h-6.8C227.9,24.3,227.5,24.6,227.4,25"
      }), jsx("path", {
        fill: fill,
        d: "M242.9,37.7l0.1-0.2c1.8-3.7,5.6-6.2,9.7-6.2c4.1,0,8,2.4,9.7,6.2l0.1,0.2H242.9z M251.7,23.5\n\t\tc-9.5,0.5-17.1,8.2-17.6,17.6c-0.6,10.7,8,19.7,18.6,19.7c5.9,0,11.5-2.8,15-7.5c0.3-0.3,0.2-0.8-0.2-1.1l-5.4-3.5\n\t\tc-0.3-0.2-0.7-0.1-1,0.2c-2,2.5-5.1,4-8.4,4c-4.7,0-8.8-3-10.3-7.5l-0.1-0.2H263v0h7.5c0.4,0,0.7-0.3,0.7-0.7\n\t\tc0.1-0.8,0.2-1.6,0.2-2.4C271.4,31.5,262.5,22.9,251.7,23.5"
      }), jsx("path", {
        fill: fill,
        d: "M178.7,52.8c-5.9,0-10.7-4.8-10.7-10.7c0-5.9,4.8-10.7,10.7-10.7c5.9,0,10.7,4.8,10.7,10.7\n\t\tC189.5,48,184.6,52.8,178.7,52.8 M178.7,23.4c-10.3,0-18.7,8.4-18.7,18.7c0,10.3,8.4,18.7,18.7,18.7c10.3,0,18.7-8.4,18.7-18.7\n\t\tC197.4,31.8,189,23.4,178.7,23.4"
      }), jsx("path", {
        fill: fill,
        d: "M116.7,18.3c-12.8,0-23.2,10.4-23.2,23.2c0,12.8,10.4,23.2,23.2,23.2c12.8,0,23.2-10.4,23.2-23.2\n\t\tc0-1.2-0.1-2.4-0.3-3.7c-0.1-0.4-0.4-0.6-0.7-0.6h-20.5c-0.4,0-0.7,0.3-0.7,0.7V45c0,0.4,0.3,0.7,0.7,0.7h12.4l-0.1,0.2\n\t\tc-2,6.2-7.7,10.3-14.3,10.2c-8-0.2-14.5-6.9-14.3-15c0.2-7.9,6.7-14.3,14.7-14.3c4.7,0,9.1,2.2,11.8,6c0.2,0.3,0.7,0.4,1,0.2\n\t\tl5.9-3.8c0.4-0.2,0.4-0.7,0.2-1C131.3,22,124.3,18.3,116.7,18.3"
      })]
    })
  }));
}

const GroverLogoLink = /*#__PURE__*/styled(Link$2).withConfig({
  displayName: "GroverLogo__GroverLogoLink",
  componentId: "y8ega6-0"
})(["margin-right:32px;height:32px;display:inline-block;@media (", "){height:40px;}"], ({
  theme
}) => theme.screens.desktop);
const GroverLogo$1 = ({
  link,
  isTransparent,
  onNavigate,
  className
}) => {
  const theme = useTheme();
  const isBusiness = link.url.includes('business');
  return jsx(GroverLogoLink, Object.assign({
    link: link,
    onNavigate: onNavigate,
    testId: "logo",
    className: className
  }, {
    children: isBusiness ? jsx(GroverBusinessSvg, {}) : jsx(GroverLogoSvg, {
      className: className,
      isTransparent: isTransparent,
      color: theme.type === 'dark' ? '#FFFFFF' : '#FE1251'
    })
  }));
};

const LinksWrapperBase = /*#__PURE__*/css(["display:flex;flex-wrap:nowrap;align-items:center;a{", ";color:", ";text-decoration:none;cursor:pointer;margin-right:24px;&:hover,&:active,&:focus{opacity:0.5;}transition:all 0.3s cubic-bezier(0.4,0,0.2,1);}"], ({
  theme
}) => theme.typography.SmallCapsHeadline, ({
  theme,
  isTransparent
}) => isTransparent ? theme.colors.Background : theme.colors.Foreground);
const MobileLinksWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__MobileLinksWrapper",
  componentId: "sc-1eeknyf-0"
})(["", " @media (", "){display:none;}a:last-of-type{margin-right:0px;}"], LinksWrapperBase, ({
  theme
}) => theme.screens.desktop);
const DesktopLinksWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__DesktopLinksWrapper",
  componentId: "sc-1eeknyf-1"
})(["", " @media not (", "){display:none;}"], LinksWrapperBase, ({
  theme
}) => theme.screens.desktop);
const NavigationWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__NavigationWrapper",
  componentId: "sc-1eeknyf-2"
})(["display:flex;flex:1;@media not (", "){justify-content:end;}"], ({
  theme
}) => theme.screens.desktop);

function Navigation({
  links,
  isTransparent = false,
  onNavigate,
  onLinkClick
}) {
  const mobileLinks = links.filter(link => link.showInMobile);
  const desktopLinks = links.filter(link => link.showInDesktop);
  return jsxs(NavigationWrapper, {
    children: [jsx(DesktopLinksWrapper, Object.assign({
      isTransparent: isTransparent
    }, {
      children: desktopLinks.map(link => jsx(Link$2, {
        onClick: event => onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick(event, link),
        link: link,
        onNavigate: onNavigate,
        testId: "desktop-navigation-link"
      }, link.url))
    })), jsx(MobileLinksWrapper, Object.assign({
      isTransparent: isTransparent
    }, {
      children: mobileLinks.map(link => jsx(Link$2, {
        onClick: event => onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick(event, link),
        link: link,
        onNavigate: onNavigate,
        testId: "mobile-navigation-link"
      }, link.url))
    }))]
  });
}

const mapAccountMenuProps = ({
  accountMenuLinks,
  contactButtonClassName
}) => accountMenuLinks === null || accountMenuLinks === void 0 ? void 0 : accountMenuLinks.reduce((actionsProps, link) => {
  if (link.key === 'ContactUs') {
    return Object.assign(Object.assign({}, actionsProps), {
      [link.key]: Object.assign(Object.assign({}, link), {
        href: link.url,
        className: contactButtonClassName
      })
    });
  }

  return Object.assign(Object.assign({}, actionsProps), {
    [link.key]: Object.assign(Object.assign({}, link), {
      href: link.url
    })
  });
}, {});
function useAccountMenuProps({
  accountMenuLinks,
  contactButtonClassName
}) {
  return useMemo(() => mapAccountMenuProps({
    accountMenuLinks,
    contactButtonClassName
  }), [accountMenuLinks, contactButtonClassName]);
}

const Text$1 = /*#__PURE__*/styled.p.withConfig({
  displayName: "resume-registrationstyles__Text",
  componentId: "sc-140uzko-0"
})(["", ";margin-left:", ";color:", ";"], ({
  theme
}) => theme.typography.TinyParagraph, ({
  theme
}) => theme.spacers.M, ({
  theme
}) => theme.colors['Level 5']);
const Link$1 = /*#__PURE__*/styled.a.withConfig({
  displayName: "resume-registrationstyles__Link",
  componentId: "sc-140uzko-1"
})(["color:currentColor;text-decoration:underline;cursor:pointer;"]);

const ResumeRegistration = ({
  hintLink
}) => {
  return jsxs(Text$1, {
    children: [hintLink.text, ' ', jsx(Link$1, Object.assign({
      href: hintLink.url
    }, {
      children: hintLink.urlText
    }))]
  });
};

function AccountMenuPopup({
  user,
  accountMenuLinks,
  hintLink,
  unreadMessages,
  contactButtonClassName,
  onSupportClick
}) {
  var _a, _b;

  const actionProps = useAccountMenuProps({
    accountMenuLinks,
    contactButtonClassName
  });

  if (onSupportClick && actionProps) {
    actionProps.ContactUs['onClick'] = e => {
      e.preventDefault();
      onSupportClick();
    };
  }

  return jsx("div", Object.assign({
    "data-testid": "account-menu"
  }, {
    children: user && accountMenuLinks ? jsx(AccountMenu$1, {
      userName: `${user.firstName} ${user.lastName}`,
      accountEmail: user.email,
      profileButtonText: (_b = (_a = actionProps === null || actionProps === void 0 ? void 0 : actionProps.YourProfile) === null || _a === void 0 ? void 0 : _a['title']) !== null && _b !== void 0 ? _b : '',
      unreadMessages: unreadMessages,
      isAccountVerified: user.verified,
      actionsProps: actionProps,
      hintText: hintLink ? jsx(ResumeRegistration, {
        hintLink: hintLink
      }) : undefined
    }) : null
  }));
}

const DashboardLinksWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "dashboard-linksstyles__DashboardLinksWrapper",
  componentId: "qdwuyr-0"
})(["display:flex;margin-left:auto;", ";"], ({
  isTransparent
}) => isTransparent && css(["", "{color:", ";}"], NavigationLink$2, ({
  theme
}) => theme.colors.Background));
const NavigationLink$2 = /*#__PURE__*/styled(Link$2).withConfig({
  displayName: "dashboard-linksstyles__NavigationLink",
  componentId: "qdwuyr-1"
})(["display:flex;align-items:center;", ";color:", ";text-decoration:none;cursor:pointer;padding:0 16px;margin-left:16px;margin-right:", ";&:hover,&:active,&:focus{opacity:", ";}transition:all 0.3s cubic-bezier(0.4,0,0.2,1);"], ({
  theme
}) => theme.typography.SmallCapsHeadline, ({
  theme
}) => theme.colors.Foreground, ({
  marginRight
}) => marginRight ? '16px' : '0', ({
  noHover
}) => noHover ? 1 : 0.5);
const LinkText = /*#__PURE__*/styled.div.withConfig({
  displayName: "dashboard-linksstyles__LinkText",
  componentId: "qdwuyr-2"
})(["white-space:pre;"]);
const IconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "dashboard-linksstyles__IconWrapper",
  componentId: "qdwuyr-3"
})(["margin-right:8px;"]);

const HoverHandler = /*#__PURE__*/styled.div.withConfig({
  displayName: "account-menustyles__HoverHandler",
  componentId: "sc-8sg5sc-0"
})(["position:absolute;right:0;top:36px;width:100%;height:28px;z-index:", ";visibility:", ";"], ({
  accountMenuActive
}) => accountMenuActive ? 3 : 0, ({
  accountMenuActive
}) => accountMenuActive ? 'visible' : 'hidden');
const AccountMenuWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "account-menustyles__AccountMenuWrapper",
  componentId: "sc-8sg5sc-2"
})(["position:absolute;right:0;top:56px;z-index:4;visibility:", ";transform:scale(", ");opacity:", ";transition:all 0.2s cubic-bezier(0,0,0.2,1);border-radius:8px;overflow:hidden;min-width:410px;box-shadow:", ";"], ({
  accountMenuActive
}) => accountMenuActive ? 'visible' : 'hidden', ({
  accountMenuActive
}) => accountMenuActive ? 1 : 0.9, ({
  accountMenuActive
}) => accountMenuActive ? 1 : 0, ({
  accountMenuActive
}) => accountMenuActive ? '0px 7px 15px rgb(0 0 0 / 13%), 0px 0px 3px rgb(0 0 0 / 5%)' : 'none');
const AccountMenuButton = /*#__PURE__*/styled.div.withConfig({
  displayName: "account-menustyles__AccountMenuButton",
  componentId: "sc-8sg5sc-3"
})(["display:flex;align-items:center;", ";color:", ";text-decoration:none;cursor:pointer;padding:0 16px;margin-left:16px;margin-right:", ";&:hover,&:active,&:focus{opacity:", ";}transition:all 0.3s cubic-bezier(0.4,0,0.2,1);"], ({
  theme
}) => theme.typography.SmallCapsHeadline, ({
  theme
}) => theme.colors.Foreground, ({
  marginRight
}) => marginRight ? '16px' : '0', ({
  noHover
}) => noHover ? 1 : 0.5);

function AccountMenu({
  user,
  accountMenuLinks,
  accountLink,
  hintLink,
  unreadMessages,
  contactButtonClassName,
  onSupportClick
}) {
  const [accountMenuActive, setAccountMenuActive] = useState(false);
  const [renderedOnClient, setRenderedOnClient] = useState(false);

  const showAccountMenu = () => {
    setAccountMenuActive(true);
  };

  const hideAccountMenu = () => {
    setAccountMenuActive(false);
  };

  useEffect(() => {
    setRenderedOnClient(true);
  }, []);
  return jsxs(Fragment$1, {
    children: [jsxs(AccountMenuButton, Object.assign({
      noHover: true,
      onMouseEnter: showAccountMenu,
      onMouseLeave: hideAccountMenu,
      "data-testid": "account-menu-button"
    }, {
      children: [accountLink.svgPath ? jsx(IconWrapper, {
        children: jsx(Svg, {
          svgPath: accountLink.svgPath
        })
      }) : null, jsx(LinkText, {
        children: accountLink.text
      })]
    })), jsx(HoverHandler, {
      accountMenuActive: accountMenuActive,
      onMouseEnter: showAccountMenu,
      onMouseLeave: hideAccountMenu
    }), jsx(AccountMenuWrapper, Object.assign({
      accountMenuActive: accountMenuActive,
      onMouseEnter: showAccountMenu,
      onMouseLeave: hideAccountMenu
    }, {
      children: renderedOnClient ? jsx(AccountMenuPopup, {
        user: user,
        accountMenuLinks: accountMenuLinks,
        hintLink: hintLink,
        unreadMessages: unreadMessages,
        contactButtonClassName: contactButtonClassName,
        onSupportClick: onSupportClick
      }) : null
    }))]
  });
}

const SignupButton = /*#__PURE__*/styled(ButtonV2).withConfig({
  displayName: "styles__SignupButton",
  componentId: "sc-3jwldy-0"
})(["line-height:32px;color:", ";&:hover,&:hover:not(:disabled),&:active,&:active:not(:disabled){background-color:", ";color:", ";box-shadow:0 4px 10px rgb(0 0 0 / 13%),0 0 3px rgb(0 0 0 / 5%);}transition:all 0.3s cubic-bezier(0.4,0,0.2,1);"], ({
  theme
}) => theme.colors.Background === 'rgba(255, 255, 255, 1)' ? theme.colors.Background : theme.colors.Foreground, ({
  theme
}) => theme.colors.Background, ({
  theme
}) => theme.colors.Foreground);
const LoginButton = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__LoginButton",
  componentId: "sc-3jwldy-1"
})(["", ";color:", ";cursor:pointer;margin-right:16px;&:hover,&:active,&:focus{opacity:0.5;}transition:all 0.3s cubic-bezier(0.4,0,0.2,1);"], ({
  theme
}) => theme.typography.SmallCapsHeadline, ({
  isTransparent,
  theme
}) => isTransparent ? theme.colors.Background : theme.colors.Foreground);

const AuthButtonsWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "AuthButtons__AuthButtonsWrapper",
  componentId: "sc-1bzn7e2-0"
})(["display:flex;align-items:center;margin-left:auto;"]);
function AuthButtons({
  loginButtonText,
  signupButtonText,
  onLogin,
  onSignup,
  storeId,
  isTransparent = false,
  sendAnalyticsFunctionFromConsumer,
  trackLoginEvent
}) {
  const handleLogin = () => {
    if (trackLoginEvent) handleLoginButtonClick({
      storeId,
      sendAnalyticsFunctionFromConsumer
    });
    onLogin === null || onLogin === void 0 ? void 0 : onLogin();
  };

  return jsxs(AuthButtonsWrapper, {
    children: [jsx(LoginButton, Object.assign({
      isTransparent: isTransparent,
      onClick: handleLogin,
      "data-testid": "login-button"
    }, {
      children: loginButtonText
    })), jsx(SignupButton, Object.assign({
      color: "red",
      onClick: onSignup
    }, {
      children: signupButtonText
    }))]
  });
}

function DashboardLinks({
  links,
  isTransparent,
  onNavigate,
  storeId,
  sendAnalyticsFunctionFromConsumer
}) {
  var _a, _b;

  const handleLinkClick = (e, {
    url
  }) => {
    const isYourTechLink = url.includes('your-tech'); // yea not best ever

    if (!isYourTechLink) return;
    const isB2BStore = url.includes('business');
    handleYourTechLinkClick({
      storeId,
      isB2BStore,
      sendAnalyticsFunctionFromConsumer
    });
  };

  return jsx(DashboardLinksWrapper, Object.assign({
    isTransparent: isTransparent
  }, {
    children: (_b = (_a = links === null || links === void 0 ? void 0 : links.filter(link => link.showInDesktop)) === null || _a === void 0 ? void 0 : _a.map(link => jsxs(NavigationLink$2, Object.assign({
      link: link,
      onNavigate: onNavigate,
      onClick: handleLinkClick,
      testId: "dashboard-link"
    }, {
      children: [link.svgPath ? jsx(IconWrapper, {
        children: jsx(Svg, {
          isTransparent: isTransparent,
          svgPath: link.svgPath
        })
      }) : null, jsx(LinkText, {
        children: link.text
      })]
    }), link.url))) !== null && _b !== void 0 ? _b : null
  }));
}

const UserBarWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "UserBar__UserBarWrapper",
  componentId: "sc-1qqb9ki-0"
})(["display:flex;align-self:stretch;@media not (", "){display:none;}"], ({
  theme
}) => theme.screens.desktop);
function UserBar({
  userBarData: {
    dashboardLinks,
    loginButtonText,
    signupButtonText,
    user,
    accountMenuLinks,
    accountLink,
    hintLink
  },
  onLogin,
  onSignup,
  onNavigate,
  loggedIn,
  isTransparent = false,
  unreadMessages,
  storeId,
  contactButtonClassName,
  sendAnalyticsFunctionFromConsumer,
  onSupportClick,
  trackLoginEvent
}) {
  return jsx(UserBarWrapper, {
    children: loggedIn ? jsxs(Fragment$1, {
      children: [jsx(DashboardLinks, {
        onNavigate: onNavigate,
        isTransparent: isTransparent,
        links: dashboardLinks,
        storeId: storeId,
        sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
      }), jsx(AccountMenu, {
        user: user,
        accountMenuLinks: accountMenuLinks,
        accountLink: accountLink,
        unreadMessages: unreadMessages,
        contactButtonClassName: contactButtonClassName,
        hintLink: hintLink,
        onSupportClick: onSupportClick
      })]
    }) : jsx(AuthButtons, {
      onLogin: onLogin,
      onSignup: onSignup,
      storeId: storeId,
      loginButtonText: loginButtonText,
      signupButtonText: signupButtonText,
      isTransparent: isTransparent,
      sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer,
      trackLoginEvent: trackLoginEvent
    })
  });
}

const Header = ({
  header,
  search,
  onNavigate,
  query,
  onQueryChange,
  deviceType,
  unreadMessages,
  onLogin,
  onLogout,
  onSignup,
  cart,
  contactButtonClassName,
  sendAnalyticsFunctionFromConsumer,
  consumer,
  onSupportClick,
  onLinkClick,
  onLocaleChange,
  onStoreChange,
  trackLoginEvent: _trackLoginEvent = true
}) => {
  const mobile = deviceType !== "desktop"
  /* Desktop */
  ;

  if (!(header === null || header === void 0 ? void 0 : header.data)) {
    return null;
  }

  const {
    store,
    storeId,
    locale,
    loggedIn,
    homeLink,
    links,
    userBar,
    categoryMenu,
    topLevelCategoriesTitle,
    searchCategoriesShowAllLabel
  } = header.data;
  return jsxs(RootWrapper$1, {
    children: [jsxs(TopWrapper$1, Object.assign({
      mobile: mobile
    }, {
      children: [jsx(GroverLogo$1, {
        onNavigate: onNavigate,
        isTransparent: false,
        link: homeLink
      }), jsx(Navigation, {
        onNavigate: onNavigate,
        links: links,
        onLinkClick: onLinkClick
      }), jsx(UserBar, {
        loggedIn: loggedIn,
        onNavigate: onNavigate,
        userBarData: userBar,
        onLogin: onLogin,
        onSignup: onSignup,
        isTransparent: false,
        unreadMessages: unreadMessages,
        storeId: storeId,
        contactButtonClassName: contactButtonClassName,
        sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer,
        onSupportClick: onSupportClick,
        trackLoginEvent: _trackLoginEvent
      })]
    })), jsxs(BottomWrapper$1, {
      children: [jsx(Categories, {
        onNavigate: onNavigate,
        categoryMenuData: categoryMenu,
        handleChangeStore: onStoreChange,
        handleChangeLocale: onLocaleChange,
        handleLogout: onLogout,
        handleLogin: onLogin,
        loggedIn: loggedIn,
        activeStore: store,
        activeLocale: locale,
        userDevice: deviceType,
        storeId: storeId,
        sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer,
        onLinkClick: onLinkClick,
        trackLoginEvent: _trackLoginEvent,
        onSupportClick: onSupportClick
      }), jsx(Search$1, {
        userDevice: deviceType,
        searchLoading: search.loading,
        query: query,
        onQueryChange: onQueryChange,
        categories: categoryMenu.categories,
        topLevelCategoriesTitle: topLevelCategoriesTitle,
        searchCategoriesShowAllLabel: searchCategoriesShowAllLabel,
        searchResult: search.data,
        onNavigate: onNavigate,
        storeId: storeId,
        store: store,
        locale: locale,
        sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer,
        consumer: consumer
      }), cart ? cart : null]
    })]
  });
};

const AccountMenuFilledIcon = ({
  className,
  color,
  size: _size = '24'
}) => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      d: "M12 14C14.2091 14 16 12.2091 16 10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10C8 12.2091 9.79086 14 12 14Z",
      fill: "#333333"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM8.33169 15.7815C7.47927 16.162 6.69302 16.672 6.00007 17.2917C4.7553 15.8815 4 14.0289 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 14.0289 19.2447 15.8815 17.9999 17.2917C17.2843 16.6517 16.4694 16.129 15.5854 15.745C14.44 15.2475 13.2035 14.9938 11.9547 15.0001C10.7059 15.0064 9.47207 15.2725 8.33169 15.7815Z",
      fill: "#333333"
    })]
  }));
};

const AccountMenuOutlineIcon = ({
  className,
  color,
  size: _size = '24'
}) => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10ZM14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10Z",
      fill: "#333333"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C13.6621 20 15.2058 19.4931 16.485 18.6255C16.0691 18.2785 15.6131 17.9798 15.1252 17.7364C14.1645 17.257 13.1063 17.0051 12.0326 17.0001C10.9589 16.9951 9.89845 17.2371 8.93326 17.7075C8.42352 17.956 7.94756 18.2646 7.51502 18.6255C8.7942 19.4931 10.3379 20 12 20ZM17.7763 17.0983C17.8519 17.1615 17.9265 17.226 17.9999 17.2917C19.2447 15.8815 20 14.0289 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 14.0289 4.7553 15.8815 6.00007 17.2917C6.09439 17.2074 6.19046 17.125 6.28822 17.0447C6.82971 16.6001 7.42305 16.2187 8.05705 15.9097C9.29801 15.3049 10.6615 14.9937 12.0419 15.0001C13.4224 15.0065 14.7829 15.3304 16.0182 15.9468C16.6493 16.2617 17.239 16.6486 17.7763 17.0983Z",
      fill: "#333333"
    })]
  }));
};

const FULL_HEADER_HEIGHT = 124;
const TOP_HEADER_HEIGHT = 60;

const MenuWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__MenuWrapper",
  componentId: "sc-18yssys-0"
})(["position:relative;"]);
const MenuButton = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__MenuButton",
  componentId: "sc-18yssys-1"
})(["cursor:pointer;padding:", ";border-radius:999px;display:flex;align-items:center;justify-content:center;background-color:", ";&:hover{background-color:#f1f1f1;}"], ({
  theme
}) => `${theme.spacers.M}`, ({
  active,
  theme
}) => active ? '#f1f1f1' : theme.colors.Background);
const MenuContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__MenuContent",
  componentId: "sc-18yssys-2"
})(["z-index:2;display:flex;flex-direction:column;background-color:", ";box-shadow:0 4px 10px 0 rgba(0,0,0,0.13),0 0 3px 0 rgba(0,0,0,0.05);overflow-x:hidden;", " ", ""], ({
  theme
}) => theme.colors.Background, ({
  mobile,
  active,
  animation,
  isScrolledToTop
}) => mobile && css(["position:fixed;top:", ";left:0;bottom:0;width:100%;height:100vh;", ";", ";@media (", "){width:375px;}"], isScrolledToTop ? '0' : `${TOP_HEADER_HEIGHT}px`, animation && 'transition: transform 150ms ease-out', active ? 'transform: translateX(0);' : 'transform: translateX(-100%);', ({
  theme
}) => theme.screens.tablet), ({
  mobile,
  active
}) => !mobile && css(["position:absolute;top:", ";right:0;min-width:280px;padding:12px 0;border-radius:24px;visibility:", ";"], ({
  theme
}) => theme.spacers['4XL'], active ? 'visible' : 'hidden'));
const MenuContentAnimationWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__MenuContentAnimationWrapper",
  componentId: "sc-18yssys-3"
})(["position:relative;"]);
const MenuContentAnimation = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__MenuContentAnimation",
  componentId: "sc-18yssys-4"
})(["", " ", " padding-bottom:64px;position:absolute;width:100%;"], ({
  isPush
}) => isPush && css(["@keyframes leftSlide{100%{right:0;}}right:-100%;animation:leftSlide 200ms forwards;"]), ({
  isPush
}) => !isPush && css(["@keyframes rightSlide{100%{left:0;}}left:-100%;animation:rightSlide 200ms forwards;"]));
const MobileMenuHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__MobileMenuHeader",
  componentId: "sc-18yssys-5"
})(["display:flex;justify-content:space-between;align-items:center;padding:12px ", " 12px ", ";"], ({
  theme
}) => `${theme.spacers.M}`, ({
  theme
}) => `${theme.spacers.L}`);
const MobileMenuHeaderText = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__MobileMenuHeaderText",
  componentId: "sc-18yssys-6"
})(["display:flex;align-items:center;color:", ";font-size:18px;line-height:120%;font-weight:800;"], ({
  theme
}) => theme.palette.grey[100]);
const MenuItem = /*#__PURE__*/styled.a.withConfig({
  displayName: "styles__MenuItem",
  componentId: "sc-18yssys-7"
})(["", " line-height:24px;text-transform:capitalize;color:", ";cursor:pointer;display:flex;align-items:center;justify-content:space-between;width:100%;padding:", ";&:hover{background:#f1f1f1;}"], ({
  theme
}) => theme.typography.Paragraph, ({
  theme
}) => theme.palette.grey[100], ({
  mobile
}) => mobile ? '16px 24px;' : '12px 24px');
const MenuDivider = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__MenuDivider",
  componentId: "sc-18yssys-8"
})(["border:1px solid #f1f1f1;width:100%;margin:", ";"], ({
  theme
}) => `${theme.spacers.M} 0`);
const CloseIconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__CloseIconWrapper",
  componentId: "sc-18yssys-9"
})(["padding:", ";cursor:pointer;display:flex;"], ({
  theme
}) => `${theme.spacers.M}`);
const BackArrowWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__BackArrowWrapper",
  componentId: "sc-18yssys-10"
})(["padding:", ";cursor:pointer;display:flex;"], ({
  theme
}) => `${theme.spacers.M} ${theme.spacers.L} ${theme.spacers.M} 0`);

const CloseCrossIcon = ({
  className,
  color: _color = '#333',
  size: _size = '24'
}) => {
  return jsx("svg", Object.assign({
    className: className,
    width: _size,
    height: _size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("g", Object.assign({
      id: "Close Cross"
    }, {
      children: jsx("path", {
        id: "Vector",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L12 10.5858L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L13.4142 12L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L12 13.4142L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L10.5858 12L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: _color
      })
    }))
  }));
};

const BackArrowIcon = () => {
  return jsx("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("g", Object.assign({
      id: "Icon"
    }, {
      children: jsx("path", {
        id: "Vector",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.7208 19.7071C11.1113 19.3166 11.1113 18.6834 10.7208 18.2929L5.42789 13L20.9995 13C21.5517 13 21.9995 12.5523 21.9995 12C21.9995 11.4477 21.5517 11 20.9995 11L5.42789 11L10.7208 5.70711C11.1113 5.31658 11.1113 4.68342 10.7208 4.29289C10.3303 3.90237 9.69709 3.90237 9.30656 4.29289L2.30657 11.2929C1.91604 11.6834 1.91604 12.3166 2.30657 12.7071L9.30657 19.7071C9.69709 20.0976 10.3303 20.0976 10.7208 19.7071Z",
        fill: "#333333"
      })
    }))
  }));
};

const useHideOnScroll = () => {
  const [isScrollingDown, setIsScrollingDown] = useState(false);
  const [isScrolledToTop, setIsScrolledToTop] = useState(true);
  useEffect(() => {
    let prevScrollPosition = 0;
    let ticking = false;

    const setScrollVariables = scrollPosition => {
      if (scrollPosition <= FULL_HEADER_HEIGHT) {
        setIsScrolledToTop(true);
      } else if (isScrolledToTop) {
        setIsScrolledToTop(false);
      }

      if (scrollPosition > prevScrollPosition && scrollPosition > FULL_HEADER_HEIGHT) {
        setIsScrollingDown(true);
      } else {
        setIsScrollingDown(false);
      }

      prevScrollPosition = scrollPosition;
    };

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrollVariables(window.scrollY);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isScrolledToTop]);
  return {
    isScrolledToTop,
    isScrollingDown
  };
};

const Menu = /*#__PURE__*/forwardRef(({
  button,
  content,
  mobile: _mobile = false,
  headerLabel,
  animation: _animation = true,
  onMenuOpen
}, ref) => {
  const [isPush, setIsPush] = useState(false);
  const [menuStack, setMenuStack] = useState([{
    content,
    label: headerLabel
  }]);
  const [menuActive, setMenuActive] = useState(false);
  const newRef = useRef(null);
  const handleMenuBack = useCallback(() => {
    const sliceIndex = menuStack.length === 1 ? 1 : menuStack.length - 1;
    setIsPush(false);
    setMenuStack(menuStack.slice(0, sliceIndex));
  }, [menuStack]);
  const {
    isScrolledToTop
  } = useHideOnScroll();

  const handleMenuOpen = () => {
    onMenuOpen === null || onMenuOpen === void 0 ? void 0 : onMenuOpen();
    setMenuActive(true);
  };

  const handleMenuClose = useCallback(e => {
    if (newRef.current && e.target instanceof Node && !newRef.current.contains(e.target)) {
      setMenuActive(false);
      handleMenuBack();
    }
  }, [handleMenuBack]);
  const handleMenuNavigate = useCallback(menuOptions => {
    setMenuStack([...menuStack, menuOptions]);
    setIsPush(true);
  }, [menuStack]);
  useImperativeHandle(ref, () => {
    return {
      handleMenuNavigate
    };
  }, [handleMenuNavigate]);
  useEffect(() => {
    document.addEventListener('mousedown', handleMenuClose);
    return () => {
      document.removeEventListener('mousedown', handleMenuClose);
    };
  }, [handleMenuClose]);

  const mobileMenuHeader = jsxs(MobileMenuHeader, Object.assign({
    "data-testid": "mobile-menu-header"
  }, {
    children: [jsxs(MobileMenuHeaderText, {
      children: [menuStack.length > 1 && jsx(BackArrowWrapper, Object.assign({
        onClick: handleMenuBack
      }, {
        children: jsx(BackArrowIcon, {})
      })), menuStack[menuStack.length - 1].label]
    }), jsx(CloseIconWrapper, Object.assign({
      onClick: () => setMenuActive(false)
    }, {
      children: jsx(CloseCrossIcon, {})
    }))]
  }));

  const menuContent = _mobile ? jsx(MenuContentAnimationWrapper, {
    children: jsx(MenuContentAnimation, Object.assign({
      isPush: isPush
    }, {
      children: menuStack[menuStack.length - 1].content
    }), menuStack.length)
  }) : menuStack[menuStack.length - 1].content;
  return jsxs(MenuWrapper, {
    children: [jsx(MenuButton, Object.assign({
      role: "button",
      "data-testid": "menu-button",
      onClick: handleMenuOpen,
      active: menuActive
    }, {
      children: button
    })), jsxs(MenuContent, Object.assign({
      isScrolledToTop: isScrolledToTop,
      "data-testid": "menu-content",
      ref: newRef,
      active: menuActive,
      mobile: _mobile,
      animation: _animation
    }, {
      children: [_mobile && mobileMenuHeader, menuContent]
    }))]
  });
});

const SlideButtonWrapper = /*#__PURE__*/styled.a.withConfig({
  displayName: "styles__SlideButtonWrapper",
  componentId: "sc-1a4qe8v-0"
})(["cursor:pointer;display:flex;align-items:center;justify-content:space-between;padding:", ";background-color:", ";&:hover,&:active{background-color:", ";}"], ({
  theme
}) => `0px ${theme.spacers.L}`, ({
  theme
}) => theme.colors.Background, ({
  theme
}) => theme.palette.grey['7']);
const SlideButtonInfo = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__SlideButtonInfo",
  componentId: "sc-1a4qe8v-1"
})(["display:flex;align-items:center;gap:12px;"]);
const SlideButtonImage = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__SlideButtonImage",
  componentId: "sc-1a4qe8v-2"
})(["display:flex;align-items:center;justify-content:center;height:56px;width:56px;background:", ";border-radius:50%;& > img{width:100%;height:auto;padding:5px;border-radius:50%;}"], ({
  theme
}) => theme.palette.grey[4]);
const SlideButtonLabel = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__SlideButtonLabel",
  componentId: "sc-1a4qe8v-3"
})(["color:", ";display:flex;align-items:center;padding:", ";font-size:16px;font-style:normal;font-weight:", ";line-height:150%;"], ({
  theme
}) => theme.palette.grey[100], ({
  theme
}) => `${theme.spacers.XL} 0px`, ({
  bold
}) => bold ? 700 : 500);
const SectionHeadingWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__SectionHeadingWrapper",
  componentId: "sc-1a4qe8v-4"
})(["display:flex;flex-direction:row;align-items:center;padding:", ";"], ({
  theme
}) => `12px 0px 12px ${theme.spacers.L}`);
const SectionHeading = /*#__PURE__*/styled.label.withConfig({
  displayName: "styles__SectionHeading",
  componentId: "sc-1a4qe8v-5"
})(["color:", ";display:block;font-size:12px;line-height:14.4px;letter-spacing:1.2px;font-weight:800;position:relative;text-transform:uppercase;"], ({
  theme
}) => theme.palette.grey[75]);
const SectionHeadingDivider = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__SectionHeadingDivider",
  componentId: "sc-1a4qe8v-6"
})(["flex-grow:1;height:2px;background-color:", ";margin-left:", ";"], ({
  theme
}) => theme.palette.grey[7], ({
  theme
}) => theme.spacers.M);
const CategoryMobileTextContent = /*#__PURE__*/styled.a.withConfig({
  displayName: "styles__CategoryMobileTextContent",
  componentId: "sc-1a4qe8v-7"
})(["cursor:pointer;display:block;overflow:hidden;padding:", ";color:", ";font-size:16px;line-height:150%;font-weight:500;text-overflow:ellipsis;white-space:nowrap;"], ({
  theme
}) => `${theme.spacers.L} ${theme.spacers.XL}`, ({
  theme
}) => theme.palette.grey[100]);
const SlideButtonMcWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__SlideButtonMcWrapper",
  componentId: "sc-1a4qe8v-8"
})(["padding:", ";"], ({
  theme
}) => `${theme.spacers.XXL} 20px 20px 20px`);

const ChevronRightIcon = () => {
  return jsx("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.2929 16.7071C9.90237 16.3166 9.90237 15.6834 10.2929 15.2929L13.5858 12L10.2929 8.70711C9.90237 8.31658 9.90237 7.68342 10.2929 7.29289C10.6834 6.90237 11.3166 6.90237 11.7071 7.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L11.7071 16.7071C11.3166 17.0976 10.6834 17.0976 10.2929 16.7071Z",
      fill: "#333333"
    })
  }));
};

const MAX_NUMBER_OF_CHARACTERS = 25;
const MenuSlideButton = ({
  icon,
  label,
  onSlideClick,
  href,
  className,
  bold: _bold = true
}) => {
  const handleOnClick = e => {
    if (!href) {
      e.preventDefault();
      e.stopPropagation();
    }

    onSlideClick === null || onSlideClick === void 0 ? void 0 : onSlideClick();
  };

  return jsxs(SlideButtonWrapper, Object.assign({
    className: className,
    "data-testid": "slide-button"
  }, Object.assign({}, href && {
    href
  }), {
    onClick: handleOnClick
  }, {
    children: [jsxs(SlideButtonInfo, {
      children: [jsx(SlideButtonImage, {
        children: icon
      }), jsx(SlideButtonLabel, Object.assign({
        bold: _bold
      }, {
        children: label.length > MAX_NUMBER_OF_CHARACTERS ? label.substring(0, MAX_NUMBER_OF_CHARACTERS) + '…' : label
      }))]
    }), jsx(ChevronRightIcon, {})]
  }));
};

const AccountUserInfo = /*#__PURE__*/styled(MenuItem).withConfig({
  displayName: "styles__AccountUserInfo",
  componentId: "sc-168mtow-0"
})(["display:flex;flex-direction:column;align-items:flex-start;gap:", ";padding:", ";cursor:default;&:hover{background-color:", ";}"], ({
  mobile
}) => mobile ? '24px' : '12px', ({
  mobile,
  bigPadding,
  theme
}) => mobile ? bigPadding ? `${theme.spacers['3XL']} ${theme.spacers.XL}` : `${theme.spacers.XL}` : undefined, ({
  theme
}) => theme.colors.Background);
const AccountWelcomeText = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__AccountWelcomeText",
  componentId: "sc-168mtow-1"
})(["", " font-weight:700;", ";line-height:120%;"], ({
  theme
}) => theme.typography.Paragraph, ({
  mobile,
  theme
}) => mobile && theme.typography.Subheadline);
const AccountUserInfoName = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__AccountUserInfoName",
  componentId: "sc-168mtow-2"
})(["display:flex;flex-direction:column;", " line-height:120%;font-weight:700;", ""], ({
  theme
}) => theme.typography.Paragraph, ({
  mobile
}) => mobile && css(["gap:", ";font-size:24px;font-weight:800;"], ({
  theme
}) => theme.spacers.S));
const AccountUserInfoEmail = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__AccountUserInfoEmail",
  componentId: "sc-168mtow-3"
})(["", " line-height:150%;text-transform:lowercase;color:#666;", ""], ({
  theme
}) => theme.typography.Paragraph, ({
  mobile
}) => !mobile && css(["font-size:14px;line-height:20px;"]));
const AccountMenuItem = /*#__PURE__*/styled(MenuItem).withConfig({
  displayName: "styles__AccountMenuItem",
  componentId: "sc-168mtow-4"
})(["font-weight:700;justify-content:flex-start;gap:", ";"], ({
  theme
}) => theme.spacers.L);
const AccountWelcomeButtons = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__AccountWelcomeButtons",
  componentId: "sc-168mtow-5"
})(["display:flex;flex-direction:", ";gap:", ";width:100%;"], ({
  mobile
}) => mobile ? 'column' : 'row', ({
  mobile,
  theme
}) => mobile ? '12px' : theme.spacers.M);
const Button$2 = /*#__PURE__*/styled.button.withConfig({
  displayName: "styles__Button",
  componentId: "sc-168mtow-6"
})(["cursor:pointer;display:flex;justify-content:center;align-items:center;", " font-weight:700;line-height:150%;width:100%;max-height:", ";padding:12px ", ";border-radius:88px;", " ", ""], ({
  theme
}) => theme.typography.Paragraph, ({
  theme,
  mobile
}) => mobile ? theme.spacers['4XL'] : theme.spacers['3XL'], ({
  theme
}) => theme.spacers.L, ({
  theme,
  primary
}) => primary && css(["color:", ";background-color:", ";&:hover{background-color:#ba264d;}"], theme.colors.Background, theme.colors.primary), ({
  theme,
  outlined
}) => outlined && css(["color:", ";background-color:", ";border:2px solid ", ";&:hover{background-color:#f1f1f1;}"], theme.colors.Foreground, theme.colors.Background, theme.colors.Foreground));
const AccountMenuItemSlide = /*#__PURE__*/styled(MenuSlideButton).withConfig({
  displayName: "styles__AccountMenuItemSlide",
  componentId: "sc-168mtow-7"
})(["", "{height:56px;width:56px;}", "{font-weight:700;line-height:24px;}"], SlideButtonImage, SlideButtonLabel);

const TechOutlineIcon = ({
  className,
  color: _color = '#333',
  size: _size = '24'
}) => {
  return jsx("svg", Object.assign({
    className: className,
    width: _size,
    height: _size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 8.00023L5 20.0002H13V18.357L9.6997 17.4727C8.63277 17.1868 7.9996 16.0901 8.28548 15.0232L10.1673 8.00023H5ZM17.9447 17.6114L21.0506 6.02027L13.3232 3.94972L10.2173 15.5408L17.9447 17.6114ZM14.7839 20.9055C14.4535 21.5552 13.7787 22.0002 13 22.0002H5C3.89543 22.0002 3 21.1048 3 20.0002V8.00023C3 6.89566 3.89543 6.00023 5 6.00023H10.7032L11.3913 3.43208C11.6772 2.36514 12.7739 1.73198 13.8408 2.01786L21.5682 4.08842C22.6351 4.3743 23.2683 5.47097 22.9824 6.53791L19.8766 18.129C19.5907 19.1959 18.494 19.8291 17.4271 19.5432L15 18.8929V20.0002C15 20.3261 14.9221 20.6337 14.7839 20.9055Z",
      fill: _color
    })
  }));
};

const PaymentsIcon = ({
  className,
  color: _color = '#333',
  size: _size = '24'
}) => {
  return jsx("svg", Object.assign({
    className: className,
    width: _size,
    height: _size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("g", Object.assign({
      id: "Card"
    }, {
      children: jsx("path", {
        id: "Vector",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6ZM20 6H4V13H20V6ZM20 15H4V18L20 18V15ZM18 10C18 10.5523 17.5523 11 17 11H15C14.4477 11 14 10.5523 14 10V9C14 8.44772 14.4477 8 15 8H17C17.5523 8 18 8.44772 18 9V10Z",
        fill: _color
      })
    }))
  }));
};

var uncurryThis = functionUncurryThis;
var aCallable$1 = aCallable$5;
var NATIVE_BIND = functionBindNative;

var bind$1 = uncurryThis(uncurryThis.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$1(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$1(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var wellKnownSymbol$1 = wellKnownSymbol$g;
var Iterators$1 = iterators;

var ITERATOR$1 = wellKnownSymbol$1('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$1] === it);
};

var classof = classof$6;
var getMethod$1 = getMethod$5;
var Iterators = iterators;
var wellKnownSymbol = wellKnownSymbol$g;

var ITERATOR = wellKnownSymbol('iterator');

var getIteratorMethod$2 = function (it) {
  if (it != undefined) return getMethod$1(it, ITERATOR)
    || getMethod$1(it, '@@iterator')
    || Iterators[classof(it)];
};

var call$2 = functionCall;
var aCallable = aCallable$5;
var anObject$2 = anObject$e;
var tryToString$1 = tryToString$5;
var getIteratorMethod$1 = getIteratorMethod$2;

var $TypeError$1 = TypeError;

var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject$2(call$2(iteratorMethod, argument));
  throw $TypeError$1(tryToString$1(argument) + ' is not iterable');
};

var call$1 = functionCall;
var anObject$1 = anObject$e;
var getMethod = getMethod$5;

var iteratorClose$1 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$1(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$1(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$1(innerResult);
  return value;
};

var bind = functionBindContext;
var call = functionCall;
var anObject = anObject$e;
var tryToString = tryToString$5;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike = lengthOfArrayLike$5;
var isPrototypeOf = objectIsPrototypeOf;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;
var iteratorClose = iteratorClose$1;

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$1 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};

var $ = _export;
var iterate = iterate$1;
var createProperty = createProperty$2;

// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, { AS_ENTRIES: true });
    return obj;
  }
});

const useTracking = ({
  storeId,
  sendAnalyticsFunctionFromConsumer
}) => {
  const sendAnalytics = sendAnalyticsFunctionFromConsumer || sendAnalyticsEvent;
  const commonWidgetPayload = {
    store_id: storeId,
    page_url: typeof window !== 'undefined' ? window.location.pathname : '',
    position: TRACKING_PROPS.POSITION,
    platform: TRACKING_PROPS.PLATFORM
  };

  const prepareAnalyticsPayload = payload => Object.fromEntries(Object.entries(payload).filter(([_, value]) => !!value));

  const sendAccountNavigationClickEvent = ({
    action,
    destinationUrl
  }) => {
    sendNavigationEvent(NAVIGATION_GROUP_TYPE.ACCOUNT, {
      destination_url: destinationUrl,
      action
    });
  };

  const sendBrandsNavigationClickEvent = ({
    topBrand,
    newBrand,
    destinationUrl,
    marketingCard
  }) => {
    sendNavigationEvent(NAVIGATION_GROUP_TYPE.BRANDS, {
      destination_url: destinationUrl,
      top_brand: topBrand,
      new_brand: newBrand,
      marketing_card: marketingCard
    });
  };

  const sendCategoryNavigationClickEvent = ({
    category,
    subCategory,
    brand,
    trending,
    marketingCard,
    destinationUrl
  }) => {
    sendNavigationEvent(NAVIGATION_GROUP_TYPE.CATEGORY, {
      brand,
      trending,
      category,
      sub_category: subCategory,
      marketing_card: marketingCard,
      destination_url: destinationUrl
    });
  };

  const sendAllCategoriesNavigationClickEvent = ({
    category,
    destinationUrl
  }) => {
    sendNavigationEvent(NAVIGATION_GROUP_TYPE.ALL_CATEGORIES, {
      category,
      destination_url: destinationUrl
    });
  };

  const sendNavigationClickEvent = ({
    group,
    destinationUrl
  }) => {
    sendNavigationEvent(group, {
      destination_url: destinationUrl
    });
  };

  const sendStoreLanguageSelectorEvent = _a => {
    var {
      event
    } = _a,
        rest = __rest(_a, ["event"]);

    sendAnalytics(event, Object.assign(Object.assign({}, commonWidgetPayload), rest));
  };

  const sendNavigationEvent = (group, props) => {
    sendAnalytics(SEGMENT_EVENTS.navigationClicked, Object.assign({
      group
    }, prepareAnalyticsPayload(props)));
  };

  return {
    sendNavigationClickEvent,
    sendStoreLanguageSelectorEvent,
    sendAccountNavigationClickEvent,
    sendBrandsNavigationClickEvent,
    sendCategoryNavigationClickEvent,
    sendAllCategoriesNavigationClickEvent
  };
};

const Wrapper$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "kayutc-0"
})(["position:absolute;top:0px;right:0px;background-color:", ";border-radius:48px;padding:2px 4px;height:16px;min-width:16px;display:flex;flex-direction:column;justify-content:center;align-items:center;line-height:0;"], ({
  theme
}) => theme.colors.primary);
const Content$1 = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__Content",
  componentId: "kayutc-1"
})(["", ";color:", ";font-style:normal;font-weight:700;line-height:150%;text-align:center;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;"], ({
  theme
}) => theme.typography.TinyParagraph, ({
  theme
}) => theme.colors.Background);

const Badge = ({
  value
}) => {
  if (!value || value < 0) return null;
  return jsx(Wrapper$1, {
    children: jsx(Content$1, {
      children: value >= 100 ? '99+' : value
    })
  });
};

var AccountLinkKeys;

(function (AccountLinkKeys) {
  AccountLinkKeys["Settings"] = "Settings";
  AccountLinkKeys["YourTech"] = "YourTech";
  AccountLinkKeys["YourPayments"] = "YourPayments";
})(AccountLinkKeys || (AccountLinkKeys = {}));

const iconMap = {
  Settings: jsx(AccountMenuOutlineIcon, {}),
  YourTech: jsx(TechOutlineIcon, {}),
  YourPayments: jsx(PaymentsIcon, {})
};
const Account = ({
  mobile,
  loggedIn,
  userBar,
  unreadMessages,
  handleLogin,
  handleLogout,
  handleSignUp,
  storeId,
  sendAnalyticsFunctionFromConsumer
}) => {
  var _a, _b;

  const {
    t
  } = useTranslation();
  const {
    sendAccountNavigationClickEvent
  } = useTracking({
    storeId,
    sendAnalyticsFunctionFromConsumer
  });
  const {
    user,
    accountMenuLinksV2: accountLinks
  } = userBar;

  if (!accountLinks) {
    return null;
  }

  const commonLinks = (_a = accountLinks === null || accountLinks === void 0 ? void 0 : accountLinks[(accountLinks === null || accountLinks === void 0 ? void 0 : accountLinks.length) - 1]) === null || _a === void 0 ? void 0 : _a.map(({
    title,
    url
  }, index) => jsx(MenuItem, Object.assign({
    href: url,
    mobile: mobile,
    onClick: () => sendAccountNavigationClickEvent({
      destinationUrl: url
    })
  }, {
    children: t(title)
  }), `${index}-${url}`));

  if (loggedIn) {
    const loggedInLinks = (_b = accountLinks === null || accountLinks === void 0 ? void 0 : accountLinks[0]) !== null && _b !== void 0 ? _b : [];
    return jsx(Menu, {
      onMenuOpen: () => sendAccountNavigationClickEvent({}),
      mobile: mobile,
      animation: false,
      button: jsxs(Fragment$1, {
        children: [jsx(AccountMenuFilledIcon, {}), jsx(Badge, {
          value: unreadMessages
        })]
      }),
      content: jsxs(Fragment$1, {
        children: [jsx(AccountUserInfo, Object.assign({
          mobile: mobile
        }, {
          children: jsxs(AccountUserInfoName, Object.assign({
            mobile: mobile
          }, {
            children: [t('SIGNUP_BIRTHDATE_HEADING', {
              first_name: user === null || user === void 0 ? void 0 : user.firstName
            }), jsx(AccountUserInfoEmail, Object.assign({
              mobile: mobile
            }, {
              children: user === null || user === void 0 ? void 0 : user.email
            }))]
          }))
        })), jsx(MenuDivider, {}), loggedInLinks.map(({
          title,
          url,
          icon
        }, index) => {
          if (mobile) {
            return jsx(AccountMenuItemSlide, {
              icon: iconMap[icon],
              label: t(title),
              href: url,
              onSlideClick: () => sendAccountNavigationClickEvent({
                destinationUrl: url
              })
            }, `${url} - ${index}`);
          }

          return jsxs(AccountMenuItem, Object.assign({
            href: url,
            onClick: () => sendAccountNavigationClickEvent({
              destinationUrl: url
            })
          }, {
            children: [icon && iconMap[icon], t(title)]
          }));
        }), jsx(MenuDivider, {}), commonLinks, jsx(MenuDivider, {}), jsx(MenuItem, Object.assign({
          onClick: handleLogout,
          mobile: mobile
        }, {
          children: t('PROFILE_LINKS_LOG_OUT')
        }))]
      })
    }, "logged-in-account-menu");
  }

  return jsx(Menu, {
    onMenuOpen: () => sendAccountNavigationClickEvent({}),
    mobile: mobile,
    animation: false,
    button: jsxs(Fragment$1, {
      children: [jsx(AccountMenuOutlineIcon, {}), jsx(Badge, {
        value: unreadMessages
      })]
    }),
    content: jsxs(Fragment$1, {
      children: [jsxs(AccountUserInfo, Object.assign({
        mobile: mobile,
        bigPadding: true
      }, {
        children: [jsx(AccountWelcomeText, Object.assign({
          mobile: mobile,
          role: "img",
          "aria-label": "wave"
        }, {
          children: t('NEW_USER_WELCOME_TEXT')
        })), jsxs(AccountWelcomeButtons, Object.assign({
          mobile: mobile
        }, {
          children: [jsx(Button$2, Object.assign({
            primary: true,
            mobile: mobile,
            onClick: () => {
              sendAccountNavigationClickEvent({
                action: ACCOUNT_ACTION_TYPE.REGISTER
              });
              handleSignUp === null || handleSignUp === void 0 ? void 0 : handleSignUp();
            }
          }, {
            children: t('SIGN_UP')
          })), jsx(Button$2, Object.assign({
            outlined: true,
            mobile: mobile,
            onClick: () => {
              sendAccountNavigationClickEvent({
                action: ACCOUNT_ACTION_TYPE.LOGIN
              });
              handleLogin === null || handleLogin === void 0 ? void 0 : handleLogin();
            }
          }, {
            children: t('SIGN_IN')
          }))]
        }))]
      })), jsx(MenuDivider, {}), commonLinks]
    })
  }, "logged-out-account-menu");
};

const CartIcon = ({
  className,
  color,
  size: _size = '24'
}) => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.07031 3C2.51803 3 2.07031 3.44772 2.07031 4C2.07031 4.55228 2.51803 5 3.07031 5H4.44426L7.55457 17H17.1137C18.0184 17 18.8104 16.3927 19.0452 15.5191L20.9264 8.51908C21.2679 7.2485 20.3107 6 18.995 6H6.76954L5.99196 3H3.07031ZM9.10227 15L7.28792 8H18.995L17.1137 15L9.10227 15Z",
      fill: "#333333"
    }), jsx("path", {
      d: "M11 20C11 21.1046 10.1046 22 9 22C7.89543 22 7 21.1046 7 20C7 18.8954 7.89543 18 9 18C10.1046 18 11 18.8954 11 20Z",
      fill: "#333333"
    }), jsx("path", {
      d: "M19 20C19 21.1046 18.1046 22 17 22C15.8954 22 15 21.1046 15 20C15 18.8954 15.8954 18 17 18C18.1046 18 19 18.8954 19 20Z",
      fill: "#333333"
    })]
  }));
};

const HeaderWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__HeaderWrapper",
  componentId: "sc-18b2wbx-0"
})(["z-index:9;position:sticky;top:0;transition:transform 300ms ease-in-out;", ";", ";"], ({
  isScrollingDown
}) => isScrollingDown && css(["transform:translateY(", ");"], `-${FULL_HEADER_HEIGHT}px`), ({
  isScrolledToTop,
  isScrollingDown,
  mobile
}) => mobile && !isScrollingDown && !isScrolledToTop && css(["transform:translateY(", ");"], `-${TOP_HEADER_HEIGHT}px`));
const RootWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__RootWrapper",
  componentId: "sc-18b2wbx-1"
})(["z-index:9;margin:auto;max-width:1456px;display:flex;flex-direction:column;background-color:", ";", ";@media (", "){padding:0;}"], ({
  theme
}) => theme.colors.Background, ({
  mobile
}) => !mobile && css(["padding:0 72px;"]), ({
  theme
}) => theme.screens.wideScreen);
const TopWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__TopWrapper",
  componentId: "sc-18b2wbx-2"
})(["position:relative;height:", ";display:flex;align-items:center;justify-content:space-between;flex:1;padding:", ";"], props => props.mobile ? '32px' : '48px', ({
  mobile,
  theme
}) => mobile ? `${theme.spacers.M} ${theme.spacers.L} 0 ${theme.spacers.L}` : '12px 0');
const BottomWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__BottomWrapper",
  componentId: "sc-18b2wbx-3"
})(["display:flex;align-items:center;font-size:14px;font-weight:500;line-height:20px;color:#333333;position:relative;", " ", ""], ({
  mobile
}) => mobile && css(["margin:", ";border-bottom:none;"], ({
  theme
}) => `${theme.spacers.M}`), ({
  mobile
}) => !mobile && css(["& > div{padding:", ";white-space:nowrap;}& > div:first-child{padding-left:0;}"], ({
  theme
}) => `${theme.spacers.M} 10px`));
const DesktopDivider = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__DesktopDivider",
  componentId: "sc-18b2wbx-4"
})(["position:absolute;bottom:-0.5px;height:2px;width:100%;background-color:#f1f1f1;"]);
const HeaderActions = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__HeaderActions",
  componentId: "sc-18b2wbx-5"
})(["display:flex;align-items:center;gap:4px;margin-left:auto;justify-content:flex-end;"]);
const HeaderActionWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__HeaderActionWrapper",
  componentId: "sc-18b2wbx-6"
})(["cursor:pointer;position:relative;padding:", ";border-radius:20px;display:flex;align-items:center;justify-content:center;&:hover{background-color:#f1f1f1;}& > a{display:flex;}"], ({
  theme
}) => theme.spacers.M);
const CategoriesDivider = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__CategoriesDivider",
  componentId: "sc-18b2wbx-7"
})(["background:#f1f1f1;display:inline-block;margin:", ";width:2px;padding:", ";border-radius:24px;height:21px;"], ({
  theme
}) => `${theme.spacers.M} 10px 10px`, ({
  theme
}) => `${theme.spacers.M} 0 10px`);
const GroverLogo = /*#__PURE__*/styled(GroverLogo$1).withConfig({
  displayName: "styles__GroverLogo",
  componentId: "sc-18b2wbx-8"
})(["width:", ";"], ({
  mobile
}) => mobile ? '96px' : '120px');

const Checkout = _a => {
  var {
    links,
    storeId,
    cartItems,
    sendAnalyticsFunctionFromConsumer
  } = _a,
      restProps = __rest(_a, ["links", "storeId", "cartItems", "sendAnalyticsFunctionFromConsumer"]);

  const {
    sendNavigationClickEvent
  } = useTracking({
    storeId,
    sendAnalyticsFunctionFromConsumer
  });
  const cartLink = links === null || links === void 0 ? void 0 : links[2];
  if (!cartLink) return jsx(HeaderActionWrapper, {
    children: jsx(CartIcon, {})
  });
  return jsx(HeaderActionWrapper, {
    children: jsxs(Link$2, Object.assign({}, restProps, {
      link: cartLink,
      onClick: () => sendNavigationClickEvent({
        destinationUrl: cartLink.url,
        group: NAVIGATION_GROUP_TYPE.CART
      })
    }, {
      children: [jsx(CartIcon, {}), jsx(Badge, {
        value: cartItems
      })]
    }))
  });
};

const heightStyle = ({
  mobile,
  searchActive
}) => css(["height:", ";"], ({
  theme
}) => !mobile || searchActive ? theme.spacers['4XL'] : theme.spacers['3XL']);
const OuterWrap = /*#__PURE__*/styled.section.withConfig({
  displayName: "styles__OuterWrap",
  componentId: "sc-1uhyrl-0"
})(["position:relative;flex:1;width:100%;", " @media (", "){", "}"], ({
  mobile,
  searchActive
}) => heightStyle({
  mobile,
  searchActive
}), ({
  theme
}) => theme.screens.desktop, ({
  searchActive
}) => !searchActive && css(["max-width:416px;"]));
const InnerWrap = /*#__PURE__*/styled.section.withConfig({
  displayName: "styles__InnerWrap",
  componentId: "sc-1uhyrl-1"
})(["position:absolute;display:flex;flex-direction:column;background-color:transparent;color:", ";width:100%;height:", ";overflow-y:auto;", " ", " ", ""], ({
  theme
}) => theme.colors.Foreground, ({
  searchActive,
  mobile
}) => searchActive && mobile ? '100vh' : '100%', ({
  searchActive
}) => searchActive && css(["z-index:2;background-color:", ";"], ({
  theme
}) => theme.colors.ElementBackground), ({
  searchActive,
  mobile
}) => searchActive && !mobile && css(["padding-top:8px;margin-top:-8px;height:auto;max-height:808px;border-radius:24px;"]), ({
  searchActive,
  mobile,
  isScrolledToTop
}) => searchActive && mobile && css(["position:fixed;top:", ";height:100vh;left:0;right:0;bottom:0;border-radius:0;"], (!isScrolledToTop ? TOP_HEADER_HEIGHT : 0) + 8 + 'px'));
const Form = /*#__PURE__*/styled.form.withConfig({
  displayName: "styles__Form",
  componentId: "sc-1uhyrl-2"
})(["position:relative;display:flex;align-items:center;", " width:100%;gap:8px;padding:", ";"], ({
  mobile,
  searchActive
}) => heightStyle({
  mobile,
  searchActive
}), ({
  theme
}) => `0 ${theme.spacers.M}`);
const SearchButton = /*#__PURE__*/styled.section.withConfig({
  displayName: "styles__SearchButton",
  componentId: "sc-1uhyrl-3"
})(["display:flex;position:absolute;left:", ";"], ({
  theme
}) => theme.spacers.XL);
const SearchBar = /*#__PURE__*/styled.input.withConfig({
  displayName: "styles__SearchBar",
  componentId: "sc-1uhyrl-4"
})(["display:flex;align-items:center;flex:1;", ";font-weight:700;font-size:16px;line-height:24px;", " padding:", ";border-radius:100px;border:2px solid ", ";background-color:transparent;color:", ";outline:transparent;caret-color:", ";&::-webkit-search-cancel-button{-webkit-appearance:none;outline:none;}"], ({
  theme
}) => theme.typography.Paragraph, ({
  mobile,
  searchActive
}) => heightStyle({
  mobile,
  searchActive
}), ({
  theme
}) => `0 0 0 ${theme.spacers['4XL']}`, ({
  searchActive,
  theme
}) => searchActive ? theme.palette.grey[100] : theme.palette.grey[7], ({
  theme
}) => theme.colors.Foreground, ({
  theme
}) => theme.palette.grey[100]);
const ClearButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "styles__ClearButton",
  componentId: "sc-1uhyrl-5"
})(["cursor:pointer;display:flex;position:absolute;right:", ";background-color:transparent;"], ({
  theme
}) => theme.spacers.L);

const SearchIcon = ({
  className,
  color: _color = '#333333',
  size: _size = '24'
}) => {
  return jsx("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.1922 15.6064C13.0236 16.4816 11.5723 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 11.5723 16.4816 13.0236 15.6064 14.1922L20.707 19.2929C21.0976 19.6834 21.0976 20.3166 20.707 20.7071C20.3165 21.0976 19.6834 21.0976 19.2928 20.7071L14.1922 15.6064ZM15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10Z",
      fill: _color
    })
  }));
};

const searchIconUrl = 'https://res.cloudinary.com/grover/image/upload/v1646153280/static/search.svg';
const clockRecentSearchIconUrl = 'https://res.cloudinary.com/grover/image/upload/v1646153280/static/clock-recent-search.svg';

const Highlighter = ({
  text,
  highlight,
  className
}) => {
  const regex = new RegExp(`(${highlight.trim()})`, 'gi');
  const parts = text.split(regex).filter(Boolean);
  return jsx("span", Object.assign({
    className: className
  }, {
    children: parts.map((part, i) => regex.test(part) ? jsx("mark", {
      children: part
    }, i) : jsx(Fragment, {
      children: part
    }, i))
  }));
};

const Arrow = ({
  color,
  className
}) => jsx("svg", Object.assign({
  width: "18",
  height: "14",
  viewBox: "0 0 18 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: className
}, {
  children: jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29264 13.707C8.90211 13.3165 8.90211 12.6833 9.29264 12.2928L13.5855 7.99988L0.999743 7.99988C0.447457 7.99988 -0.000256928 7.55216 -0.00025688 6.99988C-0.000256832 6.44759 0.447457 5.99988 0.999743 5.99988L13.5855 5.99988L9.29264 1.70698C8.90211 1.31646 8.90211 0.683295 9.29264 0.292771C9.68316 -0.0977542 10.3163 -0.0977541 10.7068 0.292771L17.414 6.99988L10.7068 13.707C10.3163 14.0975 9.68316 14.0975 9.29264 13.707Z",
    fill: color
  })
}));
Arrow.defaultProps = {
  className: undefined,
  color: 'rgba(255, 255, 255, 0.28)'
};

const List = /*#__PURE__*/styled.ul.withConfig({
  displayName: "search-result-sectionstyles__List",
  componentId: "gctlsj-0"
})(["list-style:none;margin:0;padding:0;"]);
const Image = /*#__PURE__*/styled.img.withConfig({
  displayName: "search-result-sectionstyles__Image",
  componentId: "gctlsj-1"
})(["height:32px;width:32px;margin-right:12px;flex:0 0 auto;object-fit:contain;"]);
const NavigationLink$1 = /*#__PURE__*/styled(Link$2).withConfig({
  displayName: "search-result-sectionstyles__NavigationLink",
  componentId: "gctlsj-2"
})(["", ";color:", ";padding:", ";text-decoration:none;display:flex;align-items:center;border-radius:8px;cursor:pointer;padding:0 16px;&:hover,&:focus{background-color:#f1f1f1;outline:none;align-items:center;border-radius:0px;}height:", ";"], ({
  theme
}) => theme.typography.Paragraph, ({
  theme
}) => theme.colors.Foreground, ({
  theme
}) => `${theme.spacers.M} 0`, ({
  showFeature
}) => showFeature ? '58px' : '48px');
const baseListItemIconStyle = /*#__PURE__*/css(["margin-right:", ";position:relative;width:24px;height:24px;"], ({
  theme
}) => theme.spacers.M);
const CategoryIcon = /*#__PURE__*/styled(SonntagIcon).withConfig({
  displayName: "search-result-sectionstyles__CategoryIcon",
  componentId: "gctlsj-3"
})(["", ""], baseListItemIconStyle);
const RecentSearchTermIcon = /*#__PURE__*/styled.div.withConfig({
  displayName: "search-result-sectionstyles__RecentSearchTermIcon",
  componentId: "gctlsj-4"
})(["background:url(", ");", ""], clockRecentSearchIconUrl, baseListItemIconStyle);
const SearchTermIcon = /*#__PURE__*/styled.div.withConfig({
  displayName: "search-result-sectionstyles__SearchTermIcon",
  componentId: "gctlsj-5"
})(["background:url(", ");", ""], searchIconUrl, baseListItemIconStyle);
const HighlightedText = /*#__PURE__*/styled(Highlighter).withConfig({
  displayName: "search-result-sectionstyles__HighlightedText",
  componentId: "gctlsj-6"
})(["text-overflow:ellipsis;overflow:hidden;white-space:nowrap;mark{background-color:transparent;color:inherit;font-weight:600;}"]);
const ArrowIcon = /*#__PURE__*/styled(Arrow).attrs(({
  theme
}) => ({
  color: theme.colors['Level 3']
})).withConfig({
  displayName: "search-result-sectionstyles__ArrowIcon",
  componentId: "gctlsj-7"
})(["margin-left:auto;flex-shrink:0;&.arrow-up{transform:rotate(-45deg);}"]);
const TextWrap = /*#__PURE__*/styled.div.withConfig({
  displayName: "search-result-sectionstyles__TextWrap",
  componentId: "gctlsj-8"
})(["display:flex;flex-direction:column;justify-content:center;overflow:hidden;margin-right:", ";line-height:24px;"], ({
  theme
}) => theme.spacers.S);
const Features = /*#__PURE__*/styled(Highlighter).withConfig({
  displayName: "search-result-sectionstyles__Features",
  componentId: "gctlsj-9"
})(["", ";white-space:nowrap;text-overflow:ellipsis;overflow:hidden;line-height:18px;color:#999999;mark{background-color:transparent;color:inherit;font-weight:600;}"], ({
  theme
}) => theme.typography.TinyParagraph);
const NoResultsText = /*#__PURE__*/styled.p.withConfig({
  displayName: "search-result-sectionstyles__NoResultsText",
  componentId: "gctlsj-10"
})(["", ";color:", ";margin-bottom:", ";padding-left:16px;"], ({
  theme
}) => theme.typography.Paragraph, ({
  theme
}) => theme.colors.Foreground, ({
  theme
}) => theme.spacers.L);

const Container$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "search-result-section-container__Container",
  componentId: "sc-1xu40dc-0"
})(["display:flex;flex-direction:column;margin-bottom:", ";margin-top:16px;"], ({
  theme
}) => theme.spacers.L);
const TitleContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "search-result-section-container__TitleContainer",
  componentId: "sc-1xu40dc-1"
})(["margin-bottom:", ";padding:0px 16px;.smallDivider{", ";font-weight:800;line-height:14.4px;font-size:12px;color:#666666;::after{height:2px;}}"], ({
  theme
}) => theme.spacers.M, ({
  theme
}) => theme.typography.SmallCapsHeadline);
const SearchResultSectionContainer = ({
  title,
  children
}) => {
  return jsxs(Container$1, Object.assign({
    "data-testid": "search-result-section"
  }, {
    children: [jsx(TitleContainer, {
      children: jsx(SectionHead, {
        title: title,
        classNames: {
          sectionHead: 'smallDivider'
        }
      })
    }), children]
  }));
};

const SearchResultSection = ({
  section,
  onNavigate,
  storeId,
  query,
  setQuery
}) => {
  const {
    title,
    emptyText,
    items,
    highlight
  } = section;
  const isRecentSearchTerm = false;

  const handleClick = item => {
    if (item.type === SearchResultSectionItemType.product) return;

    if (item.type === SearchResultSectionItemType.popularSearch) {
      return setQuery === null || setQuery === void 0 ? void 0 : setQuery(item.link.text);
    }

    setQuery === null || setQuery === void 0 ? void 0 : setQuery('');
  };

  const content = !items.length ? jsx(NoResultsText, {
    children: emptyText
  }) : jsx(List, {
    children: items.map(item => {
      const {
        link,
        imageUrl,
        description,
        parentCategoryText
      } = item;
      const {
        url,
        svgPath,
        text
      } = link;
      return jsx("li", {
        children: jsxs(NavigationLink$1, Object.assign({
          link: link,
          onNavigate: onNavigate,
          onClick: () => handleClick(item),
          testId: `search-result-section-link-${item.type}`,
          showFeature: Boolean(description || parentCategoryText)
        }, {
          children: [imageUrl ? jsx(Image, {
            alt: text,
            src: imageUrl
          }) : svgPath ? jsx(CategoryIcon, {
            iconPath: svgPath
          }) : !highlight && isRecentSearchTerm ? jsx(RecentSearchTermIcon, {}) : jsx(SearchTermIcon, {}), jsxs(TextWrap, {
            children: [highlight ? jsx(HighlightedText, {
              text: text,
              highlight: highlight
            }) : jsx("span", {
              children: text
            }), jsx(Features, {
              text: description || parentCategoryText || '',
              highlight: highlight || ''
            })]
          }), jsx(ArrowIcon, {
            className: item.type === SearchResultSectionItemType.popularSearch ? 'arrow-up' : ''
          })]
        }))
      }, url);
    })
  });
  return jsx(SearchResultSectionContainer, Object.assign({
    title: title
  }, {
    children: content
  }));
};

const Wrap$2 = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styles__Wrap",
  componentId: "fi9ty3-0"
})(["padding:0;list-style:none;display:grid;margin:", " 0;grid-gap:", ";grid-template-columns:repeat(2,2fr);@media (", "){grid-template-columns:repeat(3,1fr);}@media (", "){grid-template-columns:repeat(2,1fr);}@media (", "){grid-template-columns:repeat(3,1fr);}@media (", "){grid-template-columns:repeat(4,1fr);}"], ({
  theme
}) => theme.spacers.L, ({
  theme
}) => theme.spacers.L, ({
  theme
}) => theme.screens.tablet, ({
  theme
}) => theme.screens.desktop, ({
  theme
}) => theme.screens.largeDesktop, ({
  theme
}) => theme.screens.wideDesktop);
const itemStyles = /*#__PURE__*/css(["", ";color:", ";background-color:", ";border-radius:8px;height:117px;word-break:break-word;text-align:center;padding-bottom:", ";&:hover{box-shadow:0px 0px 3px rgba(0,0,0,0.05),0px 4px 10px rgba(0,0,0,0.13);}@media (", "){height:176px;padding-bottom:", ";}"], ({
  theme
}) => theme.typography.Paragraph, ({
  theme
}) => theme.colors.secondary, ({
  theme
}) => theme.palette.grey[4], ({
  theme
}) => theme.spacers.M, ({
  theme
}) => theme.screens.tablet, ({
  theme
}) => theme.spacers.L);
const ShowAllButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "styles__ShowAllButton",
  componentId: "fi9ty3-1"
})(["", ";border:none;cursor:pointer;width:100%;text-align:center;padding:0;display:flex;align-items:center;justify-content:center;"], itemStyles);
const ButtonText = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__ButtonText",
  componentId: "fi9ty3-2"
})(["background:transparent;line-height:150%;text-align:center;font-size:16px;font-weight:700;text-decoration-line:underline;color:", ";"], ({
  theme
}) => theme.palette.grey[100]);
const NavigationLink = /*#__PURE__*/styled(Link$2).withConfig({
  displayName: "styles__NavigationLink",
  componentId: "fi9ty3-3"
})(["", ";display:flex;flex-direction:column;justify-content:center;align-items:center;text-decoration:none;"], itemStyles);
const ImageWrap = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__ImageWrap",
  componentId: "fi9ty3-4"
})(["position:relative;height:100%;width:100%;display:flex;justify-content:center;"]);
const CategoryImage = /*#__PURE__*/styled.img.withConfig({
  displayName: "styles__CategoryImage",
  componentId: "fi9ty3-5"
})(["position:absolute;height:100%;"]);
const TextContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__TextContainer",
  componentId: "fi9ty3-6"
})(["hyphens:auto;font-size:14px;line-height:150%;color:", ";@media (", "){font-size:16px;}"], ({
  theme
}) => theme.palette.grey[100], ({
  theme
}) => theme.screens.tablet);

const shimmerImageUrl = 'https://res.cloudinary.com/grover/image/upload/v1689781339/categories-widget/shimmerImage.gif';
const NUM_COLLAPSED_CATEGORY_ITEMS = 5;

const Item = ({
  link,
  text,
  imageUrl,
  onNavigate
}) => {
  const [src, setSrc] = useState(imageUrl !== null && imageUrl !== void 0 ? imageUrl : shimmerImageUrl);
  return jsxs(NavigationLink, Object.assign({
    link: link,
    onNavigate: onNavigate,
    "data-testid": "link",
    testId: "category-preview"
  }, {
    children: [jsx(ImageWrap, {
      children: jsx(CategoryImage, {
        src: src,
        alt: text,
        onError: () => setSrc(shimmerImageUrl)
      })
    }), jsx(TextContainer, {
      children: text
    })]
  }));
};

const CategoryPills = ({
  categories,
  isDesktop,
  onNavigate,
  searchCategoriesShowAllLabel
}) => {
  const [collapsed, setCollapsed] = useState(!isDesktop);
  const visibleItems = useMemo(() => {
    return collapsed ? categories.slice(0, NUM_COLLAPSED_CATEGORY_ITEMS) : categories;
  }, [collapsed, categories]);
  return jsxs(Wrap$2, {
    children: [visibleItems.map(category => {
      const {
        id,
        link,
        coverImageUrl
      } = category;
      const {
        text
      } = link;
      return jsx("li", {
        children: jsx(Item, {
          link: link,
          text: text,
          imageUrl: coverImageUrl,
          onNavigate: onNavigate
        })
      }, id);
    }), collapsed && jsx("li", {
      children: jsx(ShowAllButton, Object.assign({
        onClick: () => setCollapsed(false)
      }, {
        children: jsx(ButtonText, {
          children: searchCategoriesShowAllLabel
        })
      }), "show-all")
    })]
  });
};

const inOutTransitionFunction = 'cubic-bezier(0.4, 0.0, 0.2, 1)';
const animationDurationInMs = 1400;
const rotationKeyframe = /*#__PURE__*/keyframes(["from{transform:rotate(0deg);}to{transform:rotate(270deg);}"]);
const rotationKeyframeRule = /*#__PURE__*/css(
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
// @ts-ignore: No overload matches this call.
['', ` ${animationDurationInMs}ms linear infinite;`], rotationKeyframe);
const dashKeyframe = /*#__PURE__*/keyframes(["50%{transform:rotate(135deg);}100%{transform:rotate(450deg);}"]);
const dashKeyframeRule = /*#__PURE__*/css(
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
// @ts-ignore: No overload matches this call.
['', ` ${animationDurationInMs}ms ${inOutTransitionFunction} infinite`], dashKeyframe);
const SpinnerContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__SpinnerContainer",
  componentId: "sc-1xgvbb0-0"
})(["width:45px;height:45px;animation:", ";"], rotationKeyframeRule);
const SpinnerCircle = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__SpinnerCircle",
  componentId: "sc-1xgvbb0-1"
})(["border-left-color:", ";border-top-color:", ";box-sizing:border-box;border-width:4px;border-style:solid;width:100%;height:100%;border-radius:50%;border-right-color:transparent;border-bottom-color:transparent;animation:", ";"], ({
  theme
}) => theme.colors.Color1_75, ({
  theme
}) => theme.colors.Color1_75, dashKeyframeRule);
const Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-1xgvbb0-2"
})(["flex-shrink:0;flex-grow:1;display:flex;justify-content:center;align-items:center;width:100%;height:100%;"]);

const Spinner = () => jsx(SpinnerContainer, {
  children: jsx(SpinnerCircle, {})
});

const CircleLoader = ({
  className: _className = ''
}) => jsx(Container, Object.assign({
  className: _className
}, {
  children: jsx(Spinner, {})
}));

const commonWrap = /*#__PURE__*/css(["width:100%;display:block;overflow-y:auto;height:100vh;@media (", "){height:auto;max-height:calc(100% - 60px);padding-bottom:0;}"], ({
  theme
}) => theme.screens.tablet);
const Wrap$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__Wrap",
  componentId: "sc-6b8ivr-0"
})(["", ";padding:", ";"], commonWrap, ({
  theme
}) => `0 ${theme.spacers.L} ${theme.spacers.XL} ${theme.spacers.L}`);
const WrapResult = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__WrapResult",
  componentId: "sc-6b8ivr-1"
})(["", ""], commonWrap);
const Loader = /*#__PURE__*/styled(CircleLoader).withConfig({
  displayName: "styles__Loader",
  componentId: "sc-6b8ivr-2"
})(["height:64px;margin-top:", ";@media (", "){margin-top:16px;}"], ({
  theme
}) => theme.spacers.XXL, ({
  theme
}) => theme.screens.tablet);
const Button$1 = /*#__PURE__*/styled.button.withConfig({
  displayName: "styles__Button",
  componentId: "sc-6b8ivr-4"
})(["color:", ";", ";background-color:transparent;font-weight:700;font-size:16px;line-height:24px;color:", ";text-decoration:underline;text-underline-offset:4px;padding:12px 16px;border-radius:88px;margin:8px 16px 24px 0px;width:100%;height:48px;cursor:pointer;transition:all 0.3s;&:hover{background:#f1f1f1;}display:flex;align-items:center;justify-content:center;@media (", "){width:fit-content;margin-left:0px;justify-content:start;}"], ({
  theme
}) => theme.colors.Foreground, props => props.theme.typography.SmallHeadline, ({
  theme
}) => theme.palette.grey[100], ({
  theme
}) => theme.screens.desktop);
const ButtonWrapper$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__ButtonWrapper",
  componentId: "sc-6b8ivr-5"
})(["padding:0px 16px;"]);
const EmptyResult = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__EmptyResult",
  componentId: "sc-6b8ivr-6"
})(["height:8px;"]);

const SearchContent = ({
  isDesktop,
  isLoading,
  query,
  categories,
  searchResult,
  setQuery,
  onNavigate,
  storeId,
  searchCategoriesShowAllLabel
}) => {
  const ref = useRef(null);
  const wrapProps = {
    ref
  };

  if (isLoading) {
    return jsx(Wrap$1, Object.assign({}, wrapProps, {
      children: jsx(Loader, {})
    }));
  }

  if (!query) {
    return jsx(Wrap$1, Object.assign({}, wrapProps, {
      children: jsx(CategoryPills, {
        isDesktop: isDesktop,
        categories: categories,
        onNavigate: onNavigate,
        searchCategoriesShowAllLabel: searchCategoriesShowAllLabel
      })
    }));
  }

  if (!searchResult || !query) {
    return jsx(EmptyResult, {});
  }

  const noResultsSection = searchResult.sections.find(s => s.items.length === 0 && s.emptyText);
  return jsxs(WrapResult, Object.assign({}, wrapProps, {
    children: [searchResult.sections.map(section => {
      return jsx(SearchResultSection, {
        section: section,
        onNavigate: onNavigate,
        setQuery: setQuery,
        storeId: storeId,
        query: query
      }, section.title);
    }), !noResultsSection && jsx(ButtonWrapper$1, {
      children: jsx(Link$2, Object.assign({
        link: searchResult.showAllLink,
        onNavigate: onNavigate
      }, {
        children: jsx(Button$1, {
          children: searchResult.showAllLink.text
        })
      }))
    })]
  }));
};

const OverlayWrapper$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__OverlayWrapper",
  componentId: "sc-1ywbz1b-0"
})(["z-index:1;position:fixed;display:flex;justify-content:flex-start;align-items:center;bottom:0;left:0;right:0;top:0;overflow-y:auto;height:", ";max-height:100vh;-webkit-tap-highlight-color:transparent;cursor:pointer;background:none;visibility:hidden;@media (", "){height:100vh;}transition:all 0.2s cubic-bezier(0.3,0,0.4,1);", ""], ({
  vh
}) => vh ? `${vh}px` : '100vh', ({
  theme
}) => theme.screens.tablet, ({
  theme,
  visible
}) => visible && css(["@media (", "){background:rgba(0,0,0,0.5);visibility:visible;transition:all 0.2s cubic-bezier(0.4,0,0.6,1);};"], theme.screens.desktop));

const Overlay$1 = ({
  className,
  children,
  visible,
  id,
  onClickOverlay
}) => {
  const {
    lockScroll,
    unlockScroll
  } = useScrollLock();
  useEffect(() => {
    if (visible) {
      lockScroll();
    } else {
      unlockScroll();
    }
  }, [visible, lockScroll, unlockScroll]);
  return jsx(OverlayWrapper$1, Object.assign({
    className: className,
    visible: visible,
    id: id || undefined,
    onClick: onClickOverlay,
    vh: typeof window !== 'undefined' ? window.innerHeight : undefined
  }, {
    children: children
  }));
};

const ANIMATION_DURATION_IN_MS = 200;
const Wrap = /*#__PURE__*/styled.div.withConfig({
  displayName: "search-suggestionsstyles__Wrap",
  componentId: "rs28ay-0"
})(["display:flex;flex-wrap:nowrap;width:100%;pointer-events:none;position:absolute;max-width:calc(100% - 70px);top:0;bottom:0;left:59px;white-space:nowrap;overflow-x:hidden;"]);
const SuggestionList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "search-suggestionsstyles__SuggestionList",
  componentId: "rs28ay-1"
})(["padding:0;margin:0;position:relative;width:inherit;display:flex;align-items:center;"]);
const Suggestion = /*#__PURE__*/styled.li.withConfig({
  displayName: "search-suggestionsstyles__Suggestion",
  componentId: "rs28ay-2"
})(["display:flex;align-items:center;gap:8px;list-style:none;position:absolute;", ";line-height:normal;color:#666666;opacity:0;transition-property:opacity;transition-duration:", "ms;transition-timing-function:ease;&.categoryText-enter-active,&.categoryText-exit-active{opacity:0.5;}&.categoryText-enter-done{opacity:1;}&.categoryText-exit-done{opacity:0;}"], ({
  theme
}) => theme.typography.Paragraph, ANIMATION_DURATION_IN_MS);

const SearchSuggestions = ({
  categories,
  userDevice
}) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const isMobile = userDevice === "mobile"
  /* Mobile */
  ;
  const {
    t
  } = useTranslation();
  const suggestions = useMemo(() => categories.reduce((acc, item) => {
    var _a;

    const subCategories = (_a = item.children) !== null && _a !== void 0 ? _a : [];
    const translatedSearch = isMobile ? '' : t('SEARCHBAR_PLACEHOLDER_TEXT_STATIC');
    const childrenTitles = subCategories.map(one => {
      const translatedCategory = t('SEARCHBAR_PLACEHOLDER_TEXT_CATEGORY', {
        categoryName: one.link.text
      });
      return `${translatedSearch} ${translatedCategory}`;
    });
    return [...acc, ...childrenTitles];
  }, []), [categories, isMobile, t]);
  const updateRandomPlaceholder = useCallback(() => setActiveIndex(Math.floor(Math.random() * suggestions.length)), [suggestions]);
  useEffect(() => {
    updateRandomPlaceholder();
    const categoryNameInterval = setInterval(() => updateRandomPlaceholder(), 5000);
    return () => clearInterval(categoryNameInterval);
  }, [updateRandomPlaceholder]);
  return jsx(Wrap, {
    children: jsx(SuggestionList, {
      children: suggestions.map((item, index) => jsx(CSSTransition, Object.assign({
        timeout: ANIMATION_DURATION_IN_MS,
        classNames: "categoryText",
        in: index === activeIndex,
        out: index !== activeIndex
      }, {
        children: jsx(Suggestion, {
          children: item
        })
      }), index))
    })
  });
};

const Search = ({
  userDevice,
  query,
  onQueryChange,
  categories,
  searchLoading,
  searchResult,
  searchCategoriesShowAllLabel,
  onNavigate,
  storeId,
  store,
  locale,
  mobile,
  consumer
}) => {
  const theme = useContext(ThemeContext);
  const [searchActive, setSearchActive] = useState(false);
  const {
    isScrolledToTop
  } = useHideOnScroll();

  const handleOpen = () => {
    setSearchActive(true);
  };

  const handleClose = () => {
    setSearchActive(false);
  };

  const handleClear = () => {
    onQueryChange('');
    handleClose();
  };

  const handleNavigation = ({
    url
  }) => {
    onNavigate({
      url
    });
    handleClose();
  };

  const handleSubmit = e => {
    e.preventDefault();
    const url = `/${store}-${locale}/search?filter=search%3D${query}`;

    if (consumer === HeaderConsumer.catalog) {
      return handleNavigation({
        url
      });
    }

    window.location.href = url;
  };

  const handleQueryChange = e => {
    onQueryChange(e.target.value);
  };

  return jsxs(OuterWrap, Object.assign({
    searchActive: searchActive,
    mobile: mobile
  }, {
    children: [jsx(Overlay$1, {
      visible: searchActive,
      onClickOverlay: handleClose
    }), jsxs(InnerWrap, Object.assign({
      searchActive: searchActive,
      mobile: mobile,
      isScrolledToTop: isScrolledToTop
    }, {
      children: [jsxs(Form, Object.assign({
        onSubmit: handleSubmit,
        searchActive: searchActive,
        mobile: mobile
      }, {
        children: [jsx(SearchButton, {
          children: jsx(SearchIcon, {
            color: theme.colors.Foreground
          })
        }), !query && jsx(SearchSuggestions, {
          categories: categories,
          userDevice: userDevice
        }), jsx(SearchBar, {
          mobile: mobile,
          type: "text",
          autoComplete: "off",
          onChange: handleQueryChange,
          value: query,
          onFocus: handleOpen,
          id: "searchInput",
          searchActive: searchActive,
          "data-testid": "search-input"
        }), searchActive && jsx(ClearButton, Object.assign({
          onClick: handleClear,
          type: "button"
        }, {
          children: jsx(CloseCrossIcon, {
            color: theme.colors.Foreground
          })
        }))]
      })), searchActive ? jsx(SearchContent, {
        searchCategoriesShowAllLabel: searchCategoriesShowAllLabel,
        isDesktop: userDevice === "desktop"
        /* Desktop */
        ,
        isLoading: searchLoading,
        query: query,
        categories: categories,
        searchResult: searchResult,
        setQuery: title => onQueryChange(title),
        onNavigate: handleNavigation,
        storeId: storeId
      }) : null]
    }))]
  }));
};

const FavoriteIcon = ({
  className,
  color,
  size: _size = '24'
}) => {
  return jsx("svg", Object.assign({
    className: className,
    width: _size,
    height: _size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.6808 20.7465C12.2909 21.0845 11.7091 21.0845 11.3192 20.7465C7.62139 17.5408 2 13.6123 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 13.6123 16.3786 17.5408 12.6808 20.7465ZM12 18.6454C14.7015 16.1861 20 12.6565 20 8.5C20 6.51695 18.4778 5 16.5 5C14.3913 5 13.2329 6.71438 12 8.15086C10.7671 6.71438 9.60866 5 7.5 5C5.52219 5 4 6.51695 4 8.5C4 12.6571 9.29799 16.1855 12 18.6454Z",
      fill: "#333333"
    })
  }));
};

const Favorites = _a => {
  var {
    links,
    storeId,
    favorites,
    sendAnalyticsFunctionFromConsumer
  } = _a,
      restProps = __rest(_a, ["links", "storeId", "favorites", "sendAnalyticsFunctionFromConsumer"]);

  const {
    sendNavigationClickEvent
  } = useTracking({
    storeId,
    sendAnalyticsFunctionFromConsumer
  });
  const wishListLink = links === null || links === void 0 ? void 0 : links[1];
  if (!wishListLink) return jsx(HeaderActionWrapper, {
    children: jsx(FavoriteIcon, {})
  });
  return jsx(HeaderActionWrapper, {
    children: jsxs(Link$2, Object.assign({}, restProps, {
      link: wishListLink,
      onClick: () => sendNavigationClickEvent({
        destinationUrl: wishListLink.url,
        group: NAVIGATION_GROUP_TYPE.WISHLIST
      })
    }, {
      children: [jsx(FavoriteIcon, {}), jsx(Badge, {
        value: favorites
      })]
    }))
  });
};

const MobileOptionsWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__MobileOptionsWrapper",
  componentId: "fm4tzf-0"
})(["display:flex;flex-direction:column;padding:", ";margin:0 ", ";border:2px solid #f1f1f1;border-radius:8px;"], ({
  theme
}) => `${theme.spacers.S} ${theme.spacers.L}`, ({
  theme
}) => theme.spacers.XL);
const DesktopOptionsHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__DesktopOptionsHeader",
  componentId: "fm4tzf-1"
})(["", " display:flex;align-items:center;width:100%;color:#666;padding:12px 0 12px 24px;gap:8px;&:after{flex:1;height:2px;content:' ';background-color:#f1f1f1;}"], ({
  theme
}) => theme.typography.SmallCapsHeadline);
const MobileOptionsHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__MobileOptionsHeader",
  componentId: "fm4tzf-2"
})(["", ";color:", ";padding:", ";"], ({
  theme
}) => theme.typography.SmallCapsHeadline, ({
  theme
}) => theme.palette.grey[75], ({
  theme,
  noPaddingTop
}) => `${noPaddingTop ? theme.spacers.L : theme.spacers.XXL} 
    0 ${theme.spacers.L} ${theme.spacers.XL}`);
const DesktopOption = /*#__PURE__*/styled(MenuItem).withConfig({
  displayName: "styles__DesktopOption",
  componentId: "fm4tzf-3"
})([""]);
const MobileOption = /*#__PURE__*/styled(MenuItem).withConfig({
  displayName: "styles__MobileOption",
  componentId: "fm4tzf-4"
})(["padding:", " 0;&:not(:last-child){border-bottom:2px solid #f1f1f1;}"], ({
  theme
}) => theme.spacers.L);
const OptionContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__OptionContent",
  componentId: "fm4tzf-5"
})(["", ";display:flex;align-items:center;gap:", ";font-weight:", ";"], ({
  theme,
  mobile
}) => mobile && theme.typography.SmallHeadline, ({
  mobile,
  theme
}) => mobile ? theme.spacers.M : theme.spacers.L, ({
  mobile
}) => mobile ? '700' : '500');
const ButtonWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__ButtonWrapper",
  componentId: "fm4tzf-6"
})(["display:flex;align-items:center;gap:4px;padding:", ";"], ({
  theme
}) => `${theme.spacers.XS}`);
const LanguageText = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__LanguageText",
  componentId: "fm4tzf-7"
})(["", " font-size:14px;font-weight:700;line-height:20.33px;text-transform:uppercase;"], ({
  theme
}) => theme.typography.TinyParagraph);

const GermanFlagIcon = ({
  className,
  color,
  size: _size = '24'
}) => {
  return jsxs("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsxs("g", Object.assign({
      clipPath: "url(#clip0_2632_33685)"
    }, {
      children: [jsx("path", {
        d: "M0 13.333H20V19.9997H0V13.333Z",
        fill: "#FFCE00"
      }), jsx("path", {
        d: "M0 0H20V6.66667H0V0Z",
        fill: "black"
      }), jsx("path", {
        d: "M0 6.66699H20V13.3337H0V6.66699Z",
        fill: "#DD0000"
      })]
    })), jsx("defs", {
      children: jsx("clipPath", Object.assign({
        id: "clip0_2632_33685"
      }, {
        children: jsx("rect", {
          width: "20",
          height: "19.9997",
          rx: "9.99984",
          fill: "white"
        })
      }))
    })]
  }));
};

const AustriaFlagIcon = () => {
  return jsxs("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsxs("g", Object.assign({
      clipPath: "url(#clip0_1486_4635)"
    }, {
      children: [jsx("path", {
        d: "M19.378 13.4784C19.78 12.3951 20 11.2234 20 10.0002C20 8.77696 19.78 7.60528 19.378 6.52192L10 5.65234L0.621992 6.52192C0.220039 7.60528 0 8.77696 0 10.0002C0 11.2234 0.220039 12.3951 0.621992 13.4784L10 14.348L19.378 13.4784Z",
        fill: "white"
      }), jsx("path", {
        d: "M10.0001 20.0003C14.2997 20.0003 17.9652 17.2865 19.3781 13.4785H0.62207C2.03504 17.2865 5.70043 20.0003 10.0001 20.0003Z",
        fill: "#D80027"
      }), jsx("path", {
        d: "M10.0001 0C5.70043 0 2.03504 2.71375 0.62207 6.52176H19.3781C17.9652 2.71375 14.2997 0 10.0001 0Z",
        fill: "#D80027"
      })]
    })), jsx("defs", {
      children: jsx("clipPath", Object.assign({
        id: "clip0_1486_4635"
      }, {
        children: jsx("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      }))
    })]
  }));
};

const UnitedStatesFlagIcon = () => {
  return jsxs("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsxs("g", Object.assign({
      clipPath: "url(#clip0_1486_4655)"
    }, {
      children: [jsx("mask", Object.assign({
        id: "mask0_1486_4655",
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "20",
        height: "20"
      }, {
        children: jsx("path", {
          d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
          fill: "#F0F0F0"
        })
      })), jsxs("g", Object.assign({
        mask: "url(#mask0_1486_4655)"
      }, {
        children: [jsx("path", {
          d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
          fill: "white"
        }), jsx("rect", {
          x: "-1.66699",
          y: "12.5",
          width: "23.3333",
          height: "2.5",
          fill: "#D80027"
        }), jsx("rect", {
          x: "-1.66699",
          y: "17.5",
          width: "23.3333",
          height: "2.5",
          fill: "#D80027"
        }), jsx("rect", {
          x: "-1.66699",
          y: "7.5",
          width: "23.3333",
          height: "2.5",
          fill: "#D80027"
        }), jsx("rect", {
          x: "-1.66699",
          y: "2.5",
          width: "23.3333",
          height: "2.5",
          fill: "#D80027"
        }), jsx("rect", {
          x: "-2.5",
          y: "-1.6665",
          width: "12.5",
          height: "11.6667",
          fill: "#0052B4"
        })]
      }))]
    })), jsx("defs", {
      children: jsx("clipPath", Object.assign({
        id: "clip0_1486_4655"
      }, {
        children: jsx("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      }))
    })]
  }));
};

const SpainFlagIcon = () => {
  return jsxs("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsxs("g", Object.assign({
      clipPath: "url(#clip0_1486_4650)"
    }, {
      children: [jsx("path", {
        d: "M-3.33301 0H23.3337V20H-3.33301V0Z",
        fill: "#C60B1E"
      }), jsx("path", {
        d: "M-3.33301 5H23.3337V15H-3.33301V5Z",
        fill: "#FFC400"
      })]
    })), jsx("defs", {
      children: jsx("clipPath", Object.assign({
        id: "clip0_1486_4650"
      }, {
        children: jsx("rect", {
          width: "20",
          height: "20",
          rx: "10",
          fill: "white"
        })
      }))
    })]
  }));
};

const NetherlandsFlagIcon = () => {
  return jsxs("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsxs("g", Object.assign({
      clipPath: "url(#clip0_1486_4644)"
    }, {
      children: [jsx("path", {
        d: "M23.3337 0H-3.33301V19.9141H23.3337V0Z",
        fill: "white"
      }), jsx("path", {
        d: "M23.3337 13.3633H-3.33301V20H23.3337V13.3633Z",
        fill: "#21468B"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M-3.33301 0H23.3337V6.64062H-3.33301V0Z",
        fill: "#AE1C28"
      })]
    })), jsx("defs", {
      children: jsx("clipPath", Object.assign({
        id: "clip0_1486_4644"
      }, {
        children: jsx("rect", {
          width: "20",
          height: "20",
          rx: "10",
          fill: "white"
        })
      }))
    })]
  }));
};

const storeIconMap = new Map([[HeaderStore.de, jsx(GermanFlagIcon, {})], [HeaderStore.at, jsx(AustriaFlagIcon, {})], [HeaderStore.nl, jsx(NetherlandsFlagIcon, {})], [HeaderStore.es, jsx(SpainFlagIcon, {})], [HeaderStore.us, jsx(UnitedStatesFlagIcon, {})], [HeaderStore.business, jsx(GermanFlagIcon, {})], [HeaderStore.business_nl, jsx(NetherlandsFlagIcon, {})], [HeaderStore.business_es, jsx(SpainFlagIcon, {})], [HeaderStore.business_us, jsx(UnitedStatesFlagIcon, {})], [HeaderStore.business_at, jsx(AustriaFlagIcon, {})]]);

const TickIcon = () => {
  return jsx("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, {
    children: jsx("g", Object.assign({
      id: "16px Check"
    }, {
      children: jsx("path", {
        id: "Vector",
        d: "M7 12L10 15L17 9",
        stroke: "#333333",
        strokeWidth: "2",
        strokeLinecap: "round"
      })
    }))
  }));
};

const Option = ({
  children,
  handleSelect,
  value,
  activeValue,
  mobile: _mobile = false
}) => {
  const OptionWrapper = _mobile ? MobileOption : DesktopOption;
  return jsxs(OptionWrapper, Object.assign({
    onClick: () => handleSelect(value)
  }, {
    children: [jsx(OptionContent, Object.assign({
      mobile: _mobile
    }, {
      children: children
    })), activeValue === value && jsx(TickIcon, {})]
  }));
};

const StoreOptions = ({
  activeStore,
  storeOptions,
  handleStoreChange,
  mobile,
  storeId,
  sendAnalyticsFunctionFromConsumer
}) => {
  const [selectedStore, setSelectedStore] = useState(activeStore);
  const {
    sendStoreLanguageSelectorEvent
  } = useTracking({
    storeId,
    sendAnalyticsFunctionFromConsumer
  });

  const handleClick = value => {
    setSelectedStore(value);
    sendStoreLanguageSelectorEvent({
      event: SEGMENT_EVENTS.storeChanged,
      store: value
    });
    handleStoreChange === null || handleStoreChange === void 0 ? void 0 : handleStoreChange(value);
  };

  const storeOptionsWithIcon = storeOptions.map(store => Object.assign(Object.assign({}, store), {
    icon: storeIconMap.get(String(store.value))
  })).filter(({
    value
  }) => {
    if (!activeStore) return false;
    const activeAndOptionAreB2B = activeStore.includes('business') && String(value).includes('business');
    const activeAndOptionAreB2C = !activeStore.includes('business') && !String(value).includes('business');
    return activeAndOptionAreB2B || activeAndOptionAreB2C;
  });
  return jsx(Fragment$1, {
    children: storeOptionsWithIcon.map(({
      icon,
      value,
      label
    }, index) => jsxs(Option, Object.assign({
      mobile: mobile,
      handleSelect: handleClick,
      value: value,
      activeValue: selectedStore
    }, {
      children: [icon, label]
    }), `${value}-${index}`))
  });
};

const LanguageOptions = ({
  activeLocale,
  localeOptions,
  handleLocaleChange,
  mobile,
  storeId,
  sendAnalyticsFunctionFromConsumer
}) => {
  const [selectedLanguage, setSelectedLanguage] = useState(activeLocale);
  const {
    sendStoreLanguageSelectorEvent
  } = useTracking({
    storeId,
    sendAnalyticsFunctionFromConsumer
  });

  const handleClick = value => __awaiter(void 0, void 0, void 0, function* () {
    setSelectedLanguage(value);
    sendStoreLanguageSelectorEvent({
      event: SEGMENT_EVENTS.languageChanged,
      language: value
    });
    yield i18n.changeLanguage(value);
    handleLocaleChange === null || handleLocaleChange === void 0 ? void 0 : handleLocaleChange(value);
  });

  return jsx(Fragment$1, {
    children: localeOptions.map(({
      value,
      label
    }, index) => jsx(Option, Object.assign({
      mobile: mobile,
      handleSelect: handleClick,
      value: value,
      activeValue: selectedLanguage
    }, {
      children: label
    }), `${index}-${value}`))
  });
};

const StoreAndLanguageSelector = ({
  activeLocale,
  localeOptions,
  handleLocaleChange,
  activeStore,
  storeOptions,
  handleStoreChange,
  mobile: _mobile = false,
  storeId,
  sendAnalyticsFunctionFromConsumer
}) => {
  const {
    t
  } = useTranslation();
  const menuContent = _mobile ? jsxs(Fragment$1, {
    children: [jsx(MobileOptionsHeader, Object.assign({
      "data-testid": "mobile-header",
      noPaddingTop: true
    }, {
      children: t('LANGUAGE_SELECTOR_LABEL')
    })), jsx(MobileOptionsWrapper, {
      children: jsx(LanguageOptions, {
        activeLocale: activeLocale,
        localeOptions: localeOptions,
        handleLocaleChange: handleLocaleChange,
        mobile: _mobile,
        storeId: storeId,
        sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
      })
    }), jsx(MobileOptionsHeader, {
      children: t('COUNTRY_SELECTOR_LABEL')
    }), jsx(MobileOptionsWrapper, {
      children: jsx(StoreOptions, {
        activeStore: activeStore,
        storeOptions: storeOptions,
        handleStoreChange: handleStoreChange,
        mobile: _mobile,
        storeId: storeId,
        sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
      })
    })]
  }) : jsxs(Fragment$1, {
    children: [jsx(DesktopOptionsHeader, Object.assign({
      "data-testid": "desktop-header"
    }, {
      children: t('LANGUAGE_SELECTOR_LABEL')
    })), jsx(LanguageOptions, {
      activeLocale: activeLocale,
      localeOptions: localeOptions,
      handleLocaleChange: handleLocaleChange,
      mobile: _mobile,
      storeId: storeId,
      sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
    }), jsx(DesktopOptionsHeader, {
      children: t('COUNTRY_SELECTOR_LABEL')
    }), jsx(StoreOptions, {
      activeStore: activeStore,
      storeOptions: storeOptions,
      handleStoreChange: handleStoreChange,
      mobile: _mobile,
      storeId: storeId,
      sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
    })]
  });
  return jsx(Menu, {
    mobile: _mobile,
    animation: false,
    button: jsxs(ButtonWrapper, {
      children: [storeIconMap.get(activeStore), !_mobile && jsx(LanguageText, {
        children: activeLocale
      })]
    }),
    content: menuContent,
    headerLabel: t('LANGUAGE_AND_COUNTRY_MENU_HEADER')
  });
};

const HamburgerIcon = ({
  className,
  color,
  size: _size = '24'
}) => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 7C4 6.44772 4.44772 6 5 6H19C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8H5C4.44772 8 4 7.55228 4 7Z",
      fill: "#333333"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z",
      fill: "#333333"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 17C4 16.4477 4.44772 16 5 16H19C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H5C4.44772 18 4 17.5523 4 17Z",
      fill: "#333333"
    })]
  }));
};

const StarOutlineIcon = () => {
  return jsx("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("g", Object.assign({
      id: "Star Outline"
    }, {
      children: jsx("path", {
        id: "Vector",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.9397 7.95492L12.0008 2L9.06187 7.95492L2.49023 8.90983L7.24552 13.5451L6.12295 20.0902L12.0008 17L17.8787 20.0902L16.7561 13.5451L21.5114 8.90983L14.9397 7.95492ZM17.2134 10.3063L13.6116 9.78293L12.0008 6.5191L10.39 9.78293L6.78816 10.3063L9.39448 12.8468L8.77921 16.4341L12.0008 14.7404L15.2224 16.4341L14.6071 12.8468L17.2134 10.3063Z",
        fill: "#333333"
      })
    }))
  }));
};

const TrendingIcon = () => {
  return jsx("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("g", Object.assign({
      id: "Trending"
    }, {
      children: jsx("path", {
        id: "Vector",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 8C14 7.44772 14.4477 7 15 7H21C21.5523 7 22 7.44771 22 8V14.2308C22 14.7831 21.5523 15.2308 21 15.2308C20.4477 15.2308 20 14.7831 20 14.2308V10.4801L14.387 16.309C14.1985 16.5048 13.9384 16.6154 13.6667 16.6154C13.3949 16.6154 13.1349 16.5048 12.9463 16.309L9 12.2109L3.72032 17.6936C3.33723 18.0915 2.70418 18.1034 2.30636 17.7203C1.90854 17.3372 1.89659 16.7042 2.27968 16.3064L8.27968 10.0756C8.46818 9.87983 8.72824 9.76923 9 9.76923C9.27176 9.76923 9.53182 9.87983 9.72032 10.0756L13.6667 14.1737L18.6488 9H15C14.4477 9 14 8.55228 14 8Z",
        fill: "#333333"
      })
    }))
  }));
};

const ShowAllIcon = () => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.5859 7.21875C13.2207 7.69336 12.6465 8 12 8C11.5488 8 11.1328 7.85156 10.7969 7.59961C10.3125 7.23438 10 6.6543 10 6C10 4.89453 10.8945 4 12 4C13.1055 4 14 4.89453 14 6C14 6.45898 13.8457 6.88281 13.5859 7.21875Z",
      fill: "#333333"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 12C14 13.1055 13.1055 14 12 14C10.8945 14 10 13.1055 10 12C10 10.8945 10.8945 10 12 10C12.6406 10 13.2109 10.3008 13.5762 10.7695C13.8418 11.1094 14 11.5352 14 12Z",
      fill: "#333333"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.7012 19.0527C13.3496 19.6211 12.7188 20 12 20C10.8945 20 10 19.1055 10 18C10 16.8945 10.8945 16 12 16C13.1055 16 14 16.8945 14 18C14 18.3867 13.8906 18.748 13.7012 19.0527Z",
      fill: "#333333"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.58594 7.21875C7.2207 7.69336 6.64648 8 6 8C5.54883 8 5.13281 7.85156 4.79688 7.59961C4.3125 7.23438 4 6.6543 4 6C4 4.89453 4.89453 4 6 4C7.10547 4 8 4.89453 8 6C8 6.45898 7.8457 6.88281 7.58594 7.21875Z",
      fill: "#333333"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 12C8 13.1055 7.10547 14 6 14C4.89453 14 4 13.1055 4 12C4 10.8945 4.89453 10 6 10C6.64062 10 7.21094 10.3008 7.57617 10.7695C7.8418 11.1094 8 11.5352 8 12Z",
      fill: "#333333"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.70117 19.0527C7.34961 19.6211 6.71875 20 6 20C4.89453 20 4 19.1055 4 18C4 16.8945 4.89453 16 6 16C7.10547 16 8 16.8945 8 18C8 18.3867 7.89062 18.748 7.70117 19.0527Z",
      fill: "#333333"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.5859 7.21875C19.2207 7.69336 18.6465 8 18 8C17.5488 8 17.1328 7.85156 16.7969 7.59961C16.3125 7.23438 16 6.6543 16 6C16 4.89453 16.8945 4 18 4C19.1055 4 20 4.89453 20 6C20 6.45898 19.8457 6.88281 19.5859 7.21875Z",
      fill: "#333333"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 12C20 13.1055 19.1055 14 18 14C16.8945 14 16 13.1055 16 12C16 10.8945 16.8945 10 18 10C18.6406 10 19.2109 10.3008 19.5762 10.7695C19.8418 11.1094 20 11.5352 20 12Z",
      fill: "#333333"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.7012 19.0527C19.3496 19.6211 18.7188 20 18 20C16.8945 20 16 19.1055 16 18C16 16.8945 16.8945 16 18 16C19.1055 16 20 16.8945 20 18C20 18.3867 19.8906 18.748 19.7012 19.0527Z",
      fill: "#333333"
    })]
  }));
};

var DataCountToShow;

(function (DataCountToShow) {
  DataCountToShow[DataCountToShow["NUMBER_OF_CATEGORIES_TO_SHOW"] = 8] = "NUMBER_OF_CATEGORIES_TO_SHOW";
  DataCountToShow[DataCountToShow["NUMBER_OF_BRANDS_TO_SHOW"] = 6] = "NUMBER_OF_BRANDS_TO_SHOW";
  DataCountToShow[DataCountToShow["NUMBER_OF_TRENDING_TO_SHOW"] = 6] = "NUMBER_OF_TRENDING_TO_SHOW";
})(DataCountToShow || (DataCountToShow = {}));

const MainMenuSectionHeading = ({
  title
}) => jsxs(SectionHeadingWrapper, {
  children: [jsx(SectionHeading, {
    children: title
  }), jsx(SectionHeadingDivider, {})]
});

const CategoryMobile = ({
  brands,
  trending,
  handleBrandClick,
  handleTrendingClick
}) => {
  const {
    t
  } = useTranslation();
  return jsxs(Fragment$1, {
    children: [(brands === null || brands === void 0 ? void 0 : brands.length) ? jsxs(Fragment$1, {
      children: [jsx(MainMenuSectionHeading, {
        title: t('BRANDS_TITLE_TEXT')
      }), brands.slice(0, DataCountToShow.NUMBER_OF_BRANDS_TO_SHOW).map(brand => {
        var _a;

        return brand ? jsx(CategoryMobileTextContent, Object.assign({
          href: String((_a = brand.link) !== null && _a !== void 0 ? _a : brand.slug),
          onClick: () => handleBrandClick(brand.title, brand.link)
        }, {
          children: brand.title
        })) : null;
      })]
    }) : null, (trending === null || trending === void 0 ? void 0 : trending.length) ? jsxs(Fragment$1, {
      children: [jsx(MainMenuSectionHeading, {
        title: t('TRENDING_TITLE_TEXT')
      }), trending.slice(0, DataCountToShow.NUMBER_OF_TRENDING_TO_SHOW).map(trendingData => {
        return trendingData ? jsx(CategoryMobileTextContent, Object.assign({
          href: String(trendingData.linkTo),
          onClick: () => handleTrendingClick(trendingData.ctaText, trendingData.linkTo)
        }, {
          children: trendingData.ctaText
        })) : null;
      })]
    }) : null]
  });
};

const Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "o3d5sf-0"
})(["cursor:pointer;width:100%;height:100%;background-image:", ";background-position:center;background-repeat:no-repeat;background-size:cover;border-radius:16px;display:flex;flex-direction:column;justify-content:flex-end;aspect-ratio:3/2;"], ({
  imageUrl
}) => `url(${imageUrl})`);
const Content = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__Content",
  componentId: "o3d5sf-1"
})(["display:inline-flex;gap:4px;padding:", " ", ";background:linear-gradient(180deg,rgba(0,0,0,0.00) 0%,rgba(0,0,0,0.20) 53.32%,rgba(0,0,0,0.40) 100%);border-radius:16px;"], ({
  theme
}) => theme.spacers.L, ({
  theme
}) => theme.spacers.XL);
const Title = /*#__PURE__*/styled.p.withConfig({
  displayName: "styles__Title",
  componentId: "o3d5sf-2"
})(["", " line-height:24px;font-weight:700;color:", ";"], ({
  theme
}) => theme.typography.Paragraph, props => props.theme.colors.Background);

const ChevronLargeRightIcon = ({
  className,
  color: _color = '#333333',
  size: _size = '24'
}) => {
  return jsx("svg", Object.assign({
    className: className,
    width: _size,
    height: _size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M7.29289 19.2929C6.90237 19.6834 6.90237 20.3166 7.29289 20.7071C7.68342 21.0976 8.31658 21.0976 8.70711 20.7071L16.7071 12.7071C17.0976 12.3166 17.0976 11.6834 16.7071 11.2929L8.70711 3.29289C8.31658 2.90237 7.68342 2.90237 7.29289 3.29289C6.90237 3.68342 6.90237 4.31658 7.29289 4.70711L14.5858 12L7.29289 19.2929Z",
      fill: _color
    })
  }));
};

const MarketingCard = ({
  content: {
    header,
    image
  }
}) => {
  const theme = useContext(ThemeContext);
  if (!header || !(image === null || image === void 0 ? void 0 : image.url)) return null;
  return jsx(Wrapper, Object.assign({
    imageUrl: image.url
  }, {
    children: jsxs(Content, {
      children: [jsx(Title, {
        children: header
      }), jsx(ChevronLargeRightIcon, {
        color: theme.colors.Background
      })]
    })
  }));
};

var FallBackRoute;

(function (FallBackRoute) {
  FallBackRoute["deal"] = "/deals";
  FallBackRoute["topProducts"] = "/trending";
})(FallBackRoute || (FallBackRoute = {}));

const DealsIcon = () => {
  return jsx("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("g", Object.assign({
      id: "Icon"
    }, {
      children: jsxs("g", Object.assign({
        id: "Vector"
      }, {
        children: [jsx("path", {
          d: "M16.7071 8.70714C17.0976 8.31661 17.0976 7.68345 16.7071 7.29292C16.3166 6.9024 15.6834 6.9024 15.2929 7.29292L7.29289 15.2929C6.90237 15.6834 6.90237 16.3166 7.29289 16.7071C7.68342 17.0977 8.31658 17.0977 8.70711 16.7071L16.7071 8.70714Z",
          fill: "#333333"
        }), jsx("path", {
          d: "M11 9.00003C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9.00003C7 7.89546 7.89543 7.00003 9 7.00003C10.1046 7.00003 11 7.89546 11 9.00003Z",
          fill: "#333333"
        }), jsx("path", {
          d: "M15 17C16.1046 17 17 16.1046 17 15C17 13.8955 16.1046 13 15 13C13.8954 13 13 13.8955 13 15C13 16.1046 13.8954 17 15 17Z",
          fill: "#333333"
        }), jsx("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M2 7.00003C2 4.23861 4.23858 2.00003 7 2.00003H17C19.7614 2.00003 22 4.23861 22 7.00003V17C22 19.7615 19.7614 22 17 22H7C4.23858 22 2 19.7615 2 17V7.00003ZM7 4.00003H17C18.6569 4.00003 20 5.34318 20 7.00003V17C20 18.6569 18.6569 20 17 20H7C5.34315 20 4 18.6569 4 17V7.00003C4 5.34318 5.34315 4.00003 7 4.00003Z",
          fill: "#333333"
        })]
      }))
    }))
  }));
};

const NUMBER_OF_CATEGORIES_TO_SHOW = 5;
const NUMBER_OF_BRANDS_TO_SHOW = 5;
const useMainMenu = ({
  storeId,
  sendAnalyticsFunctionFromConsumer
}) => {
  const {
    t
  } = useTranslation();
  const {
    sendNavigationClickEvent,
    sendBrandsNavigationClickEvent,
    sendCategoryNavigationClickEvent,
    sendAllCategoriesNavigationClickEvent
  } = useTracking({
    storeId,
    sendAnalyticsFunctionFromConsumer
  });

  const getMarketingCard = (handleTracking, marketingCard, onNavigate) => {
    var _a;

    if (!((_a = marketingCard === null || marketingCard === void 0 ? void 0 : marketingCard.button) === null || _a === void 0 ? void 0 : _a.linkTo)) return [];
    return [jsx(SlideButtonMcWrapper, Object.assign({
      onClick: () => {
        var _a, _b;

        handleTracking({
          marketingCard: `${marketingCard.header}`,
          destinationUrl: `${(_a = marketingCard === null || marketingCard === void 0 ? void 0 : marketingCard.button) === null || _a === void 0 ? void 0 : _a.linkTo}`
        });
        onNavigate === null || onNavigate === void 0 ? void 0 : onNavigate({
          url: `${(_b = marketingCard === null || marketingCard === void 0 ? void 0 : marketingCard.button) === null || _b === void 0 ? void 0 : _b.linkTo}`
        });
      }
    }, {
      children: jsx(MarketingCard, {
        content: marketingCard
      })
    }))];
  };

  const getCategorySlideButtons = (categories, onCategoryClick, subCategory, onNavigate) => {
    var _a;

    const content = (_a = categories === null || categories === void 0 ? void 0 : categories.map(({
      coverImageUrl,
      link,
      children,
      brands,
      trending,
      marketingCard,
      permalink
    }, index) => {
      const props = Object.assign({
        icon: jsx("img", {
          src: coverImageUrl || shimmerImageUrl$1,
          alt: link.text
        }),
        label: link.text
      }, subCategory ? {
        onSlideClick: () => {
          var _a, _b;

          return sendCategoryNavigationClickEvent({
            category: (_a = permalink.split('/')) === null || _a === void 0 ? void 0 : _a[0],
            subCategory: (_b = permalink.split('/')) === null || _b === void 0 ? void 0 : _b[1],
            destinationUrl: link.url
          });
        },
        href: link.url,
        bold: false
      } : {
        onSlideClick: () => {
          let content = [jsx(MainMenuSectionHeading, {
            title: t('CATEGORIES_BUTTON')
          }), jsx(MenuSlideButton, {
            icon: jsx(ShowAllIcon, {}),
            label: t('CATEGORY_MENU_VIEW_ALL'),
            href: link.url,
            bold: false,
            onSlideClick: () => sendCategoryNavigationClickEvent({
              category: permalink,
              subCategory: 'explore-all',
              destinationUrl: 'tbd'
            })
          }, `${link.url} - ${index}`)];
          content = content.concat(getCategorySlideButtons(children, onCategoryClick, true, onNavigate));
          content.push(jsx(CategoryMobile, {
            brands: brands,
            trending: trending,
            handleBrandClick: (brand, destinationUrl) => {
              sendCategoryNavigationClickEvent({
                category: permalink,
                brand,
                destinationUrl
              });
            },
            handleTrendingClick: (trending, destinationUrl) => {
              sendCategoryNavigationClickEvent({
                category: permalink,
                trending,
                destinationUrl
              });
            }
          }));
          content = content.concat(getMarketingCard(payload => sendCategoryNavigationClickEvent(Object.assign({
            category: permalink
          }, payload)), marketingCard, onNavigate));
          sendAllCategoriesNavigationClickEvent({
            category: permalink,
            destinationUrl: link.url
          });
          onCategoryClick === null || onCategoryClick === void 0 ? void 0 : onCategoryClick({
            content,
            label: link.text
          });
        }
      });
      return jsx(MenuSlideButton, Object.assign({}, props), `${link.url} - ${index}`);
    })) !== null && _a !== void 0 ? _a : [];
    return content;
  };

  const getCategoryMenu = ({
    categories,
    onCategoryClick,
    onNavigate
  }) => {
    const menuContent = getCategorySlideButtons(categories === null || categories === void 0 ? void 0 : categories.slice(0, NUMBER_OF_CATEGORIES_TO_SHOW), onCategoryClick, false, onNavigate);
    menuContent.push(jsx(MenuSlideButton, {
      icon: jsx(ShowAllIcon, {}),
      label: t('CATEGORY_MENU_VIEW_ALL'),
      onSlideClick: () => {
        onCategoryClick === null || onCategoryClick === void 0 ? void 0 : onCategoryClick({
          content: getCategorySlideButtons(categories, onCategoryClick, false, onNavigate),
          label: t('BROWSE_PAGE_CATEGORIES')
        });
      }
    }, t('CATEGORY_MENU_VIEW_ALL')));
    return menuContent;
  };

  const getBrandsSectionSlideButtons = (brand = [], type, title) => {
    if (!(brand === null || brand === void 0 ? void 0 : brand.length)) return [];
    const menuContent = brand.slice(0, NUMBER_OF_BRANDS_TO_SHOW).map(({
      title,
      image,
      link,
      slug
    }) => {
      const href = slug ? `/brands/${slug}` : link !== null && link !== void 0 ? link : '';
      const props = {
        icon: jsx("img", {
          src: (image === null || image === void 0 ? void 0 : image.url) || shimmerImageUrl$1,
          alt: `${slug !== null && slug !== void 0 ? slug : link}`
        }),
        label: `${title}`,
        href: href,
        bold: false
      };
      return jsx(MenuSlideButton, Object.assign({}, props, {
        onSlideClick: () => {
          sendBrandsNavigationClickEvent(Object.assign(Object.assign({}, type === 'TOP' ? {
            topBrand: title
          } : {
            newBrand: title
          }), {
            destinationUrl: href
          }));
        }
      }));
    });
    return [jsx(MainMenuSectionHeading, {
      title: title
    }), ...menuContent];
  };

  const getBrandsSlideSections = (brands, onNavigate) => {
    if (!brands) return [];
    const {
      marketingCard
    } = brands; // Add all brands section

    return [...getBrandsSectionSlideButtons(brands.allBrands, 'TOP', t('BRANDS_TITLE_TEXT')), ...getBrandsSectionSlideButtons(brands.newBrands, 'NEW', t('HEADER_NEW_BRANDS')), ...getMarketingCard(payload => sendBrandsNavigationClickEvent(Object.assign({}, payload)), marketingCard, onNavigate)];
  };

  const getTopLinksMenu = ({
    mobileLinks,
    brands,
    onBrandsClick,
    onNavigate
  }) => {
    const [topProductsLink, dealsLink] = mobileLinks !== null && mobileLinks !== void 0 ? mobileLinks : [];
    const menuContent = [jsx(MenuSlideButton, {
      icon: jsx(DealsIcon, {}),
      label: t('OFFERINGS_LINKS_DEALS_TEXT'),
      onSlideClick: () => {
        var _a, _b;

        sendNavigationClickEvent({
          destinationUrl: (_a = dealsLink === null || dealsLink === void 0 ? void 0 : dealsLink.url) !== null && _a !== void 0 ? _a : FallBackRoute.deal,
          group: NAVIGATION_GROUP_TYPE.DEALS
        });
        onNavigate === null || onNavigate === void 0 ? void 0 : onNavigate({
          url: (_b = dealsLink === null || dealsLink === void 0 ? void 0 : dealsLink.url) !== null && _b !== void 0 ? _b : FallBackRoute.deal
        });
      }
    })];

    if (brands) {
      menuContent.push(jsx(MenuSlideButton, {
        icon: jsx(StarOutlineIcon, {}),
        label: t('DIVISION_LINE_BRANDS'),
        onSlideClick: () => {
          onBrandsClick === null || onBrandsClick === void 0 ? void 0 : onBrandsClick({
            content: getBrandsSlideSections(brands, onNavigate),
            label: t('DIVISION_LINE_BRANDS')
          });
        }
      }, "brands"));
    }

    menuContent.push(jsx(MenuSlideButton, {
      icon: jsx(TrendingIcon, {}),
      label: t('OFFERINGS_LINKS_TOP_PRODUCTS_TEXT'),
      onSlideClick: () => {
        var _a, _b;

        sendNavigationClickEvent({
          destinationUrl: (_a = topProductsLink === null || topProductsLink === void 0 ? void 0 : topProductsLink.url) !== null && _a !== void 0 ? _a : FallBackRoute.topProducts,
          group: NAVIGATION_GROUP_TYPE.TRENDING
        });
        onNavigate === null || onNavigate === void 0 ? void 0 : onNavigate({
          url: (_b = topProductsLink === null || topProductsLink === void 0 ? void 0 : topProductsLink.url) !== null && _b !== void 0 ? _b : FallBackRoute.topProducts
        });
      }
    }, "top-products"));
    return menuContent;
  };

  const getInfoLinksMenu = ({
    linkGroup,
    mobile
  }) => {
    var _a;

    return (_a = linkGroup.map(({
      text,
      url
    }, index) => jsx(MenuItem, Object.assign({
      mobile: mobile,
      href: url,
      onClick: () => {
        sendNavigationClickEvent({
          destinationUrl: url,
          group: NAVIGATION_GROUP_TYPE.HAMBURGER_MENU
        });
      }
    }, {
      children: text
    }), `${text}-${index}`))) !== null && _a !== void 0 ? _a : [];
  };

  return {
    getCategoryMenu,
    getTopLinksMenu,
    getInfoLinksMenu
  };
};

const MainMenu = ({
  links,
  mobile: _mobile = false,
  categories,
  mobileLinks,
  brands,
  storeId,
  sendAnalyticsFunctionFromConsumer,
  onNavigate
}) => {
  var _a;

  const menuRef = useRef(null);
  const {
    t
  } = useTranslation();
  const {
    getCategoryMenu,
    getTopLinksMenu,
    getInfoLinksMenu
  } = useMainMenu({
    storeId,
    sendAnalyticsFunctionFromConsumer
  });
  let menuContent = [];

  const navigateMenu = options => {
    var _a;

    return (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.handleMenuNavigate(options);
  };

  if (_mobile) {
    menuContent = menuContent.concat((_a = getCategoryMenu({
      categories,
      onCategoryClick: navigateMenu,
      onNavigate
    })) !== null && _a !== void 0 ? _a : []);
    menuContent.push(jsx(MenuDivider, {}));
    menuContent = menuContent.concat(getTopLinksMenu({
      mobileLinks,
      brands,
      onBrandsClick: navigateMenu,
      onNavigate
    }));
    menuContent.push(jsx(MenuDivider, {}, "divider"));
  } // Info links


  links === null || links === void 0 ? void 0 : links.forEach((linkGroup, index) => {
    menuContent = menuContent.concat(getInfoLinksMenu({
      mobile: _mobile,
      linkGroup
    }));

    if (index !== (links === null || links === void 0 ? void 0 : links.length) - 1) {
      menuContent.push(jsx(MenuDivider, {}, index));
    }
  });
  return jsx(Menu, {
    ref: menuRef,
    mobile: _mobile,
    button: jsx(HamburgerIcon, {}),
    content: menuContent,
    headerLabel: t('MAIN_MENU_HEADER')
  });
};

const Mobile = ({
  header,
  search,
  unreadMessages,
  favorites,
  cartItems,
  onNavigate,
  query,
  onQueryChange,
  deviceType,
  onLogin,
  onLogout,
  onSignup,
  consumer,
  onStoreChange,
  onLocaleChange,
  sendAnalyticsFunctionFromConsumer
}) => {
  const {
    isScrolledToTop,
    isScrollingDown
  } = useHideOnScroll();

  if (!(header === null || header === void 0 ? void 0 : header.data)) {
    return null;
  }

  const {
    store,
    storeId,
    locale,
    loggedIn,
    homeLink,
    categoryMenu,
    searchCategoriesShowAllLabel,
    userBar,
    brands
  } = header.data;
  return jsx(HeaderWrapper, Object.assign({
    isScrollingDown: isScrollingDown,
    isScrolledToTop: isScrolledToTop,
    mobile: true
  }, {
    children: jsxs(RootWrapper, Object.assign({
      mobile: true,
      isScrolledToTop: isScrolledToTop
    }, {
      children: [jsxs(TopWrapper, Object.assign({
        mobile: true
      }, {
        children: [jsx(GroverLogo, {
          onNavigate: onNavigate,
          isTransparent: false,
          link: homeLink,
          mobile: true
        }), jsxs(HeaderActions, {
          children: [jsx(StoreAndLanguageSelector, {
            mobile: true,
            activeStore: store,
            storeOptions: categoryMenu.storeOptions,
            handleStoreChange: onStoreChange,
            activeLocale: locale,
            localeOptions: categoryMenu.localeOptions,
            handleLocaleChange: onLocaleChange,
            storeId: storeId,
            sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
          }), jsx(Account, {
            mobile: true,
            userBar: userBar,
            unreadMessages: unreadMessages,
            loggedIn: loggedIn,
            handleLogin: onLogin,
            handleLogout: onLogout,
            handleSignUp: onSignup,
            storeId: storeId,
            sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
          }), jsx(Favorites, {
            favorites: favorites,
            onNavigate: onNavigate,
            links: userBar.dashboardLinksV2,
            storeId: storeId,
            sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
          }), jsx(Checkout, {
            cartItems: cartItems,
            onNavigate: onNavigate,
            links: userBar.dashboardLinksV2,
            storeId: storeId,
            sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
          })]
        })]
      })), jsxs(BottomWrapper, Object.assign({
        mobile: true
      }, {
        children: [jsx(MainMenu, {
          storeId: storeId,
          sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer,
          onNavigate: onNavigate,
          brands: brands,
          links: userBar.menuLinks,
          categories: categoryMenu.categories,
          mobileLinks: categoryMenu.mobileLinks,
          mobile: true
        }), jsx(Search, {
          userDevice: deviceType,
          searchLoading: search.loading,
          query: query,
          onQueryChange: onQueryChange,
          categories: categoryMenu.categories,
          searchCategoriesShowAllLabel: searchCategoriesShowAllLabel,
          searchResult: search.data,
          onNavigate: onNavigate,
          storeId: storeId,
          store: store,
          locale: locale,
          consumer: consumer,
          mobile: true
        })]
      }))]
    }))
  }));
};

const OverlayWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__OverlayWrapper",
  componentId: "sc-1gibb1a-0"
})(["position:relative;"]);
const OverlayContentWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__OverlayContentWrapper",
  componentId: "sc-1gibb1a-1"
})(["position:fixed;left:0;width:100%;background-color:white;box-shadow:0px 8px 10px 0px rgba(0,0,0,0.13);margin-top:", ";border-top:2px solid ", ";"], ({
  theme
}) => theme.spacers.M, ({
  theme
}) => theme.palette.grey[7]);
const OverlayContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__OverlayContent",
  componentId: "sc-1gibb1a-2"
})(["max-width:1456px;display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:", ";margin:auto;padding:8px 72px 16px 72px;@media (", "){padding-left:0;padding-right:0;}"], ({
  theme
}) => theme.spacers.L, ({
  theme
}) => theme.screens.wideScreen);
const OverlayContentRow = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__OverlayContentRow",
  componentId: "sc-1gibb1a-3"
})(["display:flex;flex-direction:column;min-width:100%;& > *{min-height:40px;}"]);
const OverlayHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__OverlayHeader",
  componentId: "sc-1gibb1a-4"
})(["cursor:pointer;padding:", " 0;color:", ";font-size:14px;font-style:normal;font-weight:700;"], ({
  theme
}) => theme.spacers.M, ({
  theme
}) => theme.palette.grey[100]);
const OverlayTextWrapper = /*#__PURE__*/styled.a.withConfig({
  displayName: "styles__OverlayTextWrapper",
  componentId: "sc-1gibb1a-5"
})(["display:flex;align-items:center;cursor:pointer;padding:", " 0;gap:", ";color:", ";font-size:14px;font-style:normal;font-weight:500;"], ({
  theme
}) => theme.spacers.M, ({
  theme
}) => theme.spacers.L, ({
  theme
}) => theme.palette.grey[100]);
const OverlayMCWrapper = /*#__PURE__*/styled.a.withConfig({
  displayName: "styles__OverlayMCWrapper",
  componentId: "sc-1gibb1a-6"
})(["margin:", " 0;max-height:208px;"], ({
  theme
}) => theme.spacers.M);
const OverlayTextContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__OverlayTextContent",
  componentId: "sc-1gibb1a-7"
})(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;:after{content:'';float:left;background:transparent;width:100%;height:2px;border-radius:1px;}&:hover{:after{background-color:", ";}}"], ({
  theme
}) => theme.palette.grey[100]);

const OverlayButton = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__OverlayButton",
  componentId: "sc-8m6wba-0"
})(["cursor:pointer;"]);
const ButtonHighlight = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__ButtonHighlight",
  componentId: "sc-8m6wba-1"
})(["visibility:", ";z-index:1;position:absolute;bottom:-2px;height:2px;width:calc(100% - 20px);background-color:", ";border-radius:1px;", ";"], ({
  active
}) => active ? 'visible' : 'hidden', ({
  theme
}) => theme.palette.grey[100], ({
  width
}) => width && css(["width:", "px;"], width));
const ButtonLinkWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__ButtonLinkWrapper",
  componentId: "sc-8m6wba-2"
})(["padding:", " 0;position:relative;"], ({
  theme
}) => theme.spacers.M);

const OverlayTextButton = ({
  text,
  active
}) => {
  var _a;

  const buttonRef = useRef(null);
  return jsxs(OverlayButton, Object.assign({
    ref: buttonRef
  }, {
    children: [text, jsx(ButtonHighlight, {
      width: (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth,
      active: active
    })]
  }));
};

const OVERLAY_CONTENT_ID = 'header-overlay-content';
const Overlay = ({
  buttonText,
  categoryUrl,
  content,
  className,
  keyPrefix
}) => {
  const [buttonHovered, setButtonHovered] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  const [timeoutId, setTimeoutId] = useState();
  useEffect(() => {
    if ((window === null || window === void 0 ? void 0 : window.location.pathname) === categoryUrl) {
      setButtonHovered(true);
    }
  }, [buttonHovered, categoryUrl]);

  const handleMenuOpen = () => {
    setButtonHovered(true);
    const overlayElement = document.getElementById(OVERLAY_CONTENT_ID);

    if (overlayElement === null || overlayElement === void 0 ? void 0 : overlayElement.isConnected) {
      setMenuActive(true);
    } else {
      const id = setTimeout(() => {
        setMenuActive(true);
      }, 300);
      setTimeoutId(id);
    }
  };

  const handleMenuClose = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(undefined);
    }

    setButtonHovered(false);
    setMenuActive(false);
  };

  const contentElement = Array.isArray(content) ? content.map((element, index) => jsx(OverlayContentRow, {
    children: element
  }, `${keyPrefix}-${index}`)) : content;
  return jsxs(OverlayWrapper, Object.assign({
    className: className,
    onMouseEnter: handleMenuOpen,
    onMouseLeave: handleMenuClose,
    "data-testid": "overlay"
  }, {
    children: [jsx(OverlayTextButton, {
      text: buttonText,
      active: menuActive || buttonHovered
    }), menuActive && jsx(OverlayContentWrapper, Object.assign({
      id: OVERLAY_CONTENT_ID,
      onMouseEnter: () => {
        setMenuActive(true);
        setButtonHovered(true);
      },
      onMouseLeave: handleMenuClose
    }, {
      children: jsx(OverlayContent, {
        children: contentElement
      })
    }))]
  }));
};

const NUMBER_OF_CATEGORIES_IN_A_ROW = 6;
const AllCategories = ({
  categories,
  storeId,
  sendAnalyticsFunctionFromConsumer
}) => {
  var _a;

  const {
    t
  } = useTranslation();
  const {
    sendAllCategoriesNavigationClickEvent
  } = useTracking({
    storeId,
    sendAnalyticsFunctionFromConsumer
  });
  const content = []; // Header for row 1

  content[0] = [jsx(OverlayHeader, {
    children: t('BROWSE_PAGE_CATEGORIES')
  }, "all-categories-row-1-header")];

  for (let i = 1; i < categories.length; i++) {
    const index = Math.floor(i / NUMBER_OF_CATEGORIES_IN_A_ROW);
    const category = categories[i]; // Empty header for first element in subsequent rows

    if (i % NUMBER_OF_CATEGORIES_IN_A_ROW === 0) {
      content[index] = [jsx(OverlayHeader, {}, `all-categories-row-${index}-empty-header`)];
      continue;
    } // Categories for other rows


    content[index] = ((_a = content[index]) !== null && _a !== void 0 ? _a : []).concat(jsxs(OverlayTextWrapper, Object.assign({
      href: category.link.url,
      onClick: () => {
        sendAllCategoriesNavigationClickEvent({
          category: category.permalink,
          destinationUrl: category.link.url
        });
      }
    }, {
      children: [category.link.svgPath && jsx(SonntagIcon, {
        iconPath: category.link.svgPath
      }), jsx(OverlayTextContent, {
        children: category.link.text
      })]
    }), `all-categories-text-wrapper-${category.link.text}-col-${i}`));
  }

  return jsx(Overlay, {
    buttonText: t('BROWSE_PAGE_CATEGORIES'),
    content: content,
    keyPrefix: "all-categories"
  });
};

const NUMBER_OF_BRANDS_IN_A_ROW = 5;
const Brands = ({
  allBrands,
  newBrands,
  marketingCard,
  storeId,
  sendAnalyticsFunctionFromConsumer
}) => {
  var _a, _b;

  const {
    t
  } = useTranslation();
  const {
    sendBrandsNavigationClickEvent
  } = useTracking({
    storeId,
    sendAnalyticsFunctionFromConsumer
  });
  const content = []; // Header for row 1
  // TODO: add explore all link

  content[0] = [jsx(OverlayHeader, {
    children: t('DIVISION_LINE_BRANDS')
  }, "brands-row-1-header") // TODO removal requested in DISCO-1590, page not available yet
  // <OverlayTextWrapper
  //   key="brands-row-1-show-all"
  //   onClick={() =>
  //     sendBrandsNavigationClickEvent({
  //       topBrand: 'explore-all',
  //       destinationUrl: 'tbd',
  //     })
  //   }
  // >
  //   {/* TODO removal requested in DISCO-1590, page not available yet */}
  //   {/*<OverlayTextContent>{t('CATEGORY_MENU_VIEW_ALL')}</OverlayTextContent>*/}
  // </OverlayTextWrapper>,
  ];

  for (let i = 0; i < allBrands.length; i++) {
    const index = Math.floor(i / NUMBER_OF_BRANDS_IN_A_ROW);
    const {
      title,
      link,
      slug
    } = allBrands[i]; // Empty header for first element in subsequent rows

    if (i !== 0 && i % NUMBER_OF_BRANDS_IN_A_ROW === 0) {
      content[index] = [jsx(OverlayHeader, {}, `brands-row-${index}-empty-header-col-${i}`)];
    }

    const brandUrl = slug ? `/brands/${slug}` : link; // Brands for other rows

    content[index] = ((_a = content[index]) !== null && _a !== void 0 ? _a : []).concat(jsx(OverlayTextWrapper, Object.assign({
      href: brandUrl !== null && brandUrl !== void 0 ? brandUrl : '',
      onClick: () => sendBrandsNavigationClickEvent({
        topBrand: title,
        destinationUrl: brandUrl
      })
    }, {
      children: jsx(OverlayTextContent, {
        children: title
      })
    }), `brands-row-${index}-${title}-col-${i}`));
  } // Add new brands in third row


  content[2] = [jsx(OverlayHeader, {
    children: t('HEADER_NEW_BRANDS')
  }, "brands-row-3-header"), ...newBrands.map(({
    title,
    slug,
    link
  }, index) => {
    const url = slug ? `/brands/${slug}` : link;
    return jsx(OverlayTextWrapper, Object.assign({
      href: url !== null && url !== void 0 ? url : '',
      onClick: () => sendBrandsNavigationClickEvent({
        newBrand: title,
        destinationUrl: url
      })
    }, {
      children: jsx(OverlayTextContent, {
        children: title
      })
    }), `brands-row-3-${title}-col-${index}`);
  })]; // Add marketing card in fourth row

  if (marketingCard && ((_b = marketingCard === null || marketingCard === void 0 ? void 0 : marketingCard.button) === null || _b === void 0 ? void 0 : _b.linkTo)) {
    content[3] = [jsx(OverlayMCWrapper, Object.assign({
      href: marketingCard.button.linkTo,
      onClick: () => {
        var _a;

        return sendBrandsNavigationClickEvent({
          marketingCard: marketingCard.header,
          destinationUrl: (_a = marketingCard.button) === null || _a === void 0 ? void 0 : _a.linkTo
        });
      }
    }, {
      children: jsx(MarketingCard, {
        content: marketingCard
      })
    }), "brands-row-3-marketing-card")];
  }

  return jsx(Overlay, {
    buttonText: t('DIVISION_LINE_BRANDS'),
    content: content,
    keyPrefix: "brands"
  });
};

const Category = ({
  category,
  className,
  storeId,
  sendAnalyticsFunctionFromConsumer
}) => {
  var _a, _b, _c, _d, _e;

  const {
    t
  } = useTranslation();
  const {
    sendCategoryNavigationClickEvent
  } = useTracking({
    storeId,
    sendAnalyticsFunctionFromConsumer
  });
  const overlayContent = [];
  const brands = (_a = category.brands) === null || _a === void 0 ? void 0 : _a.slice(0, DataCountToShow.NUMBER_OF_BRANDS_TO_SHOW);
  const trending = (_b = category.trending) === null || _b === void 0 ? void 0 : _b.slice(0, DataCountToShow.NUMBER_OF_TRENDING_TO_SHOW);
  const marketingCard = category.marketingCard;

  const returnBrandsAndTrendingNodes = (type, data) => {
    var _a;

    if (!data) return [];
    const headerText = type === 'brands' ? t('BRANDS_TITLE_TEXT') : t('TRENDING_TITLE_TEXT');
    return [jsx(OverlayHeader, {
      children: headerText
    }, type), ...((_a = data.map((item, index) => {
      const link = String(type === 'brands' ? item === null || item === void 0 ? void 0 : item.link : item === null || item === void 0 ? void 0 : item.linkTo);
      const text = type === 'brands' ? item === null || item === void 0 ? void 0 : item.title : item === null || item === void 0 ? void 0 : item.ctaText;
      return jsx(OverlayTextWrapper, Object.assign({
        href: link,
        onClick: () => sendCategoryNavigationClickEvent(Object.assign(Object.assign({
          category: category.permalink
        }, type === 'brands' ? {
          brand: text
        } : {
          trending: text
        }), {
          destinationUrl: link
        }))
      }, {
        children: jsx(OverlayTextContent, {
          children: text
        })
      }), `category-text-wrapper-${category.link.text}-col-${index}`);
    })) !== null && _a !== void 0 ? _a : [])];
  };

  overlayContent[0] = [jsx(OverlayHeader, {
    children: category.link.text
  }, "category-row-1-header"), jsxs(OverlayTextWrapper, {
    children: [jsx(ShowAllIcon, {}), jsx(OverlayTextContent, Object.assign({
      onClick: () => sendCategoryNavigationClickEvent({
        category: category.permalink,
        subCategory: 'explore-all',
        destinationUrl: 'tbd'
      })
    }, {
      children: t('CATEGORY_MENU_VIEW_ALL')
    }))]
  }, "category-row-1-show-all"), ...((_d = (_c = category.children) === null || _c === void 0 ? void 0 : _c.slice(0, DataCountToShow.NUMBER_OF_CATEGORIES_TO_SHOW).map(({
    link: subCategory,
    permalink: subCategoryPermalink
  }, index) => jsxs(OverlayTextWrapper, Object.assign({
    href: subCategory.url,
    onClick: e => {
      var _a;

      return sendCategoryNavigationClickEvent({
        category: category.permalink,
        subCategory: (_a = subCategoryPermalink.split('/')) === null || _a === void 0 ? void 0 : _a[1],
        destinationUrl: subCategory.url
      });
    }
  }, {
    children: [subCategory.svgPath && jsx(SonntagIcon, {
      iconPath: subCategory.svgPath
    }), jsx(OverlayTextContent, {
      children: subCategory.text
    })]
  }), `category-row-1-${category.link.text}-col-${index}`))) !== null && _d !== void 0 ? _d : [])];
  overlayContent[1] = returnBrandsAndTrendingNodes('brands', brands);
  overlayContent[2] = returnBrandsAndTrendingNodes('trending', trending); // Add marketing card in fourth row

  if (marketingCard && ((_e = marketingCard === null || marketingCard === void 0 ? void 0 : marketingCard.button) === null || _e === void 0 ? void 0 : _e.linkTo)) {
    overlayContent[3] = [jsx(OverlayMCWrapper, Object.assign({
      href: marketingCard.button.linkTo,
      onClick: () => {
        var _a;

        return sendCategoryNavigationClickEvent({
          category: category.permalink,
          marketingCard: marketingCard.header,
          destinationUrl: (_a = marketingCard === null || marketingCard === void 0 ? void 0 : marketingCard.button) === null || _a === void 0 ? void 0 : _a.linkTo
        });
      }
    }, {
      children: jsx(MarketingCard, {
        content: marketingCard
      })
    }), "category-row-3-marketing-card")];
  }

  return jsx(Overlay, {
    className: className,
    buttonText: category.link.text,
    categoryUrl: category.link.url,
    content: overlayContent,
    keyPrefix: category.link.text
  }, category.link.text);
};

const MAX_NUMBER_OF_CATEGORIES_TO_SHOW = 6;
const useCategories = categories => {
  var _a;

  const [removedElementsWidths, setRemovedElementsWidths] = useState([]);
  useEffect(() => {
    const calculateCategoriesToRender = () => {
      var _a, _b, _c, _d;

      const allCategoryElements = document.getElementsByClassName('categories');
      const bottomWrapperElement = (_a = allCategoryElements[0]) === null || _a === void 0 ? void 0 : _a.parentElement; // Calculated width of all elements + space required as padding on each side for them

      const bottomWrapperWidth = 2 * ((_c = (_b = bottomWrapperElement === null || bottomWrapperElement === void 0 ? void 0 : bottomWrapperElement.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.left) !== null && _c !== void 0 ? _c : 0) + Array.from((_d = bottomWrapperElement === null || bottomWrapperElement === void 0 ? void 0 : bottomWrapperElement.children) !== null && _d !== void 0 ? _d : []).reduce((totalWidth, {
        clientWidth
      }) => clientWidth + totalWidth, 0);

      if (bottomWrapperWidth > window.innerWidth) {
        // Add last category element to removed element
        const elementToRemove = allCategoryElements[allCategoryElements.length - 1];
        setRemovedElementsWidths([...removedElementsWidths, elementToRemove.clientWidth]);
      } else {
        const lastRemovedElementWidth = removedElementsWidths[removedElementsWidths.length - 1]; // Recover the last removed element if it can fit

        if (bottomWrapperWidth + lastRemovedElementWidth < window.innerWidth) {
          // Remove last element
          const updatedElements = removedElementsWidths.slice(0, removedElementsWidths.length - 1);
          setRemovedElementsWidths(updatedElements);
        }
      }
    };

    calculateCategoriesToRender();
    window.addEventListener('resize', calculateCategoriesToRender);
    return () => {
      window.removeEventListener('resize', calculateCategoriesToRender);
    };
  }, [removedElementsWidths]);
  return {
    categories: (_a = categories === null || categories === void 0 ? void 0 : categories.slice(0, MAX_NUMBER_OF_CATEGORIES_TO_SHOW - removedElementsWidths.length)) !== null && _a !== void 0 ? _a : []
  };
};

const isTabActive = link => {
  var _a;

  if (typeof window === 'undefined') return false;
  return (_a = window.location.pathname.includes(link.url)) !== null && _a !== void 0 ? _a : false;
};
const getLinkClickEventNavigationGroup = link => {
  if (link.url.includes('deals')) {
    return NAVIGATION_GROUP_TYPE.DEALS;
  }

  return NAVIGATION_GROUP_TYPE.TRENDING;
};

const OverlayLinkButton = _a => {
  var {
    link,
    storeId,
    sendAnalyticsFunctionFromConsumer
  } = _a,
      restProps = __rest(_a, ["link", "storeId", "sendAnalyticsFunctionFromConsumer"]);

  const {
    sendNavigationClickEvent
  } = useTracking({
    storeId,
    sendAnalyticsFunctionFromConsumer
  });
  const [isSelected, setIsSelected] = useState(isTabActive(link));
  const {
    t
  } = useTranslation();
  const [linkHovered, setLinkHovered] = useState(false);

  const handleLinkClick = () => {
    setIsSelected(true);
    const navigationEventGroup = getLinkClickEventNavigationGroup(link);
    sendNavigationClickEvent === null || sendNavigationClickEvent === void 0 ? void 0 : sendNavigationClickEvent({
      destinationUrl: link.url,
      group: navigationEventGroup
    });
  };

  return jsxs(ButtonLinkWrapper, Object.assign({
    onMouseOver: () => setLinkHovered(true),
    onMouseLeave: () => setLinkHovered(false)
  }, {
    children: [jsx(Link$2, Object.assign({}, restProps, {
      onClick: handleLinkClick,
      link: link
    }, {
      children: jsx("span", {
        children: t(link.text)
      })
    })), jsx(ButtonHighlight, {
      active: isSelected || linkHovered
    })]
  }));
};

const MAX_LINKS_TO_SHOW = 2;
const OverlayLinks = ({
  links,
  storeId,
  onNavigate,
  sendAnalyticsFunctionFromConsumer
}) => jsx(Fragment$1, {
  children: links.slice(0, MAX_LINKS_TO_SHOW).map((link, index) => jsx(OverlayLinkButton, {
    link: link,
    onNavigate: onNavigate,
    storeId: storeId,
    sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
  }, `${index}-${link.url}`))
});

const StyledLink = /*#__PURE__*/styled.a.withConfig({
  displayName: "styles__StyledLink",
  componentId: "sc-1mlmw5r-0"
})(["cursor:pointer;display:flex;padding:10px;border-radius:20px;font-size:14px;font-weight:700;color:", ";&:hover{background-color:", ";}"], ({
  theme
}) => theme.palette.grey[100], ({
  theme
}) => theme.palette.grey[7]);

const UserBarLink = ({
  links,
  storeId,
  sendAnalyticsFunctionFromConsumer
}) => {
  const {
    t
  } = useTranslation();
  const {
    sendNavigationClickEvent
  } = useTracking({
    storeId,
    sendAnalyticsFunctionFromConsumer
  });

  if (links === null || links === void 0 ? void 0 : links[0]) {
    const url = links[0].url;
    const navigationGroup = url.includes('tech') ? NAVIGATION_GROUP_TYPE.MY_TECH : NAVIGATION_GROUP_TYPE.HOW_IT_WORKS;
    return jsx(StyledLink, Object.assign({
      href: url,
      onClick: () => {
        sendNavigationClickEvent({
          destinationUrl: url,
          group: navigationGroup
        });
      }
    }, {
      children: t(links[0].text)
    }));
  }

  return null;
};

const Desktop = ({
  header,
  search,
  unreadMessages,
  favorites,
  cartItems,
  onNavigate,
  query,
  onQueryChange,
  deviceType,
  onLogin,
  onLogout,
  onSignup,
  consumer,
  onStoreChange,
  onLocaleChange,
  sendAnalyticsFunctionFromConsumer
}) => {
  const {
    isScrollingDown
  } = useHideOnScroll();
  const {
    categories
  } = useCategories(header === null || header === void 0 ? void 0 : header.data.categoryMenu.categories);
  const mobile = deviceType !== "desktop"
  /* Desktop */
  ;

  if (!(header === null || header === void 0 ? void 0 : header.data)) {
    return null;
  }

  const {
    store,
    storeId,
    locale,
    loggedIn,
    homeLink,
    categoryMenu,
    searchCategoriesShowAllLabel,
    userBar,
    brands
  } = header.data;
  return jsxs(HeaderWrapper, Object.assign({
    isScrollingDown: isScrollingDown
  }, {
    children: [jsxs(RootWrapper, {
      children: [jsxs(TopWrapper, Object.assign({
        mobile: mobile
      }, {
        children: [jsx(GroverLogo, {
          onNavigate: onNavigate,
          isTransparent: false,
          link: homeLink
        }), jsx(Search, {
          userDevice: deviceType,
          searchLoading: search.loading,
          query: query,
          onQueryChange: onQueryChange,
          categories: categoryMenu.categories,
          searchCategoriesShowAllLabel: searchCategoriesShowAllLabel,
          searchResult: search.data,
          onNavigate: onNavigate,
          storeId: storeId,
          store: store,
          locale: locale,
          consumer: consumer
        }), jsxs(HeaderActions, {
          children: [jsx(UserBarLink, {
            links: userBar.dashboardLinksV2,
            storeId: storeId,
            sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
          }), jsx(StoreAndLanguageSelector, {
            activeStore: store,
            storeOptions: categoryMenu.storeOptions,
            handleStoreChange: onStoreChange,
            activeLocale: locale,
            localeOptions: categoryMenu.localeOptions,
            handleLocaleChange: onLocaleChange,
            storeId: storeId,
            sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
          }), jsx(Account, {
            userBar: userBar,
            unreadMessages: unreadMessages,
            loggedIn: loggedIn,
            handleLogin: onLogin,
            handleLogout: onLogout,
            handleSignUp: onSignup,
            storeId: storeId,
            sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
          }), jsx(Favorites, {
            favorites: favorites,
            onNavigate: onNavigate,
            links: userBar.dashboardLinksV2,
            storeId: storeId,
            sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
          }), jsx(Checkout, {
            cartItems: cartItems,
            onNavigate: onNavigate,
            links: userBar.dashboardLinksV2,
            storeId: storeId,
            sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
          }), jsx(MainMenu, {
            links: userBar.menuLinks,
            storeId: storeId,
            sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
          })]
        })]
      })), jsxs(BottomWrapper, {
        children: [jsx(AllCategories, {
          categories: categoryMenu.categories,
          storeId: storeId,
          sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
        }), categories.map(category => jsx(Category, {
          className: "categories",
          category: category,
          storeId: storeId,
          sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
        }, category.permalink)), jsx(CategoriesDivider, {}), (brands === null || brands === void 0 ? void 0 : brands.allBrands) && (brands === null || brands === void 0 ? void 0 : brands.newBrands) && jsx(Brands, {
          allBrands: brands === null || brands === void 0 ? void 0 : brands.allBrands,
          newBrands: brands === null || brands === void 0 ? void 0 : brands.newBrands,
          marketingCard: brands === null || brands === void 0 ? void 0 : brands.marketingCard,
          storeId: storeId,
          sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
        }), jsx(OverlayLinks, {
          onNavigate: onNavigate,
          links: categoryMenu.mobileLinks,
          storeId: storeId,
          sendAnalyticsFunctionFromConsumer: sendAnalyticsFunctionFromConsumer
        })]
      })]
    }), jsx(DesktopDivider, {})]
  }));
};

const i18nextLanguageDetector = {
  type: 'languageDetector',
  init: () => {// Leave empty
  },
  cacheUserLanguage: lng => {// Leave empty
  },
  detect: () => {
    var _a;

    return (_a = Cookies.get('locale')) !== null && _a !== void 0 ? _a : 'en';
  }
};
i18n.use(resourcesToBackend(language => require(`${__dirname}/locales/${language}.json`))).use(initReactI18next).use(i18nextLanguageDetector).init({
  fallbackLng: 'en',
  load: 'languageOnly'
});

let _$4 = t => t,
    _t$4;
const FontStyles = /*#__PURE__*/createGlobalStyle(_t$4 || (_t$4 = _$4`
  body, html, div {
    font-family: "Inter", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  a:hover {
    text-decoration: none;
  }

  button {
    border: none;
  }
`));

const HeaderV2 = props => {
  const {
    deviceType
  } = props;
  const mobile = deviceType !== "desktop"
  /* Desktop */
  ;
  return jsxs(Fragment$1, {
    children: [jsx(FontStyles, {}), mobile ? jsx(Mobile, Object.assign({}, props)) : jsx(Desktop, Object.assign({}, props))]
  });
};

const LoadingUnitBase = /*#__PURE__*/css(["background:", ";position:relative;overflow:hidden;&:last-child{margin-right:0;}&:after{position:absolute;top:0;right:0;bottom:0;left:0;background:rgba(255,0,0,0.09);transform:translateX(-100%);background:linear-gradient( 90deg,transparent 40%,rgba(255,255,255,0.3) 65%,transparent 90%,transparent );animation:shimmer 2s infinite;content:'';}@keyframes shimmer{100%{transform:translateX(100%);}}"], props => props.theme.colors.secondaryBackground);
const LoadingUnit = /*#__PURE__*/styled.div.withConfig({
  displayName: "loadingstyles__LoadingUnit",
  componentId: "sc-8ajmo1-0"
})(["width:", ";margin-right:", ";height:", ";border-radius:", ";", ""], ({
  short
}) => short ? '48px' : '108px', ({
  wide
}) => wide ? '28px' : '20px', ({
  wide
}) => wide ? '32px' : '16px', ({
  wide
}) => wide ? '24px' : '8px', LoadingUnitBase);
const LoadingUnitRect = /*#__PURE__*/styled.div.withConfig({
  displayName: "loadingstyles__LoadingUnitRect",
  componentId: "sc-8ajmo1-1"
})(["width:24px;height:24px;border-radius:8px;margin-right:4px;", ""], LoadingUnitBase);
const Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "loadingstyles__Root",
  componentId: "sc-8ajmo1-2"
})(["padding-bottom:4px;"]);
const LinksWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "loadingstyles__LinksWrapper",
  componentId: "sc-8ajmo1-3"
})(["margin-right:40px;display:flex;"]);
const RightLinksWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "loadingstyles__RightLinksWrapper",
  componentId: "sc-8ajmo1-4"
})(["flex-grow:1;display:flex;justify-content:flex-end;"]);
const LogoWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "loadingstyles__LogoWrapper",
  componentId: "sc-8ajmo1-5"
})(["margin-right:40px;height:32px;display:inline-block;@media (", "){height:40px;}"], ({
  theme
}) => theme.screens.desktop);
const Button = /*#__PURE__*/styled.div.withConfig({
  displayName: "loadingstyles__Button",
  componentId: "sc-8ajmo1-6"
})(["height:48px;padding:0 12px;border-radius:24px;box-shadow:rgb(0 0 0 / 13%) 0px 2px 5px,rgb(0 0 0 / 5%) 0px 0px 3px;display:flex;align-items:center;justify-content:center;"]);
const CategoriesButtonWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "loadingstyles__CategoriesButtonWrapper",
  componentId: "sc-8ajmo1-7"
})(["margin-right:8px;"]);
const CartButtonWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "loadingstyles__CartButtonWrapper",
  componentId: "sc-8ajmo1-8"
})(["margin-left:8px;"]);
const SearchInput = /*#__PURE__*/styled.div.withConfig({
  displayName: "loadingstyles__SearchInput",
  componentId: "sc-8ajmo1-9"
})(["flex-grow:1;height:48px;border-radius:24px;box-shadow:rgb(0 0 0 / 13%) 0px 2px 5px,rgb(0 0 0 / 5%) 0px 0px 3px;"]);

const Loading = ({
  mobile,
  hasCart
}) => {
  const theme = useTheme();

  const logo = jsx(LogoWrapper, {
    children: jsx(GroverLogoSvg, {
      color: theme.type === 'dark' ? '#FFFFFF' : '#FE1251'
    })
  });

  const topBar = mobile ? jsxs(TopWrapper$1, Object.assign({
    mobile: true
  }, {
    children: [logo, jsx(RightLinksWrapper, {
      children: jsx(LoadingUnit, {})
    })]
  })) : jsxs(TopWrapper$1, {
    children: [logo, jsxs(LinksWrapper, {
      children: [jsx(LoadingUnit, {}), jsx(LoadingUnit, {}), jsx(LoadingUnit, {
        short: true
      }), jsx(LoadingUnit, {})]
    }), jsxs(RightLinksWrapper, {
      children: [jsx(LoadingUnit, {
        wide: true
      }), jsx(LoadingUnit, {
        wide: true
      })]
    })]
  });
  return jsxs(Root, {
    children: [topBar, jsxs(BottomWrapper$1, {
      children: [jsx(CategoriesButtonWrapper, {
        children: jsxs(Button, {
          children: [jsx(LoadingUnitRect, {}), !mobile && jsx(LoadingUnit, {})]
        })
      }), jsx(SearchInput, {}), hasCart && jsx(CartButtonWrapper, {
        children: jsx(Button, {
          children: jsx(LoadingUnitRect, {})
        })
      })]
    })]
  });
};

const HeaderUI = props => {
  const {
    deviceType,
    header,
    cart
  } = props;
  const mobile = deviceType !== "desktop"
  /* Desktop */
  ;

  if (header === null || header === void 0 ? void 0 : header.loading) {
    return jsx(Loading, {
      mobile: mobile,
      hasCart: !!cart
    });
  }

  if (!(header === null || header === void 0 ? void 0 : header.data)) {
    return null;
  }

  const isHeaderV2Enabled = header.data.headerV2Enabled;
  if (isHeaderV2Enabled) return jsx(HeaderV2, Object.assign({}, props));
  return jsx(Header, Object.assign({}, props));
};

function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return typeof value == 'object' && value !== null;
}

function invariant(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(
      message != null ? message : 'Unexpected invariant triggered.',
    );
  }
}

const LineRegExp = /\r\n|[\n\r]/g;
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  let lastLineStart = 0;
  let line = 1;

  for (const match of source.body.matchAll(LineRegExp)) {
    typeof match.index === 'number' || invariant(false);

    if (match.index >= position) {
      break;
    }

    lastLineStart = match.index + match[0].length;
    line += 1;
  }

  return {
    line,
    column: position + 1 - lastLineStart,
  };
}

/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(
    location.source,
    getLocation(location.source, location.start),
  );
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  const firstLineColumnOffset = source.locationOffset.column - 1;
  const body = ''.padStart(firstLineColumnOffset) + source.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];

    for (let i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return (
      locationStr +
      printPrefixedLines([
        [`${lineNum} |`, subLines[0]],
        ...subLines.slice(1, subLineIndex + 1).map((subLine) => ['|', subLine]),
        ['|', '^'.padStart(subLineColumnNum)],
        ['|', subLines[subLineIndex + 1]],
      ])
    );
  }

  return (
    locationStr +
    printPrefixedLines([
      // Lines specified like this: ["prefix", "string"],
      [`${lineNum - 1} |`, lines[lineIndex - 1]],
      [`${lineNum} |`, locationLine],
      ['|', '^'.padStart(columnNum)],
      [`${lineNum + 1} |`, lines[lineIndex + 1]],
    ])
  );
}

function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_, line]) => line !== undefined);
  const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
  return existingLines
    .map(([prefix, line]) => prefix.padStart(padLen) + (line ? ' ' + line : ''))
    .join('\n');
}

function toNormalizedOptions(args) {
  const firstArg = args[0];

  if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5],
    };
  }

  return firstArg;
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

class GraphQLError extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */

  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref;

    const { nodes, source, positions, path, originalError, extensions } =
      toNormalizedOptions(rawArgs);
    super(message);
    this.name = 'GraphQLError';
    this.path = path !== null && path !== void 0 ? path : undefined;
    this.originalError =
      originalError !== null && originalError !== void 0
        ? originalError
        : undefined; // Compute list of blame nodes.

    this.nodes = undefinedIfEmpty(
      Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined,
    );
    const nodeLocations = undefinedIfEmpty(
      (_this$nodes = this.nodes) === null || _this$nodes === void 0
        ? void 0
        : _this$nodes.map((node) => node.loc).filter((loc) => loc != null),
    ); // Compute locations in the source for the given nodes/positions.

    this.source =
      source !== null && source !== void 0
        ? source
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : (_nodeLocations$ = nodeLocations[0]) === null ||
          _nodeLocations$ === void 0
        ? void 0
        : _nodeLocations$.source;
    this.positions =
      positions !== null && positions !== void 0
        ? positions
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => loc.start);
    this.locations =
      positions && source
        ? positions.map((pos) => getLocation(source, pos))
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
    const originalExtensions = isObjectLike(
      originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions,
    )
      ? originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions
      : undefined;
    this.extensions =
      (_ref =
        extensions !== null && extensions !== void 0
          ? extensions
          : originalExtensions) !== null && _ref !== void 0
        ? _ref
        : Object.create(null); // Only properties prescribed by the spec should be enumerable.
    // Keep the rest as non-enumerable.

    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true,
      },
      name: {
        enumerable: false,
      },
      nodes: {
        enumerable: false,
      },
      source: {
        enumerable: false,
      },
      positions: {
        enumerable: false,
      },
      originalError: {
        enumerable: false,
      },
    }); // Include (non-enumerable) stack trace.

    /* c8 ignore start */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317

    if (
      originalError !== null &&
      originalError !== void 0 &&
      originalError.stack
    ) {
      Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true,
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true,
      });
    }
    /* c8 ignore stop */
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLError';
  }

  toString() {
    let output = this.message;

    if (this.nodes) {
      for (const node of this.nodes) {
        if (node.loc) {
          output += '\n\n' + printLocation(node.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output += '\n\n' + printSourceLocation(this.source, location);
      }
    }

    return output;
  }

  toJSON() {
    const formattedError = {
      message: this.message,
    };

    if (this.locations != null) {
      formattedError.locations = this.locations;
    }

    if (this.path != null) {
      formattedError.path = this.path;
    }

    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }

    return formattedError;
  }
}

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError(`Syntax Error: ${description}`, {
    source,
    positions: [position],
  });
}

/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
class Location {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  constructor(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  get [Symbol.toStringTag]() {
    return 'Location';
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
    };
  }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

class Token {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(kind, start, end, line, column, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    this.value = value;
    this.prev = null;
    this.next = null;
  }

  get [Symbol.toStringTag]() {
    return 'Token';
  }

  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column,
    };
  }
}
/** Name */

let OperationTypeNode;

(function (OperationTypeNode) {
  OperationTypeNode['QUERY'] = 'query';
  OperationTypeNode['MUTATION'] = 'mutation';
  OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})(OperationTypeNode || (OperationTypeNode = {}));

/**
 * The set of allowed directive location values.
 */
let DirectiveLocation;
/**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */

(function (DirectiveLocation) {
  DirectiveLocation['QUERY'] = 'QUERY';
  DirectiveLocation['MUTATION'] = 'MUTATION';
  DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
  DirectiveLocation['FIELD'] = 'FIELD';
  DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
  DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
  DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
  DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
  DirectiveLocation['SCHEMA'] = 'SCHEMA';
  DirectiveLocation['SCALAR'] = 'SCALAR';
  DirectiveLocation['OBJECT'] = 'OBJECT';
  DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
  DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
  DirectiveLocation['INTERFACE'] = 'INTERFACE';
  DirectiveLocation['UNION'] = 'UNION';
  DirectiveLocation['ENUM'] = 'ENUM';
  DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
  DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
  DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})(DirectiveLocation || (DirectiveLocation = {}));

/**
 * The set of allowed kind values for AST nodes.
 */
let Kind;
/**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */

(function (Kind) {
  Kind['NAME'] = 'Name';
  Kind['DOCUMENT'] = 'Document';
  Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
  Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
  Kind['SELECTION_SET'] = 'SelectionSet';
  Kind['FIELD'] = 'Field';
  Kind['ARGUMENT'] = 'Argument';
  Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
  Kind['INLINE_FRAGMENT'] = 'InlineFragment';
  Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
  Kind['VARIABLE'] = 'Variable';
  Kind['INT'] = 'IntValue';
  Kind['FLOAT'] = 'FloatValue';
  Kind['STRING'] = 'StringValue';
  Kind['BOOLEAN'] = 'BooleanValue';
  Kind['NULL'] = 'NullValue';
  Kind['ENUM'] = 'EnumValue';
  Kind['LIST'] = 'ListValue';
  Kind['OBJECT'] = 'ObjectValue';
  Kind['OBJECT_FIELD'] = 'ObjectField';
  Kind['DIRECTIVE'] = 'Directive';
  Kind['NAMED_TYPE'] = 'NamedType';
  Kind['LIST_TYPE'] = 'ListType';
  Kind['NON_NULL_TYPE'] = 'NonNullType';
  Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
  Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
  Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
  Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
  Kind['FIELD_DEFINITION'] = 'FieldDefinition';
  Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
  Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
  Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
  Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
  Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
  Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
  Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
  Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
  Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
  Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
  Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
  Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
  Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
  Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})(Kind || (Kind = {}));

/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */
function isWhiteSpace(code) {
  return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */

function isDigit(code) {
  return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */

function isLetter(code) {
  return (
    (code >= 0x0061 && code <= 0x007a) || // A-Z
    (code >= 0x0041 && code <= 0x005a) // a-z
  );
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */

function isNameStart(code) {
  return isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */

function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 0x005f;
}

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */

function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;

  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;

  for (let i = 0; i < lines.length; ++i) {
    var _firstNonEmptyLine;

    const line = lines[i];
    const indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    firstNonEmptyLine =
      (_firstNonEmptyLine = firstNonEmptyLine) !== null &&
      _firstNonEmptyLine !== void 0
        ? _firstNonEmptyLine
        : i;
    lastNonEmptyLine = i;

    if (i !== 0 && indent < commonIndent) {
      commonIndent = indent;
    }
  }

  return lines // Remove common indentation from all lines but first.
    .map((line, i) => (i === 0 ? line : line.slice(commonIndent))) // Remove leading and trailing blank lines.
    .slice(
      (_firstNonEmptyLine2 = firstNonEmptyLine) !== null &&
        _firstNonEmptyLine2 !== void 0
        ? _firstNonEmptyLine2
        : 0,
      lastNonEmptyLine + 1,
    );
}

function leadingWhitespace(str) {
  let i = 0;

  while (i < str.length && isWhiteSpace(str.charCodeAt(i))) {
    ++i;
  }

  return i;
}

/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
let TokenKind;
/**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */

(function (TokenKind) {
  TokenKind['SOF'] = '<SOF>';
  TokenKind['EOF'] = '<EOF>';
  TokenKind['BANG'] = '!';
  TokenKind['DOLLAR'] = '$';
  TokenKind['AMP'] = '&';
  TokenKind['PAREN_L'] = '(';
  TokenKind['PAREN_R'] = ')';
  TokenKind['SPREAD'] = '...';
  TokenKind['COLON'] = ':';
  TokenKind['EQUALS'] = '=';
  TokenKind['AT'] = '@';
  TokenKind['BRACKET_L'] = '[';
  TokenKind['BRACKET_R'] = ']';
  TokenKind['BRACE_L'] = '{';
  TokenKind['PIPE'] = '|';
  TokenKind['BRACE_R'] = '}';
  TokenKind['NAME'] = 'Name';
  TokenKind['INT'] = 'Int';
  TokenKind['FLOAT'] = 'Float';
  TokenKind['STRING'] = 'String';
  TokenKind['BLOCK_STRING'] = 'BlockString';
  TokenKind['COMMENT'] = 'Comment';
})(TokenKind || (TokenKind = {}));

/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

class Lexer {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  constructor(source) {
    const startOfFileToken = new Token(TokenKind.SOF, 0, 0, 0, 0);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }

  get [Symbol.toStringTag]() {
    return 'Lexer';
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */

  advance() {
    this.lastToken = this.token;
    const token = (this.token = this.lookahead());
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */

  lookahead() {
    let token = this.token;

    if (token.kind !== TokenKind.EOF) {
      do {
        if (token.next) {
          token = token.next;
        } else {
          // Read the next token and form a link in the token linked-list.
          const nextToken = readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.

          token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.

          nextToken.prev = token;
          token = nextToken;
        }
      } while (token.kind === TokenKind.COMMENT);
    }

    return token;
  }
}
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return (
    kind === TokenKind.BANG ||
    kind === TokenKind.DOLLAR ||
    kind === TokenKind.AMP ||
    kind === TokenKind.PAREN_L ||
    kind === TokenKind.PAREN_R ||
    kind === TokenKind.SPREAD ||
    kind === TokenKind.COLON ||
    kind === TokenKind.EQUALS ||
    kind === TokenKind.AT ||
    kind === TokenKind.BRACKET_L ||
    kind === TokenKind.BRACKET_R ||
    kind === TokenKind.BRACE_L ||
    kind === TokenKind.PIPE ||
    kind === TokenKind.BRACE_R
  );
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */

function isUnicodeScalarValue(code) {
  return (
    (code >= 0x0000 && code <= 0xd7ff) || (code >= 0xe000 && code <= 0x10ffff)
  );
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */

function isSupplementaryCodePoint(body, location) {
  return (
    isLeadingSurrogate(body.charCodeAt(location)) &&
    isTrailingSurrogate(body.charCodeAt(location + 1))
  );
}

function isLeadingSurrogate(code) {
  return code >= 0xd800 && code <= 0xdbff;
}

function isTrailingSurrogate(code) {
  return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */

function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);

  if (code === undefined) {
    return TokenKind.EOF;
  } else if (code >= 0x0020 && code <= 0x007e) {
    // Printable ASCII
    const char = String.fromCodePoint(code);
    return char === '"' ? "'\"'" : `"${char}"`;
  } // Unicode code point

  return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */

function createToken(lexer, kind, start, end, value) {
  const line = lexer.line;
  const col = 1 + start - lexer.lineStart;
  return new Token(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */

function readNextToken(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // SourceCharacter

    switch (code) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 0xfeff: // <BOM>

      case 0x0009: // \t

      case 0x0020: // <space>

      case 0x002c:
        // ,
        ++position;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"

      case 0x000a:
        // \n
        ++position;
        ++lexer.line;
        lexer.lineStart = position;
        continue;

      case 0x000d:
        // \r
        if (body.charCodeAt(position + 1) === 0x000a) {
          position += 2;
        } else {
          ++position;
        }

        ++lexer.line;
        lexer.lineStart = position;
        continue;
      // Comment

      case 0x0023:
        // #
        return readComment(lexer, position);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }

      case 0x0021:
        // !
        return createToken(lexer, TokenKind.BANG, position, position + 1);

      case 0x0024:
        // $
        return createToken(lexer, TokenKind.DOLLAR, position, position + 1);

      case 0x0026:
        // &
        return createToken(lexer, TokenKind.AMP, position, position + 1);

      case 0x0028:
        // (
        return createToken(lexer, TokenKind.PAREN_L, position, position + 1);

      case 0x0029:
        // )
        return createToken(lexer, TokenKind.PAREN_R, position, position + 1);

      case 0x002e:
        // .
        if (
          body.charCodeAt(position + 1) === 0x002e &&
          body.charCodeAt(position + 2) === 0x002e
        ) {
          return createToken(lexer, TokenKind.SPREAD, position, position + 3);
        }

        break;

      case 0x003a:
        // :
        return createToken(lexer, TokenKind.COLON, position, position + 1);

      case 0x003d:
        // =
        return createToken(lexer, TokenKind.EQUALS, position, position + 1);

      case 0x0040:
        // @
        return createToken(lexer, TokenKind.AT, position, position + 1);

      case 0x005b:
        // [
        return createToken(lexer, TokenKind.BRACKET_L, position, position + 1);

      case 0x005d:
        // ]
        return createToken(lexer, TokenKind.BRACKET_R, position, position + 1);

      case 0x007b:
        // {
        return createToken(lexer, TokenKind.BRACE_L, position, position + 1);

      case 0x007c:
        // |
        return createToken(lexer, TokenKind.PIPE, position, position + 1);

      case 0x007d:
        // }
        return createToken(lexer, TokenKind.BRACE_R, position, position + 1);
      // StringValue

      case 0x0022:
        // "
        if (
          body.charCodeAt(position + 1) === 0x0022 &&
          body.charCodeAt(position + 2) === 0x0022
        ) {
          return readBlockString(lexer, position);
        }

        return readString(lexer, position);
    } // IntValue | FloatValue (Digit | -)

    if (isDigit(code) || code === 0x002d) {
      return readNumber(lexer, position, code);
    } // Name

    if (isNameStart(code)) {
      return readName(lexer, position);
    }

    throw syntaxError(
      lexer.source,
      position,
      code === 0x0027
        ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?'
        : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position)
        ? `Unexpected character: ${printCodePointAt(lexer, position)}.`
        : `Invalid character: ${printCodePointAt(lexer, position)}.`,
    );
  }

  return createToken(lexer, TokenKind.EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */

function readComment(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    TokenKind.COMMENT,
    start,
    position,
    body.slice(start + 1, position),
  );
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */

function readNumber(lexer, start, firstCode) {
  const body = lexer.source.body;
  let position = start;
  let code = firstCode;
  let isFloat = false; // NegativeSign (-)

  if (code === 0x002d) {
    code = body.charCodeAt(++position);
  } // Zero (0)

  if (code === 0x0030) {
    code = body.charCodeAt(++position);

    if (isDigit(code)) {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid number, unexpected digit after 0: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  } else {
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Full stop (.)

  if (code === 0x002e) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // E e

  if (code === 0x0045 || code === 0x0065) {
    isFloat = true;
    code = body.charCodeAt(++position); // + -

    if (code === 0x002b || code === 0x002d) {
      code = body.charCodeAt(++position);
    }

    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart

  if (code === 0x002e || isNameStart(code)) {
    throw syntaxError(
      lexer.source,
      position,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        position,
      )}.`,
    );
  }

  return createToken(
    lexer,
    isFloat ? TokenKind.FLOAT : TokenKind.INT,
    start,
    position,
    body.slice(start, position),
  );
}
/**
 * Returns the new position in the source after reading one or more digits.
 */

function readDigits(lexer, start, firstCode) {
  if (!isDigit(firstCode)) {
    throw syntaxError(
      lexer.source,
      start,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        start,
      )}.`,
    );
  }

  const body = lexer.source.body;
  let position = start + 1; // +1 to skip first firstCode

  while (isDigit(body.charCodeAt(position))) {
    ++position;
  }

  return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */

function readString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  let chunkStart = position;
  let value = '';

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Quote (")

    if (code === 0x0022) {
      value += body.slice(chunkStart, position);
      return createToken(lexer, TokenKind.STRING, start, position + 1, value);
    } // Escape Sequence (\)

    if (code === 0x005c) {
      value += body.slice(chunkStart, position);
      const escape =
        body.charCodeAt(position + 1) === 0x0075 // u
          ? body.charCodeAt(position + 2) === 0x007b // {
            ? readEscapedUnicodeVariableWidth(lexer, position)
            : readEscapedUnicodeFixedWidth(lexer, position)
          : readEscapedCharacter(lexer, position);
      value += escape.value;
      position += escape.size;
      chunkStart = position;
      continue;
    } // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.

function readEscapedUnicodeVariableWidth(lexer, position) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3; // Cannot be larger than 12 chars (\u{00000000}).

  while (size < 12) {
    const code = body.charCodeAt(position + size++); // Closing Brace (})

    if (code === 0x007d) {
      // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }

      return {
        value: String.fromCodePoint(point),
        size,
      };
    } // Append this hex digit to the code point.

    point = (point << 4) | readHexDigit(code);

    if (point < 0) {
      break;
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(
      position,
      position + size,
    )}".`,
  );
}

function readEscapedUnicodeFixedWidth(lexer, position) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position + 2);

  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6,
    };
  } // GraphQL allows JSON-style surrogate pair escape sequences, but only when
  // a valid pair is formed.

  if (isLeadingSurrogate(code)) {
    // \u
    if (
      body.charCodeAt(position + 6) === 0x005c &&
      body.charCodeAt(position + 7) === 0x0075
    ) {
      const trailingCode = read16BitHexCode(body, position + 8);

      if (isTrailingSurrogate(trailingCode)) {
        // JavaScript defines strings as a sequence of UTF-16 code units and
        // encodes Unicode code points above U+FFFF using a surrogate pair of
        // code units. Since this is a surrogate pair escape sequence, just
        // include both codes into the JavaScript string value. Had JavaScript
        // not been internally based on UTF-16, then this surrogate pair would
        // be decoded to retrieve the supplementary code point.
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12,
        };
      }
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`,
  );
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */

function read16BitHexCode(body, position) {
  // readHexDigit() returns -1 on error. ORing a negative value with any other
  // value always produces a negative value.
  return (
    (readHexDigit(body.charCodeAt(position)) << 12) |
    (readHexDigit(body.charCodeAt(position + 1)) << 8) |
    (readHexDigit(body.charCodeAt(position + 2)) << 4) |
    readHexDigit(body.charCodeAt(position + 3))
  );
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */

function readHexDigit(code) {
  return code >= 0x0030 && code <= 0x0039 // 0-9
    ? code - 0x0030
    : code >= 0x0041 && code <= 0x0046 // A-F
    ? code - 0x0037
    : code >= 0x0061 && code <= 0x0066 // a-f
    ? code - 0x0057
    : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */

function readEscapedCharacter(lexer, position) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position + 1);

  switch (code) {
    case 0x0022:
      // "
      return {
        value: '\u0022',
        size: 2,
      };

    case 0x005c:
      // \
      return {
        value: '\u005c',
        size: 2,
      };

    case 0x002f:
      // /
      return {
        value: '\u002f',
        size: 2,
      };

    case 0x0062:
      // b
      return {
        value: '\u0008',
        size: 2,
      };

    case 0x0066:
      // f
      return {
        value: '\u000c',
        size: 2,
      };

    case 0x006e:
      // n
      return {
        value: '\u000a',
        size: 2,
      };

    case 0x0072:
      // r
      return {
        value: '\u000d',
        size: 2,
      };

    case 0x0074:
      // t
      return {
        value: '\u0009',
        size: 2,
      };
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid character escape sequence: "${body.slice(
      position,
      position + 2,
    )}".`,
  );
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */

function readBlockString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position = start + 3;
  let chunkStart = position;
  let currentLine = '';
  const blockLines = [];

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Triple-Quote (""")

    if (
      code === 0x0022 &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      const token = createToken(
        lexer,
        TokenKind.BLOCK_STRING,
        start,
        position + 3, // Return a string of the lines joined with U+000A.
        dedentBlockStringLines(blockLines).join('\n'),
      );
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token;
    } // Escaped Triple-Quote (\""")

    if (
      code === 0x005c &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022 &&
      body.charCodeAt(position + 3) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      chunkStart = position + 1; // skip only slash

      position += 4;
      continue;
    } // LineTerminator

    if (code === 0x000a || code === 0x000d) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);

      if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) {
        position += 2;
      } else {
        ++position;
      }

      currentLine = '';
      chunkStart = position;
      lineStart = position;
      continue;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */

function readName(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position);

    if (isNameContinue(code)) {
      ++position;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    TokenKind.NAME,
    start,
    position,
    body.slice(start, position),
  );
}

const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (typeof value) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? `[function ${value.name}]` : '[function]';

    case 'object':
      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return 'null';
  }

  if (previouslySeenValues.includes(value)) {
    return '[Circular]';
  }

  const seenValues = [...previouslySeenValues, value];

  if (isJSONable(value)) {
    const jsonValue = value.toJSON(); // check for infinite recursion

    if (jsonValue !== value) {
      return typeof jsonValue === 'string'
        ? jsonValue
        : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function isJSONable(value) {
  return typeof value.toJSON === 'function';
}

function formatObject(object, seenValues) {
  const entries = Object.entries(object);

  if (entries.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  const properties = entries.map(
    ([key, value]) => key + ': ' + formatValue(value, seenValues),
  );
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  const len = Math.min(MAX_ARRAY_LENGTH, array.length);
  const remaining = array.length - len;
  const items = [];

  for (let i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }

  return '[' + items.join(', ') + ']';
}

function getObjectTag(object) {
  const tag = Object.prototype.toString
    .call(object)
    .replace(/^\[object /, '')
    .replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    const name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}

/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 * See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
 * See: https://webpack.js.org/guides/production/
 */

const instanceOf =
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  // eslint-disable-next-line no-undef
  process.env.NODE_ENV === 'production'
    ? function instanceOf(value, constructor) {
        return value instanceof constructor;
      }
    : function instanceOf(value, constructor) {
        if (value instanceof constructor) {
          return true;
        }

        if (typeof value === 'object' && value !== null) {
          var _value$constructor;

          // Prefer Symbol.toStringTag since it is immune to minification.
          const className = constructor.prototype[Symbol.toStringTag];
          const valueClassName = // We still need to support constructor's name to detect conflicts with older versions of this library.
            Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
              ? value[Symbol.toStringTag]
              : (_value$constructor = value.constructor) === null ||
                _value$constructor === void 0
              ? void 0
              : _value$constructor.name;

          if (className === valueClassName) {
            const stringifiedValue = inspect(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
          }
        }

        return false;
      };

/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
class Source {
  constructor(
    body,
    name = 'GraphQL request',
    locationOffset = {
      line: 1,
      column: 1,
    },
  ) {
    typeof body === 'string' ||
      devAssert(false, `Body must be a string. Received: ${inspect(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 ||
      devAssert(
        false,
        'line in locationOffset is 1-indexed and must be positive.',
      );
    this.locationOffset.column > 0 ||
      devAssert(
        false,
        'column in locationOffset is 1-indexed and must be positive.',
      );
  }

  get [Symbol.toStringTag]() {
    return 'Source';
  }
}
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

function isSource(source) {
  return instanceOf(source, Source);
}

/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  const parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

class Parser {
  constructor(source, options) {
    const sourceObj = isSource(source) ? source : new Source(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
  }
  /**
   * Converts a name lex token into a name parse node.
   */

  parseName() {
    const token = this.expectToken(TokenKind.NAME);
    return this.node(token, {
      kind: Kind.NAME,
      value: token.value,
    });
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */

  parseDocument() {
    return this.node(this._lexer.token, {
      kind: Kind.DOCUMENT,
      definitions: this.many(
        TokenKind.SOF,
        this.parseDefinition,
        TokenKind.EOF,
      ),
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */

  parseDefinition() {
    if (this.peek(TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } // Many definitions begin with a description and require a lookahead.

    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription
      ? this._lexer.lookahead()
      : this._lexer.token;

    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }

      if (hasDescription) {
        throw syntaxError(
          this._lexer.source,
          this._lexer.token.start,
          'Unexpected description, descriptions are supported only on type definitions.',
        );
      }

      switch (keywordToken.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    }

    throw this.unexpected(keywordToken);
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */

  parseOperationDefinition() {
    const start = this._lexer.token;

    if (this.peek(TokenKind.BRACE_L)) {
      return this.node(start, {
        kind: Kind.OPERATION_DEFINITION,
        operation: OperationTypeNode.QUERY,
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
      });
    }

    const operation = this.parseOperationType();
    let name;

    if (this.peek(TokenKind.NAME)) {
      name = this.parseName();
    }

    return this.node(start, {
      kind: Kind.OPERATION_DEFINITION,
      operation,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */

  parseOperationType() {
    const operationToken = this.expectToken(TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return OperationTypeNode.QUERY;

      case 'mutation':
        return OperationTypeNode.MUTATION;

      case 'subscription':
        return OperationTypeNode.SUBSCRIPTION;
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */

  parseVariableDefinitions() {
    return this.optionalMany(
      TokenKind.PAREN_L,
      this.parseVariableDefinition,
      TokenKind.PAREN_R,
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */

  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: Kind.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(TokenKind.EQUALS)
        ? this.parseConstValueLiteral()
        : undefined,
      directives: this.parseConstDirectives(),
    });
  }
  /**
   * Variable : $ Name
   */

  parseVariable() {
    const start = this._lexer.token;
    this.expectToken(TokenKind.DOLLAR);
    return this.node(start, {
      kind: Kind.VARIABLE,
      name: this.parseName(),
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */

  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: Kind.SELECTION_SET,
      selections: this.many(
        TokenKind.BRACE_L,
        this.parseSelection,
        TokenKind.BRACE_R,
      ),
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */

  parseSelection() {
    return this.peek(TokenKind.SPREAD)
      ? this.parseFragment()
      : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */

  parseField() {
    const start = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;

    if (this.expectOptionalToken(TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return this.node(start, {
      kind: Kind.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(TokenKind.BRACE_L)
        ? this.parseSelectionSet()
        : undefined,
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */

  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(TokenKind.PAREN_L, item, TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */

  parseArgument(isConst = false) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return this.node(start, {
      kind: Kind.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst),
    });
  }

  parseConstArgument() {
    return this.parseArgument(true);
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */

  parseFragment() {
    const start = this._lexer.token;
    this.expectToken(TokenKind.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(TokenKind.NAME)) {
      return this.node(start, {
        kind: Kind.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
      });
    }

    return this.node(start, {
      kind: Kind.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */

  parseFragmentDefinition() {
    var _this$_options;

    const start = this._lexer.token;
    this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (
      ((_this$_options = this._options) === null || _this$_options === void 0
        ? void 0
        : _this$_options.allowLegacyFragmentVariables) === true
    ) {
      return this.node(start, {
        kind: Kind.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
      });
    }

    return this.node(start, {
      kind: Kind.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentName : Name but not `on`
   */

  parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseValueLiteral(isConst) {
    const token = this._lexer.token;

    switch (token.kind) {
      case TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case TokenKind.INT:
        this._lexer.advance();

        return this.node(token, {
          kind: Kind.INT,
          value: token.value,
        });

      case TokenKind.FLOAT:
        this._lexer.advance();

        return this.node(token, {
          kind: Kind.FLOAT,
          value: token.value,
        });

      case TokenKind.STRING:
      case TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case TokenKind.NAME:
        this._lexer.advance();

        switch (token.value) {
          case 'true':
            return this.node(token, {
              kind: Kind.BOOLEAN,
              value: true,
            });

          case 'false':
            return this.node(token, {
              kind: Kind.BOOLEAN,
              value: false,
            });

          case 'null':
            return this.node(token, {
              kind: Kind.NULL,
            });

          default:
            return this.node(token, {
              kind: Kind.ENUM,
              value: token.value,
            });
        }

      case TokenKind.DOLLAR:
        if (isConst) {
          this.expectToken(TokenKind.DOLLAR);

          if (this._lexer.token.kind === TokenKind.NAME) {
            const varName = this._lexer.token.value;
            throw syntaxError(
              this._lexer.source,
              token.start,
              `Unexpected variable "$${varName}" in constant value.`,
            );
          } else {
            throw this.unexpected(token);
          }
        }

        return this.parseVariable();

      default:
        throw this.unexpected();
    }
  }

  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }

  parseStringLiteral() {
    const token = this._lexer.token;

    this._lexer.advance();

    return this.node(token, {
      kind: Kind.STRING,
      value: token.value,
      block: token.kind === TokenKind.BLOCK_STRING,
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */

  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);

    return this.node(this._lexer.token, {
      kind: Kind.LIST,
      values: this.any(TokenKind.BRACKET_L, item, TokenKind.BRACKET_R),
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */

  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);

    return this.node(this._lexer.token, {
      kind: Kind.OBJECT,
      fields: this.any(TokenKind.BRACE_L, item, TokenKind.BRACE_R),
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */

  parseObjectField(isConst) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return this.node(start, {
      kind: Kind.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst),
    });
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */

  parseDirectives(isConst) {
    const directives = [];

    while (this.peek(TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }

  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */

  parseDirective(isConst) {
    const start = this._lexer.token;
    this.expectToken(TokenKind.AT);
    return this.node(start, {
      kind: Kind.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
    });
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */

  parseTypeReference() {
    const start = this._lexer.token;
    let type;

    if (this.expectOptionalToken(TokenKind.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(TokenKind.BRACKET_R);
      type = this.node(start, {
        kind: Kind.LIST_TYPE,
        type: innerType,
      });
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(TokenKind.BANG)) {
      return this.node(start, {
        kind: Kind.NON_NULL_TYPE,
        type,
      });
    }

    return type;
  }
  /**
   * NamedType : Name
   */

  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: Kind.NAMED_TYPE,
      name: this.parseName(),
    });
  } // Implements the parsing rules in the Type Definition section.

  peekDescription() {
    return this.peek(TokenKind.STRING) || this.peek(TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */

  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */

  parseSchemaDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(
      TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      TokenKind.BRACE_R,
    );
    return this.node(start, {
      kind: Kind.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes,
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */

  parseOperationTypeDefinition() {
    const start = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(TokenKind.COLON);
    const type = this.parseNamedType();
    return this.node(start, {
      kind: Kind.OPERATION_TYPE_DEFINITION,
      operation,
      type,
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */

  parseScalarTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */

  parseObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: Kind.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */

  parseImplementsInterfaces() {
    return this.expectOptionalKeyword('implements')
      ? this.delimitedMany(TokenKind.AMP, this.parseNamedType)
      : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */

  parseFieldsDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseFieldDefinition,
      TokenKind.BRACE_R,
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */

  parseFieldDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(TokenKind.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives,
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */

  parseArgumentDefs() {
    return this.optionalMany(
      TokenKind.PAREN_L,
      this.parseInputValueDef,
      TokenKind.PAREN_R,
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */

  parseInputValueDef() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    const type = this.parseTypeReference();
    let defaultValue;

    if (this.expectOptionalToken(TokenKind.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }

    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives,
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */

  parseInterfaceTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: Kind.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */

  parseUnionTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start, {
      kind: Kind.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types,
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */

  parseUnionMemberTypes() {
    return this.expectOptionalToken(TokenKind.EQUALS)
      ? this.delimitedMany(TokenKind.PIPE, this.parseNamedType)
      : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */

  parseEnumTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start, {
      kind: Kind.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values,
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */

  parseEnumValuesDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseEnumValueDefinition,
      TokenKind.BRACE_R,
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */

  parseEnumValueDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseEnumValueName() {
    if (
      this._lexer.token.value === 'true' ||
      this._lexer.token.value === 'false' ||
      this._lexer.token.value === 'null'
    ) {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        `${getTokenDesc(
          this._lexer.token,
        )} is reserved and cannot be used for an enum value.`,
      );
    }

    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */

  parseInputObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start, {
      kind: Kind.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */

  parseInputFieldsDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseInputValueDef,
      TokenKind.BRACE_R,
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */

  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */

  parseSchemaExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(
      TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      TokenKind.BRACE_R,
    );

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.SCHEMA_EXTENSION,
      directives,
      operationTypes,
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */

  parseScalarTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.SCALAR_TYPE_EXTENSION,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */

  parseObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */

  parseInterfaceTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */

  parseUnionTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.UNION_TYPE_EXTENSION,
      name,
      directives,
      types,
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */

  parseEnumTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values,
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */

  parseInputObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */

  parseDirectiveDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(TokenKind.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    const locations = this.parseDirectiveLocations();
    return this.node(start, {
      kind: Kind.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations,
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */

  parseDirectiveLocations() {
    return this.delimitedMany(TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */

  parseDirectiveLocation() {
    const start = this._lexer.token;
    const name = this.parseName();

    if (Object.prototype.hasOwnProperty.call(DirectiveLocation, name.value)) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */

  node(startToken, node) {
    var _this$_options2;

    if (
      ((_this$_options2 = this._options) === null || _this$_options2 === void 0
        ? void 0
        : _this$_options2.noLocation) !== true
    ) {
      node.loc = new Location(
        startToken,
        this._lexer.lastToken,
        this._lexer.source,
      );
    }

    return node;
  }
  /**
   * Determines if the next token is of a given kind
   */

  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    throw syntaxError(
      this._lexer.source,
      token.start,
      `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`,
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === TokenKind.NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw syntaxError(
        this._lexer.source,
        token.start,
        `Expected "${value}", found ${getTokenDesc(token)}.`,
      );
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === TokenKind.NAME && token.value === value) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */

  unexpected(atToken) {
    const token =
      atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(
      this._lexer.source,
      token.start,
      `Unexpected ${getTokenDesc(token)}.`,
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */

  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  }
}
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  const value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */

function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}

var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return __assign(__assign({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = parse(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
var gql$1 = gql;

let _$3 = t => t,
    _t$3;
const LinkParts = gql$1(_t$3 || (_t$3 = _$3`
  fragment LinkParts on HeaderLink {
    text
    url
    targetBlank
    showInMobile
    showInDesktop
    svgPath
    external
    preventDefault
  }
`));

let _$2 = t => t,
    _t$2;
const AccountLinkParts = gql$1(_t$2 || (_t$2 = _$2`
  fragment AccountLinkParts on AccountMenuLink {
    title
    description
    url
    targetBlank
    external
    key
    isHidden
    icon
  }
`));

let _$1 = t => t,
    _t$1;
const HeaderQueryDocument = gql$1(_t$1 || (_t$1 = _$1`
  query getHeader($consumer: HeaderConsumer!, $ssr: Boolean) {
    header(consumer: $consumer, ssr: $ssr) {
      headerV2Enabled
      loggedIn
      storeId
      store
      locale
      homeLink {
        ...LinkParts
      }
      links {
        ...LinkParts
      }
      categoryMenu {
        mobileLinks {
          ...LinkParts
        }
        categories {
          id
          permalink
          coverImageUrl
          brands {
            title
            link
            slug
          }
          trending {
            ctaText
            linkTo
          }
          marketingCard {
            header
            image {
              url
            }
            button {
              linkTo
            }
          }
          link {
            ...LinkParts
          }
          children {
            id
            permalink
            link {
              ...LinkParts
            }
          }
        }
        mobileOptionLinks {
          ...LinkParts
        }
        localeOptions {
          value
          label
        }
        storeOptions {
          value
          label
          defaultLocale
        }
        viewAllButtonText
        categoriesButtonText
        logoutButtonText
        signinButtonText
      }
      userBar {
        #V1
        loginButtonText
        signupButtonText
        accountLink {
          ...LinkParts
        }
        dashboardLinks {
          ...LinkParts
        }
        accountMenuLinks {
          ...AccountLinkParts
        }
        #Common
        user {
          id
          firstName
          lastName
          email
          verified
        }
        #V2
        menuLinks {
          ...LinkParts
        }
        dashboardLinksV2 {
          ...LinkParts
        }
        accountMenuLinksV2 {
          ...AccountLinkParts
        }
      }
      topLevelCategoriesTitle
      searchCategoriesShowAllLabel
      brands {
        allBrands {
          title
          slug
          link
          image {
            url
            title
          }
        }
        newBrands {
          title
          slug
          link
          image {
            url
            title
          }
        }
        marketingCard {
          header
          image {
            url
          }
          button {
            linkTo
          }
        }
      }
    }
  }
  ${0}
  ${0}
`), LinkParts, AccountLinkParts);

let _ = t => t,
    _t;
const HeaderSearchQueryDocument = gql$1(_t || (_t = _`
  query getHeaderSearch($consumer: HeaderConsumer!, $q: String!) {
    search(consumer: $consumer, q: $q) {
      sections {
        title
        emptyText
        highlight
        items {
          type
          analyticsTerms {
            name
            value
          }
          imageUrl
          description
          link {
            ...LinkParts
          }
          parentCategoryText
        }
      }
      showAllLink {
        ...LinkParts
      }
    }
  }
  ${0}
`), LinkParts);

const NavBar = /*#__PURE__*/styled.nav.withConfig({
  displayName: "mobile-nav-barstyles__NavBar",
  componentId: "sc-18qatfm-0"
})(["display:flex;flex-wrap:no-wrap;justify-content:space-between;padding:0 25px;position:fixed;bottom:0;z-index:100;width:100vw;height:64px;border-radius:8px 8px 0px 0px;box-shadow:0px 7px 15px rgb(0 0 0 / 13%),0px 0px 3px rgb(0 0 0 / 5%);background-color:", ";"], props => props.theme.colors.Background);

const Link = /*#__PURE__*/styled(Link$2).withConfig({
  displayName: "nav-linkstyles__Link",
  componentId: "elc9gp-0"
})(["width:100px;display:flex;flex-direction:column;justify-content:center;align-items:center;outline:none;-webkit-tap-highlight-color:transparent;opacity:", ";@supports (gap:4px){gap:4px;}"], props => props['data-active'] ? 1 : 0.5);
const Icon = /*#__PURE__*/styled.div.withConfig({
  displayName: "nav-linkstyles__Icon",
  componentId: "elc9gp-1"
})(["width:24px;height:24px;display:flex;justify-content:center;align-items:center;"]);
const Text = /*#__PURE__*/styled.p.withConfig({
  displayName: "nav-linkstyles__Text",
  componentId: "elc9gp-2"
})(["", ";color:", ";font-size:14px;@supports not (gap:4px){padding-top:4px;}"], ({
  theme
}) => theme.typography.SmallHeadline, ({
  theme
}) => theme.colors.Foreground);

const NavLink = ({
  link,
  active,
  onClick,
  onNavigate
}) => {
  return jsxs(Link, Object.assign({
    link: link,
    onClick: onClick,
    onNavigate: onNavigate,
    "data-active": active
  }, {
    children: [link.svgPath ? jsx(Icon, {
      children: jsx(Svg, {
        svgPath: link.svgPath
      })
    }) : null, jsx(Text, {
      children: link.text
    })]
  }));
};

const Line = /*#__PURE__*/styled.div.withConfig({
  displayName: "bottom-sheetstyles__Line",
  componentId: "sc-1r69z1b-0"
})(["margin:auto;margin-top:12px;width:35px;height:4px;border-radius:2px;background-color:", ";"], props => props.theme.colors['Level 1']);

const BottomSheet = ({
  children,
  isOpen: _isOpen = false,
  setIsOpen
}) => {
  const [shouldBeRendered, setShouldBeRendered] = useState(false);
  const theme = useContext(ThemeContext);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setShouldBeRendered(true);
    }
  }, []);

  if (!shouldBeRendered) {
    return null;
  }

  return (// It's needed as the React version in header-ui is v18, when the ui library uses v17
    // and react@18 require to define children prop type, which leads to TS error here
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    jsx(BottomSheet$1, Object.assign({
      title: jsx(Line, {}),
      marginTop: 128,
      bodyStyle: {
        borderRadius: '8px 8px 0 0',
        backgroundColor: theme.colors.Background
      },
      rootStyle: {
        zIndex: '20'
      },
      titleTypography: "TinyParagraph",
      shadowTip: false,
      swipeableViewsProps: {
        containerStyle: {
          borderRadius: '8px 8px 0 0'
        }
      },
      onChange: setIsOpen,
      open: _isOpen,
      overlayStyle: {
        opacity: 0.5
      }
    }, {
      children: children
    }))
  );
};

const AccountMenuSheet = ({
  user,
  accountMenuLinks,
  isOpen,
  setIsOpen,
  unreadMessages,
  contactButtonClassName,
  onSupportClick
}) => {
  var _a, _b;

  const actionProps = useAccountMenuProps({
    accountMenuLinks: accountMenuLinks !== null && accountMenuLinks !== void 0 ? accountMenuLinks : [],
    contactButtonClassName
  });

  if (onSupportClick) {
    actionProps.ContactUs['onClick'] = e => {
      e.preventDefault();
      onSupportClick();
    };
  }

  if (!user || !accountMenuLinks || !(accountMenuLinks === null || accountMenuLinks === void 0 ? void 0 : accountMenuLinks.length)) {
    return null;
  }

  return jsx(BottomSheet, Object.assign({
    isOpen: isOpen,
    setIsOpen: setIsOpen
  }, {
    children: jsx(AccountMenu$1, {
      userName: `${user.firstName} ${user.lastName}`,
      accountEmail: user.email,
      profileButtonText: (_b = (_a = actionProps === null || actionProps === void 0 ? void 0 : actionProps.YourProfile) === null || _a === void 0 ? void 0 : _a['title']) !== null && _b !== void 0 ? _b : '',
      unreadMessages: unreadMessages,
      isAccountVerified: user.verified,
      actionsProps: actionProps
    })
  }));
};

const AccountButton = ({
  user,
  consumer,
  accountLink,
  accountMenuLinks,
  unreadMessages,
  contactButtonClassName,
  onSupportClick
}) => {
  const [isSheetOpen, setIsSheetOpen] = useState(false);
  const openSheet = useCallback(() => {
    setIsSheetOpen(true);
  }, []);
  return jsxs(Fragment$1, {
    children: [jsx(NavLink, {
      link: Object.assign(Object.assign({}, accountLink), {
        external: false,
        targetBlank: false
      }),
      active: consumer === HeaderConsumer.payments,
      onNavigate: openSheet
    }), jsx(AccountMenuSheet, {
      isOpen: isSheetOpen,
      setIsOpen: setIsSheetOpen,
      user: user,
      unreadMessages: unreadMessages,
      accountMenuLinks: accountMenuLinks,
      contactButtonClassName: contactButtonClassName,
      onSupportClick: onSupportClick
    })]
  });
};

const MobileNavBar = ({
  className,
  header,
  unreadMessages,
  contactButtonClassName,
  consumer,
  onNavigate,
  onSupportClick
}) => {
  var _a, _b;

  const {
    loggedIn,
    userBar
  } = header;
  const {
    user,
    accountLink,
    accountMenuLinks,
    dashboardLinks
  } = userBar;

  if (!loggedIn) {
    return null;
  }

  return jsxs(NavBar, Object.assign({
    className: className
  }, {
    children: [(_b = (_a = dashboardLinks === null || dashboardLinks === void 0 ? void 0 : dashboardLinks.filter(link => link.showInMobile)) === null || _a === void 0 ? void 0 : _a.map(link => jsx(NavLink, {
      link: link,
      active: !link.external,
      onNavigate: onNavigate
    }, link.text))) !== null && _b !== void 0 ? _b : null, jsx(AccountButton, {
      user: user,
      consumer: consumer,
      unreadMessages: unreadMessages,
      accountLink: accountLink,
      accountMenuLinks: accountMenuLinks,
      contactButtonClassName: contactButtonClassName,
      onSupportClick: onSupportClick
    })]
  }));
};

const screens = {
  phone: 'min-width: 0px',
  averagePhone: 'min-width: 321px',
  largePhone: 'min-width: 425px',
  tablet: 'min-width: 768px',
  desktop: 'min-width: 1024px',
  desktopMin: 'min-width: 1024px',
  largeDesktop: 'min-width: 1280px',
  wideScreen: 'min-width: 1600px',
  wideDesktop: 'min-width: 1440px',
  extraWideScreen: 'min-width: 1728px',
  extraWideDesktop: 'min-width: 2160px'
};

const lightTheme = Object.assign(Object.assign({
  type: 'light'
}, lightBaseTheme), {
  colors: Object.assign({
    disabled: '#E0E0E0'
  }, lightBaseTheme.colors),
  typography: Object.assign({}, lightBaseTheme.typography),
  screens
});
const darkTheme = Object.assign(Object.assign({
  type: 'dark'
}, darkBaseTheme), {
  colors: Object.assign({
    disabled: '#E0E0E0'
  }, darkBaseTheme.colors),
  typography: Object.assign({}, lightBaseTheme.typography),
  screens
});

const HeaderProvider = ({
  theme: _theme = 'light',
  children
}) => jsx(ThemeProvider, Object.assign({
  theme: _theme === 'dark' ? darkTheme : lightTheme
}, {
  children: children
}));

export { Categories, HeaderProvider, HeaderQueryDocument, HeaderSearchQueryDocument, HeaderUI, Loading, MobileNavBar, Search$1 as Search, darkTheme, lightTheme, screens };
